export default {
  "t-menu": "menú",
  "t-device-trend-chart": "Gráficodetendenciasdedispositivos",
  "t-dashboard": "tablero",
  "t-search": "buscar",
  "t-reset": "restablecer",
  "t-default": "predeterminado",
  "t-system": "sistema",
  "t-system-param": "Parámetrosdelsistema",
  "t-normal": "normal",
  "t-not-supported": "No compatible",
  "t-suspend": "suspender",
  "t-create": "Agregar",
  "t-edit": "editar",
  "t-copy": "copiar",
  "t-export": "Exportar",
  "t-download": "descargar",
  "t-install": "instalar",
  "t-clean": "limpiar",
  "t-enter": "entrada",
  "t-select": "seleccionar",
  "t-selected": "seleccionado",
  "t-next": "Siguientepaso",
  "t-submit": "enviar",
  "t-update": "actualizar",
  "t-cancel": "cancelar",
  "t-cancel-reset": "reiniciar y cancelar",
  "t-name": "nombre",
  "t-alias": "alias",
  "t-value": "valor",
  "t-from": "desde",
  "t-user-name": "nombredeusuario",
  "t-current": "actual",
  "t-new": "nuevo",
  "t-password": "contraseña",
  "t-confirm-password": "Confirmarcontraseña",
  "t-length": "longitud",
  "t-type": "tipo",
  "t-check": "verificar",
  "t-radius": "radio",
  "t-refresh": "actualizar",
  "t-delete": "eliminar",
  "t-deleting": "Eliminando",
  "t-import": "importar",
  "t-confirm": "confirmar",
  "t-confirm-to": "Estásseguro",
  "t-confirm-delete": "¿Estás seguro de que deseas eliminar - {param}",
  "t-confirm-unbind": "¿Estás seguro de que deseas desvincular - {param}",
  "t-confirm-clean-logs": "¿Estásegurodequedeseaeliminarlosregistros?",
  "t-detail": "detalles",
  "t-usage": "uso",
  "t-records": "Detalles",
  "t-location": "ubicación",
  "t-add": "añadir",
  "t-size": "talla",
  "t-website": "sitioweb",
  "t-address": "dirección",
  "t-remark": "observaciones",
  "t-description": "descripción",
  "t-description-max-length": "La descripción no puede exceder los 500 caracteres",
  "t-phone": "teléfono",
  "t-phone-number": "teléfono",
  "t-file": "archivo",
  "t-batch-file": "Archivo por lotes",
  "t-push-decompressed-file": "Extraer archivo automáticamente después de la descarga",
  "t-push-decompressed-file-tip": "Si está habilitado, el archivo descargado se extraerá automáticamente en el dispositivo de destino.",
  "t-icon": "icono",
  "t-status": "estado",
  "t-action": "acción",
  "t-code": "código",
  "t-revoke": "Revocar",
  "t-create-by": "Creador",
  "t-create-time": "Horadecreación",
  "t-first-connect-time": "Primera conexión",
  "t-executed-at": "Tiempodeejecución",
  "t-execution-time": "Tiempodeejecución",
  "t-execute-by": "ejecutor",
  "t-expiration-time": "Tiempodevencimiento",
  "t-modified-by": "Modificadopor",
  "t-modified-time": "Fechademodificación",
  "t-last-update-by": "Últimaactualizaciónpor",
  "t-last-update-time": "Fechadelaúltimaactualización",
  "t-date": "fecha",
  "t-seconds": "segundos",
  "t-minute": "minuto",
  "t-hour": "hora",
  "t-day": "天",
  "t-day-number": "rd",
  "t-month": "mes",
  "t-week": "semana",
  "t-region": "región",
  "t-continent": "Continente",
  "t-basic": "versiónclásica",
  "t-premium": "Versiónpremium",
  "t-switch": "interruptor",
  "t-quantity": "cantidad",
  "t-success": "éxito",
  "t-fail": "fallido",
  "t-pending": "enprogreso",
  "t-reverted": "Revocado",
  "t-revoke-success-tip": "Revocación enviada, verifique la lista de tareas más tarde.",
  "t-yes": "Sí",
  "t-no": "no",
  "t-login": "Iniciarsesión",
  "t-logout": "Salir",
  "t-last-online-time": "Últimavezenlínea",
  "t-last-updated-time": "Últimahoradeactualizacióndedatos",
  "t-back": "regresar",
  "t-duration": "duración",
  "t-click-check": "Hagaclicparacomprobar",
  "t-aborted": "Revocar",
  "t-terminal-supported-functions": "Tipodeterminal",
  "t-format": "formato",
  "t-disable-signature": "Desactivarfirma",
  "t-polygon": "Polígono",
  "t-radius-in-meters": "Radio[50-9999]metros",
  "t-radius-in-hours": "Duración[0-72]horas",
  "t-duration-value-range": "Elrangodeduraciónesde0a72horas",
  "t-radius-value-range": "Elrangoderadioesde50a9999metros",
  "t-loading": "Cargando...",
  "t-image": "imagen",
  "t-video": "audio",
  "t-text": "texto",
  "t-html": "HTML",
  "t-required": "Esuncampoobligatorio",
  "t-remove": "eliminar",
  "t-logo": "logotipo",
  "t-partner-portal-logo": "Logotipodelportaldesocios",
  "t-notfound-result": "¡Losentimos!Noseencontraronresultados",
  "t-set": "conjunto",
  "t-number": "cantidad",
  "t-login-as-partner": "Iniciarsesióncomosocio",
  "t-logout-as-partner": "Cerrarsesióncomosocio",
  "t-abnormal-devices": "Dispositivosanormales",
  "t-abnormal-device-status": "Estadoanormaldeldispositivo",
  "t-last-7-days": "Últimos7días",
  "t-last-14-days": "Últimos14días",
  "t-last-30-days": "Últimos30días",
  "t-last-90-days": "Últimos90días",
  "t-last-365-days": "Últimos365días",
  "t-last-days-number": "Last {param} Days",
  "t-table": "tabla",
  "t-head": "título",
  "t-open": "abierto",
  "t-close": "cerrar",
  "t-notification": "Notificación",
  "t-public": "público",
  "t-welcome-back": "Bienvenidodenuevo",
  "t-sign-in-continue-storm": "ContinúaconSTORMparainiciarsesión",
  "t-remember-me": "recuérdame",
  "t-sign-in": "Iniciarsesión",
  "t-please-wait": "Iniciandosesión",
  "t-storm-introduction-title1": "Sistemadegestióndecontrolremotodeterminalinteligente",
  "t-storm-introduction-title2": "FeitianhadesarrolladolaplataformadegestiónTMSdepróximageneración,laplataforma“STORM“",
  "t-storm-introduction-title3": "Incluyeserviciodeenvíodemensajes,inyecciónremotadeclaves,actualizaciónremotaOTA,gestiónremotadedispositivosterminalesyotrasfunciones",
  "t-login-status-expired": "¡Eltiempodeiniciodesesiónseagotó,porfavoriniciesesiónnuevamente!",
  "t-tooltip-device": "SN,TID,MID,IMEI",
  "t-sn": "SN",
  "t-terminal-management-system": "Sistemadegestióndeterminales",
  "t-device-mgmt": "Administracióndedispositivos",
  "t-uninstall": "desinstalar",
  "t-uninstall-block": "Prohibirladesinstalación",
  "t-device": "dispositivo",
  "t-device-type": "dispositivo tipo",
  "t-ecr-pos": "ECR POS",
  "t-pos": "POS",
  "t-ecr": "ECR",
  "t-serial-number": "Número de serie",
  "t-product-bundle": "Paquete de productos",
  "t-device-detail": "Detalledeldispositivo",
  "t-charts-devices": "Dispositivos",
  "t-charts-push-report": "Enviarregistro",
  "t-bind": "enlazar",
  "t-bind-to": "vinculara",
  "t-unbind": "desvincular",
  "t-device-secret": "Secretodeldispositivo",
  "t-product-key": "Clavedeproducto",
  "t-available": "disponible",
  "t-used": "usado",
  "t-current-version-deleted": "Eliminado",
  "t-available-list": "Dispositivosdisponibles",
  "t-bound-list": "Dispositivosvinculados",
  "t-selected-list": "Dispositivosseleccionados",
  "t-select-device-bind": "Seleccione el dispositivo a vincular",
  "t-batch": "lote",
  "t-upload": "cargar",
  "t-refresh-device": "Actualizardispositivo",
  "t-remote-control": "controlremoto",
  "t-remote-control-auto-pwd": "CR (Autopassword)",
  "t-disable-remote-control": "Deshabilitar RC",
  "t-device-not-partner": "Dispositivonovinculadoaunsocio",
  "t-remote-control-failed": "Fallóelcontrolremoto,canceleprimeroelmododedominiodepantalla",
  "t-health-check-failed-kiosk": "Fallóelcontroldesalud,canceleprimeroelmododedominiodepantalla",
  "t-remote-control-steps": "Eneldispositivodeconexióndecontrolremoto...",
  "t-disable-device": "Desactivardispositivo",
  "t-out-of-fence": "fueradelageovalla",
  "t-active-statistics": "Estadísticasdeactivación",
  "t-online-statistics": "Estadísticasenlínea",
  "t-active": "activar",
  "t-inactive": "inactivo",
  "t-out-of-country": "fueradelpaís",
  "t-under-activation": "paraseractivado",
  "t-online": "enlínea",
  "t-offline": "fueradelínea",
  "t-abnormal": "Anómalo",
  "t-block": "Desmontaje",
  "t-device-disabled": "Dispositivodeshabilitado",
  "t-device-disabled-tamper": "Dispositivodeshabilitado,desmontar",
  "t-device-tamper-no": "Eldispositivoesnormal",
  "t-device-tamper-yes": "Eldispositivofuedesmontado",
  "t-filters": "Consultaavanzada",
  "t-basic-information": "Informaciónbásica",
  "t-installed-application": "Aplicacionesinstaladaseneldispositivo",
  "t-last-factory-settings-time": "Últimavezpararestaurarlaconfiguracióndefábrica",
  "t-timeline": "Enviarregistrodetarea",
  "t-android": "Android",
  "t-build-number": "Versióndelsistema",
  "t-sp-bootloader": "cargadordearranqueSP",
  "t-sma-version-code": "VersiónSMA",
  "t-version-code": "códigodeversión",
  "t-version-type": "tipodeversión",
  "t-upgrade-model": "Modo de actualización",
  "t-sma-status": "EstadodeSMA",
  "t-pubkey-status": "Estadodelaclavepública",
  "t-cortex-scanner": "Escánerdecorteza",
  "t-total": "total",
  "t-cpu-statistics": "EstadísticasdelaCPU",
  "t-ram-statistics": "EstadísticasdeRAM",
  "t-storage-statistics": "Estadísticasdealmacenamiento",
  "t-authorisations": "Autorización",
  "t-kiosk-mode": "Mododominación",
  "t-set-kiosk-mode": "Establecermododedominación",
  "t-cancel-kiosk-mode": "Cancelarmododedominación",
  "t-open-immediately": "Abrir inmediatamente",
  "t-options": "Opciones",
  "t-application-starts-automatically-after-installation": "La aplicación se inicia automáticamente una vez finalizada la instalación.",
  "t-cancel-open-immediately": "Cancelar apertura inmediata",
  "t-screen-resolution": "resolucióndepantalla",
  "t-battery-capacity": "Capacidaddelabatería",
  "t-sim-number": "NúmeroSIM",
  "t-sp-firmware": "firmwareSP",
  "t-cpu": "CPU",
  "t-iccid": "ICCID-(SIM)",
  "t-production-batch": "lotedeproducción",
  "t-category": "categoría",
  "t-sales-batch": "lotedeventas",
  "t-network": "red",
  "t-router-address": "Direccióndelenrutador",
  "t-router-name": "Nombredelenrutador",
  "t-communication-type": "tipodecomunicación",
  "t-signal-strength": "intensidaddelaseñal",
  "t-transmission-speed": "Velocidaddetransmisión",
  "t-wifi": "WIFI",
  "t-mobile": "Móvil",
  "t-wifi-mac-address": "DirecciónMACWIFI",
  "t-push-mgmt": "Gestióndeenvíos",
  "t-rki-mgmt": "Gestióndeclaves",
  "t-partner": "socio",
  "t-parent": "padresocio",
  "t-continent-region-exist": "Losmismosdatosdecontinenteyregiónyaexisten.Borrelosdatosexistentesyagréguelosnuevamente",
  "t-customer": "cliente",
  "t-merchant": "comerciante",
  "t-store": "tienda",
  "t-excel-sample-file": "ArchivodemuestradeExcel",
  "t-import-strip": "tira",
  "t-number-of-successes": "Númerodeéxitos",
  "t-number-of-failed": "Númerodefallos",
  "t-import-failed-file": "Erroralimportarelarchivo(hagaclicparadescargar)",
  "t-device-settings": "Configuracióndeldispositivo",
  "t-manufacturer": "Proveedordeequipos",
  "t-model": "Modelodeequipo",
  "t-model-version": "Versióndelmodelo",
  "t-general": "versióngeneral",
  "t-beta": "Versiónenescaladegrises",
  "t-resolution": "resolución",
  "t-connection-type": "Tipodeconexión",
  "t-message-protocol": "Protocolodemensajes",
  "t-hardware-parameter": "Parámetrosdehardware",
  "t-version": "versión",
  "t-version-list": "númerodeversión",
  "t-json-layout": "formatoJSON",
  "t-general-parameter": "Parámetrosgeneralesdelsistema",
  "t-terminal-profiles": "Archivodeinicializacióndeterminal",
  "t-force-initialization": "Forzarinicialización",
  "t-group": "Grupodedispositivos",
  "t-add-device-to-group": "Agregardispositivoalgrupo",
  "t-upload-file-bind-device": "Cargararchivosydispositivosdevinculación/desvinculaciónporlotes",
  "t-geo-fence": "geo-cerca",
  "t-erase-drawing": "Eliminardibujo",
  "t-log-capture": "Capturaderegistros",
  "t-log": "registro",
  "t-firmware": "firmware",
  "t-firmware-version": "versióndefirmware",
  "t-md5": "MD5",
  "t-application-mgmt": "Gestióndeaplicaciones",
  "t-application": "aplicación",
  "t-application-name": "Nombredelaaplicación",
  "t-application-version": "Versióndelaaplicación",
  "t-application-certificates": "CertificadosdeAplicación",
  "t-api-sign": "Aplicaciones API",
  "t-sign-status-created": "Pendiente",
  "t-sign-status-queued": "En cola",
  "t-sign-status-signing": "Firmando",
  "t-sign-status-completed": "Completada",
  "t-sign-status-failed": "Fallida",
  "t-certificates": "certificados",
  "t-certificate-level": "Niveldecertificado",
  "t-tls-certificates": "CertificadoTLS",
  "t-certificate-version": "Versióndelcertificado",
  "t-certificate-owner": "Propietariodelcertificado",
  "t-certificate-issuer": "Emisordelcertificado",
  "t-certificate-serial-number": "Númerodeseriedelcertificado",
  "t-certificate-effective-date": "Fechadevigenciadelcertificado",
  "t-certificate-expiration-date": "Fechadevencimientodelcertificado",
  "t-certificate": "Certificado",
  "t-certificate-signing-algorithm": "Algoritmodefirmadecertificados",
  "t-subject-dn": "DN del sujeto",
  "t-issuer-dn": "DN del emisor",
  "t-not-before": "No antes de",
  "t-not-after": "No después de",
  "t-batch-upload": "Cargaporlotes",
  "t-friendly-name": "Nombredelcertificado",
  "t-name-common": "nombrecomún",
  "t-country": "país",
  "t-currency": "moneda",
  "t-city": "ciudad",
  "t-org-unit": "Unidadorganizativa",
  "t-org": "organización",
  "t-state-province": "estado/provincia",
  "t-common-name": "Nombre común",
  "t-organization": "Organización",
  "t-organizational-unit-name": "Nombre de unidad organizativa",
  "t-locality": "Localidad",
  "t-key-store-password": "Contraseñadelalmacéndeclaves",
  "t-calendar": "calendario",
  "t-transaction-param": "Parámetrosdetransacción",
  "t-byte": "byte",
  "t-copy-code": "Copiarcódigo",
  "t-offline-data-authentication-was-not-performed": "Noserealizólaautenticacióndedatossinconexión",
  "t-sda-failed": "SDAfalló",
  "t-icc-data-missing": "FaltandatosICC",
  "t-card-appears-on-terminal-exception-file": "Latarjetaapareceenelarchivodeexcepcióndelterminal",
  "t-dda-failed": "DDAfalló",
  "t-cda-failed": "CDAfalló",
  "t-rfu": "RFU",
  "t-icc-and-terminal-have-different-application": "ICCyterminaltienendiferentesversionesdeaplicación",
  "t-expired-application": "Solicitudcaducada",
  "t-application-not-yet-effective": "Lasolicitudaúnnohaentradoenvigor",
  "t-requested-service-not-allowed-for-card-product": "Elserviciosolicitadonoestápermitidoparaproductosdetarjeta",
  "t-new-card": "nuevatarjeta",
  "t-cardholder-verification-was-not-successful": "Laverificacióndeltitulardelatarjetanofueexitosa",
  "t-unrecognised-cvm": "CVMnoreconocido",
  "t-pin-try-limit-exceeded": "SeexcedióellímitedeintentosdePIN",
  "t-pin-entry-required-and-pin-pad-not-present-or-not-working": "SerequierePIN,eltecladoPINnoexisteonofunciona",
  "t-pin-entry-required-pin-pad-present-but-pin-was-not-entered": "SerequiereingresarelPIN,elPINpadexiste,peroelPINnoseingresó",
  "t-online-pin-entered": "SehaingresadoelPINenlínea",
  "t-transaction-exceeds-floor-limit": "Lastransaccionesexcedenellímitemínimo",
  "t-lower-consecutive-offline-limit-exceeded": "Sesuperóellímiteinferiorcontinuosinconexión",
  "t-upper-consecutive-offline-limit-exceeded": "Sesuperóellímitecontinuosinconexión",
  "t-transaction-selected-randomly-for-online-processing": "Seleccionaraleatoriamentetransaccionesparaprocesamientoenlínea",
  "t-merchant-forced-transaction-online": "Elcomerciantefuerzalastransaccionesenlínea",
  "t-package": "paquete",
  "t-package-name": "Nombredelpaquete",
  "server.mam.ft.package.mismatch": "El nombre del paquete no coincide",
  "t-application-token": "Tokendeaplicación",
  "t-client-token": "Tokendecliente",
  "t-intent-name": "Nombredeintención",
  "t-file-name": "nombredearchivo",
  "t-file-size": "Tamaño de archivo",
  "t-silent-upgrade": "Actualización Manual",
  "t-prompt-for-upgrade": "Actualización Automática",
  "t-upgrade-strategy": "estrategiadeactualización",
  "t-upgrade": "actualizar",
  "t-upgrade-strategy-for-supports-sma": "LaestrategiadeactualizaciónsoloadmiteSMA,laversiónSMA100513ysuperioresadmiteestaestrategiadeactualización",
  "t-allow-use-network-download": "Permitirdescargasderedesmóviles",
  "t-selected-range-not-allowed": "Elrangodetiemposeleccionadonopuedeexcederlas18horas",
  "t-terminal-allow-use-network-download-network": "Seleccioneestaopciónyelterminalpermitiráelusoderedesmóvilesparadescargararchivosdefirmware",
  "t-time-period-upgrade-tip": "Elterminalseactualizaráautomáticamentedentrodelperíododetiempoespecificado.Sielterminalcancelaestaactualización,ingresaráalaactualizaciónnuevamenteenelsiguienteperíododetiempo",
  "t-period-of-time": "período",
  "t-start-time-and-end-time-cannot-be-same": "Losintervalosdetiemposeleccionadosnopuedenseriguales",
  "t-push-to-device-group": "Enviaradispositivoogrupo",
  "t-push-login-as-partner": "Iniciesesióncomosociopararealizarestafunción",
  "t-push-to-device": "Enviaraldispositivo",
  "t-push-to-group": "Enviaralgrupo",
  "t-push-report": "Enviarregistro",
  "t-abort-push": "Revocar envío",
  "t-not-start": "noiniciado",
  "t-warning-to-cancel-push": "¿Estássegurodequedeseasrevocarelenvío?",
  "t-scheduler-tasks": "Enviartareasprogramadas",
  "t-planned": "plan",
  "t-message": "Mensaje",
  "t-message-type": "Tipodemensaje",
  "t-push-message": "Elmensajeprogramadohacaducado",
  "t-showing-duration": "Mostrandoduración",
  "t-unlimited": "Ilimitado",
  "t-plan-time": "planificartiempo",
  "t-message-from": "de",
  "t-every": "cada",
  "t-content": "contenido",
  "t-advertisement": "anuncio",
  "t-advertisement-planner": "Plandepublicidad",
  "t-planner": "plan",
  "t-push-advertisement-expired": "Advertisement has expired",
  "t-advertisement-file": "Archivoderecursos",
  "t-loop": "bucle",
  "t-ads-start-date": "Fechayhoradeiniciodelosanuncios",
  "t-ads-end-date": "Fechayhoradefinalizacióndelosanuncios",
  "t-more-detail-url": "URLdemásdetalles",
  "t-detail-url": "URLdetallada",
  "t-folder": "carpeta",
  "t-key-capture": "Generarclavesecreta",
  "t-key": "Clavesecreta",
  "t-index": "índice",
  "t-algorithm": "algoritmo",
  "t-key-type": "Tipodeclave",
  "t-number-keys": "Númerodeclaves",
  "t-key-group": "Grupodeclaves",
  "t-key-value": "Valordeclavesecreta",
  "t-kcv": "KCV",
  "t-clear-key": "Borrarclave",
  "t-encrypted-key-under": "Clavedecifrado",
  "t-key-capture-report": "Registrodegeneracióndeclaves",
  "t-key-injection": "Inyeccióndeclave",
  "t-ksi": "KSI",
  "t-did": "DID",
  "t-counter": "Contador",
  "t-ksn": "KSN",
  "t-ksn-example": "Ejemplo KSN",
  "t-hsm": "HSM",
  "t-hsm-model": "modeloHSM",
  "t-interface": "interfaz",
  "t-primary-host": "Direccióndehost",
  "t-primary-port": "Puertohost",
  "t-secondary-host": "Direccióndehostsecundario",
  "t-secondary-port": "Puertodehostsecundario",
  "t-hsm-enable": "HSM Habilitar",
  "t-lmk-index": "ÍndiceLMK",
  "t-enable": "Sihabilitar",
  "t-key-block": "Bloquedeclavessecretas",
  "t-widgets": "complemento",
  "t-settings": "configuración",
  "t-device-locations": "Ubicacionesdedispositivos",
  "t-role-widget-save-successfully": "Configuración del informe guardada con éxito",
  "t-partner-settings": "Configuracióndesocios",
  "t-mfa": "MFA",
  "t-signature": "FirmaAPK",
  "t-cloud-messaging": "Serviciodemensajeríaenlanube",
  "t-detamper-auth": "Autenticacióndemanipulación",
  "t-enable-signature-error-partner-not-found": "Nosepuedehabilitarlafirmasecundaria,nohaysocioasociado",
  "t-enable-signature-error-2nd-cert-not-found": "Nosepuedehabilitarlafirmasecundaria,noseencontróelcertificadosecundario",
  "t-partner-setting-updated-successfully": "¡Laconfiguracióndesocioseactualizócorrectamente!",
  "t-error-updating-partner-setting": "Seprodujounerroralactualizarlaconfiguracióndelsocio",
  "t-error-loading-partner-setting": "Seprodujounerroralcargarlaconfiguracióndelsocio",
  "t-email-settings": "Configuracióndecorreoelectrónico",
  "t-email": "correoelectrónico",
  "t-email-server": "servidordecorreoelectrónico",
  "t-email-account": "cuentadecorreoelectrónico",
  "t-port": "puerto",
  "t-ssl": "SSL",
  "t-starttls": "INICIOTLS",
  "t-email-sender": "remitentedelcorreoelectrónico",
  "t-sms-settings": "ConfiguracionesdeSMS",
  "t-sms": "Mensajedetexto",
  "t-sms-gateway": "PuertadeenlaceSMS",
  "t-sms-settings-sms": "ProveedordeserviciosSMS",
  "t-sms-settings-signname": "Nombredelafirma",
  "t-access": "IDdeclavedeacceso",
  "t-access-key-id": "IDdeclavedeacceso",
  "t-access-key-secret": "Clavedeaccesosecreta",
  "t-password-policy": "Políticadecontraseñas",
  "t-enable-password-policy": "Habilitarpolíticadecontraseñas",
  "t-enable-password-length-minimum": "Habilitarlongitudmínimadecontraseña",
  "t-password-length": "Elrangodelongituddecontraseñamáscortaes4-32",
  "t-required-item": "Esteartículoesobligatorio",
  "t-password-length-minimum": "Elvalormínimoes4",
  "t-password-length-maximum": "Elvalormáximoes32",
  "t-password-policy-pattern": "Estevalordebeserunnúmeroentero",
  "t-enable-password-part": "Habilitarmétododecomposicióndecontraseña",
  "t-password-numbers-and-letters-combination": "Lacontraseñadebeserunacombinacióndenúmerosyletras",
  "t-password-use-least-one-uppercase-letter": "Usaalmenosunaletramayúscula",
  "t-repeated-characters-not-allowed-to-use": "Estáprohibidoutilizarcaracteresrepetidos",
  "t-allows-use-special-characters": "Permiteelusodecaracteresespeciales(exceptoespacios)",
  "t-use-least-one-special-character": "Usaalmenosuncarácterespecial",
  "t-different-user-name-and-password": "Elnombredeusuarioylacontraseñadebenserdiferentes",
  "t-whether-to-enable-history-password": "Sisedebeprohibirelusodecontraseñashistóricas",
  "t-use-history-password-number": "Nosepermiteutilizarlacantidaddecontraseñashistóricas[elvalores3-6]",
  "t-use-history-password-number-minimum": "Elvalormínimoes3",
  "t-use-history-password-number-maximum": "Elvalormáximoes6",
  "t-enable-password-change-frequency": "Sisedebehabilitarlafrecuenciadecambiodecontraseña",
  "t-password-change-frequency": "Frecuenciadecambiodecontraseña(días/1vez)",
  "t-password-change-frequency-minimum": "Elvalormínimoes1",
  "t-password-change-frequency-maximum": "Elvalormáximoes9",
  "t-change-the-password-regular-basis": "Sisedebecambiarlacontraseñaperiódicamente",
  "t-password-periodically-change": "Cambiarperiódicamentelacontraseñaportiempo(númerodedías)",
  "t-password-periodically-minimum": "Elvalormínimoes90",
  "t-password-periodically-maximum": "Elvalormáximoes365",
  "t-password-configuration-updated-successfully": "Política de contraseña actualizada con éxito!",
  "t-error-updated-password-configuration": "Fallólaactualizacióndelaconfiguracióndelacontraseña",
  "t-times-task": "Configuracióndetareascronometradas",
  "t-execute-once": "Ejecutarunavez",
  "t-task-group": "grupodetareas",
  "t-method": "método",
  "t-log-information": "Informaciónderegistro",
  "t-cron-expression": "Cron-expresión",
  "t-clean-condition": "Borrarcondición",
  "t-concurrent": "concurrencia",
  "t-wrong-strategy": "estrategiaincorrecta",
  "t-allow": "permitir",
  "t-prohibit": "prohibido",
  "t-execute-immediately": "Ejecutarinmediatamente",
  "t-next-execution-time": "Próximahoradeejecución",
  "t-execute": "ejecutar",
  "t-cancel-execution": "Cancelarejecución",
  "t-task-scheduler": "Tareaprogramadadelsistema",
  "t-task-scheduler-logs": "Registrosdeejecucióndetareasprogramadasdelsistema",
  "t-notice": "Configuracióndenotificaciones",
  "t-alarm-settings": "Configuracióndealarmadenotificación",
  "t-alarm": "alarma",
  "t-alarm-mgmt": "Gestión de alarmas",
  "t-already-used": "yausado",
  "t-silence-time": "tiempodesilencio",
  "t-alert-logs": "Registrosdealarmas",
  "t-logs": "registro",
  "t-alert-status-info-untreated": "Sintratar",
  "t-alert-status-info-processed": "Procesado",
  "t-alert-status-info-closed": "Cerrar",
  "t-alert-status-info-handle": "proceso",
  "t-alert-status-info-close": "Cerrar",
  "t-rule": "regla",
  "t-alert-policies": "Políticasdealerta",
  "t-policies": "políticas",
  "t-alert-level": "niveldealarma",
  "t-level": "nivel",
  "t-alerts-cycles": "ciclosdealarma",
  "t-alert-channel": "canaldealarma",
  "t-contacts-group": "Grupodecontactos",
  "t-contacts-user": "Contactos",
  "t-alert-rule": "Regladealerta",
  "t-email-alert-template": "Plantilladealertaporcorreoelectrónico",
  "t-email-template": "Plantilladecorreoelectrónico",
  "t-alert-rule-template": "Plantilladeregla",
  "t-template-title": "Títulodelaplantilla",
  "t-template": "Títulodelaplantilla",
  "t-from-name": "Nombredelremitente",
  "t-email-alert-content": "Contenidodelaplantilladecorreoelectrónico",
  "t-search-alert": "Nombredelanotificacióndebúsqueda",
  "t-alert-notice": "Notificacióndealarma",
  "t-alert-policy": "Políticadealerta",
  "t-policy": "política",
  "t-alert-contacts": "Contactosdealarma",
  "t-alert-start-time": "Horaefectiva",
  "t-alert-mechanism": "mecanismodealarma",
  "t-notice-channels": "Canalesdenotificación",
  "t-channels": "canales",
  "t-first-sequence-notifier": "Primernotificadordesecuencia",
  "t-second-sequence-notifier": "Notificadordesegundasecuencia",
  "t-third-sequence-notifier": "Notificadordetercerasecuencia",
  "t-notification-interval": "Siguienteintervalodenotificación",
  "t-error-sms-not-enable": "NohayningunaconfiguracióndepuertadeenlaceSMShabilitada",
  "t-error-email-not-enable": "Nohayconfiguracióndecorreoelectrónicohabilitada",
  "t-enable-fence-alert": "Habilitaralarmadecerca",
  "t-policy-alert-rule-content": "Reglasdealerta",
  "t-alert-channel-template-configuration": "Configuracióndeplantilladecanaldealarma",
  "t-available-merge-fields": "Camposdecombinacióndisponibles",
  "t-sunday": "Domingo",
  "t-monday": "lunes",
  "t-tuesday": "Martes",
  "t-wednesday": "Miércoles",
  "t-thursday": "jueves",
  "t-friday": "Viernes",
  "t-saturday": "Sábado",
  "t-notifying-user": "Notificandoalusuario",
  "t-notifying-partner": "Socionotificante",
  "t-notifying-customer": "Notificandoalcliente",
  "t-notifying-merchat": "Notificaralcomerciante",
  "t-notifying-text-message": "Mensajedetexto",
  "t-notifying-info": "Informacióndenotificación",
  "t-alert-status": "Estadodenotificación",
  "t-alert-time": "horadealarma",
  "t-ui": "UI",
  "t-wallpaper": "fondodepantalla",
  "t-boot-picture": "Elprimerfotogramadelarranque",
  "t-boot-animation": "Animacióndearranque",
  "t-log-report": "Registrareinformar",
  "t-entity-value": "valordeentidad",
  "t-system-health": "saluddelsistema",
  "t-gateway": "puertadeenlace",
  "t-configuration": "configuración",
  "t-health": "salud",
  "t-audit-logs": "Registrosdeauditoría",
  "t-tickets": "Boletos",
  "t-disconnect": "desconectar",
  "t-received": "recibido",
  "t-unreceived": "Norecibido",
  "t-subject": "asunto",
  "t-user-mgmt": "Gestióndeusuarios",
  "t-user": "usuario",
  "t-authorities": "rol",
  "t-reset-password": "Restablecercontraseña",
  "t-activate-token": "Multi-Factor Authentication",
  "t-replace-token": "Reemplazar el MFA",
  "t-activate-user": "Activarusuario",
  "t-activate": "activar",
  "t-deactivate": "Cerrar",
  "t-reboot": "reiniciar",
  "t-warning-to-reboot": "¿Estássegurodequedeseasreiniciareldispositivo?",
  "t-warning-to-unbind": "¿Estásegurodequedeseadesvincularesteregistro?",
  "t-lock": "bloqueo",
  "t-lock-device": "Bloqueardispositivo",
  "t-warning-to-lock": "¿Estássegurodequequieresbloqueareldispositivo?",
  "t-unlock": "desbloquear",
  "t-warning-to-unlock": "¿Estássegurodequedeseasdesbloqueareldispositivo?",
  "t-factory-settings": "Restaurarlaconfiguracióndefábrica",
  "t-warning-to-reset": "¿Estásegurodequedesearestaurareldispositivoalaconfiguracióndefábrica?Estaoperaciónprovocarálapérdidadedatos.¿Estáseguro?",
  "t-warning-to-shut-down": "¿Estássegurodequedeseasapagareldispositivo?",
  "t-warning-to-disable-geo-tracking": "¿Estásegurodequedeseadesactivarelseguimientogeográfico?",
  "t-shut-down-device": "Apagar",
  "t-enable-geo-tracking": "Habilitarseguimientogeográfico",
  "t-disable-geo-tracking": "Desactivarseguimientogeográfico",
  "t-warning-to-geo-tracking": "Tengaencuentaquehabilitarelseguimientogeográficoprovocaráqueseagotelabatería",
  "t-device-geo-tracking-not-enable": "Elseguimientogeográficonoestáhabilitadoeneldispositivo",
  "t-device-geo-tracking-has-enable": "Eldispositivotieneelseguimientogeográficohabilitado",
  "t-enter-package-name": "Ingreseelnombredelpaquete",
  "t-package-name-already-exists": "Este nombre de paquete ya existe",
  "t-device-sn": "Númerodeseriedeldispositivo",
  "t-device-name": "Nombre del dispositivo",
  "t-device-license-file-does-not-exist": "Elarchivodelicenciadeldispositivonoexiste",
  "t-device-under-activation": "Eldispositivoestáenestadopendienteoinactivo",
  "t-device-is-out-of-range-activation-failed": "Eldispositivoestáfueradealcanceylaactivaciónfalló",
  "t-sync": "sincronización",
  "t-cancel-geo-fencing": "Cancelargeo-cercado",
  "t-warning-to-cancel-geo-fencing": "¿Estássegurodequedeseascancelarlageofencing?",
  "t-device-not-support-pubkey-synchronization": "Eldispositivonoadmitelasincronizacióndeclavepública,verifiqueeldispositivo",
  "t-device-geo-location": "Geolocalizacióndeldispositivo",
  "t-geo-location": "Geolocalización",
  "t-longitude": "longitud",
  "t-latitude": "latitud",
  "t-device-unbind-successful": "Eldispositivosedesvinculóexitosamente",
  "t-device-bind-successful": "Enlacedeldispositivoexitoso",
  "t-wait-pend": "Enprogreso,esperelarespuestadeldispositivo",
  "t-warning-to-activate-kiosk": "¿Estássegurodequedeseashabilitarelmododedominiodepantalla?",
  "t-setting-version-type-general": "Siestaversiónseestableceenlaversióngeneral,lassiguientesaplicacionessemodificaránalaversiónenescaladegrises",
  "t-error-application-not-function": "Laaplicacióndelsistemanopuederealizarestaoperación",
  "t-error-device-no-application": "Estaaplicaciónnoexisteeneldispositivo",
  "t-warning-to-deactivate-kiosk": "¿Estássegurodequedeseasdesactivarelmododedominiodepantalla?",
  "t-device-need-specified-area": "Eldispositivodeberegresaraláreaespecificada",
  "t-device-need-specified-fence": "Estedispositivonecesitadevolverlacercaespecificada",
  "t-recover-key-success": "Enviarlasolicituddeclavedeinicializacióndeldispositivoconéxito",
  "t-error-domineering-state-already": "Yahayotraaplicacióndominandolapantalla",
  "t-app-has-dominated": "Estaaplicaciónhasidodominada.Porfavornoenvíecomandosdedominaciónnuevamente",
  "t-error-app-not-domineering-state": "Laaplicaciónnodominalapantalla",
  "t-error-device-not-app-in-dominant-state": "Eldispositivonotieneunaaplicaciónquedominelapantalla",
  "t-error-current-domineering-state-already": "Laaplicaciónactualyaestáenelestadodepantalladominante",
  "t-warning-to-uninstall": "¿Estássegurodequedeseasdesinstalarlaaplicación",
  "t-warning-to-uninstall-block": "¿Estássegurodequedeseaseliminaraplicacionescuyadesinstalaciónestáprohibida?",
  "t-application-in-kiosk-mode": "Laaplicaciónestáenmododedominación,canceleprimeroelmododedominación",
  "t-uninstall-application": "Desinstalaraplicación",
  "t-device-not-activated": "Eldispositivonoestáactivado",
  "t-device-not-online": "Eldispositivonoestáactivado",
  "t-request-sent-device": "Lasolicitudseenvióexitosamentealdispositivo",
  "t-activate-request-sent": "Solicituddeactivaciónenviadaexitosamentealdispositivo",
  "t-error-updating-device": "Ocurrióunerroralactualizareldispositivo",
  "t-storm-restore-factory-settings": "STORM-Restaurarlaconfiguracióndefábrica",
  "t-device-restore-factory-settings": "Dispositivo-Restaurarlaconfiguracióndefábrica",
  "t-first-name": "nombre",
  "t-last-name": "apellido",
  "t-deactivated": "desactivado",
  "t-activated": "activado",
  "t-role": "rol",
  "t-permissions-name-connot-replace": "Elformatodelnombrenocoincide,elnombrenopuedeserigualaningunode“ROLE_ADMIN“,“ROLE_OPERATOR“,“ROLE_PARTNER“o“ROLE_USER“.",
  "t-auto-generate-password": "Generarcontraseñaautomáticamente",
  "t-deactivate-user": "Desactivarusuario",
  "t-role-permissions": "Permisosderol",
  "t-permissions": "Permisos",
  "t-read": "leer",
  "t-write": "escribir",
  "t-push": "empujar",
  "t-record": "registro",
  "t-tid": "TID",
  "t-mid": "MEDIO",
  "t-imei": "IMEI",
  "t-disable": "Másalládelavalladeláreanacional",
  "t-tamper": "Desmontaje",
  "t-de-tamper": "Desmanipulación",
  "t-report": "informe",
  "t-report-data": "Datos del informe",
  "t-report-settings": "Configuracióndeinformes",
  "t-report-download": "Descargadelinforme",
  "t-sort-digit": "Ordenarnúmeros",
  "t-universal": "universal",
  "t-widget": "control",
  "t-conditions": "condiciones",
  "t-attribute-code": "Códigodeatributo",
  "t-attribute-name": "Nombredelatributo",
  "t-attribute": "Nombredelatributo",
  "t-data-type": "tipodedatos",
  "t-attribute-type": "Tipo de atributo",
  "t-language-type": "tipodeidioma",
  "t-enumerated-value": "valorenumerado",
  "t-enumerated-name": "nombredeenumeración",
  "t-association": "asociación",
  "t-sql": "SQL",
  "t-chart": "Gráficos",
  "t-pie-chart": "gráficocircular",
  "t-bar-chart": "Gráficodebarras",
  "t-line-chart": "Gráficodelíneas",
  "t-time-frame": "intervalodetiempo",
  "t-enumeration": "enumeración",
  "t-string": "cadena",
  "t-internationalization": "internacionalización",
  "t-language": "idioma",
  "t-charts": "gráficos",
  "t-fixed-report": "Informeestático",
  "t-dynamic-report": "Informedinámico",
  "t-reason": "razón",
  "t-numbers-letter": "Compuestoporletrasmayúsculasyminúsculas,númerosyguiones",
  "t-input-invalid-pattern-default": "Consisteennúmeros,letras,subrayados,puntosyespacios.Admitechino,inglés,francés,rusoyespañol.Nopuedecomenzarniterminarconespacios",
  "t-input-invalid-pattern-default-arabic": "Consiste en números, letras, guiones bajos, puntos y espacios. Admite chino, inglés, francés, ruso, español y árabe. No puede comenzar ni terminar con espacios",
  "t-input-invalid-pattern-user-name": "Consta de números, letras, guiones y espacios, admite chino, inglés, francés, ruso y español, y no puede comenzar ni terminar con espacios",
  "t-input-invalid-pattern-phone": "Constadenúmeros,guiones,+yespacios.Nopuedecomenzarniterminarconespaciosniguiones.Losespaciosyguionesnosepuedeningresarcontinuamente.Losnúmerosconcódigosdeáreacomienzancon+o00comienzo",
  "t-input-invalid-pattern-website": "CompuestoenformatoURL",
  "t-input-invalid-pattern-host": "CompuestoenformatodedirecciónIP",
  "t-input-invalid-pattern-email": "Ejemplodeformatodecorreoelectrónico:abc@ftsafe.com",
  "t-input-invalid-pattern-smtp": "CompuestoenformatodenombrededominioSMTP",
  "t-input-invalid-pattern-sn": "Compuestoporletrasmayúsculasyminúsculas,númerosyguiones",
  "t-input-invalid-pattern-imei": "Constadenúmerospuros",
  "t-input-invalid-pattern-device-imei": "IMEIsólopuedeingresarnúmeros",
  "t-input-invalid-pattern-tid": "Compuestoporletrasmayúsculas,minúsculasynúmeros",
  "t-input-invalid-pattern-key": "Compuestoporletrasmayúsculasyminúsculas,puntosynúmeros",
  "t-input-invalid-pattern-key-number": "Compuestoporletrasmayúsculasyminúsculas,puntosynúmeros",
  "t-input-invalid-pattern": "Ingreseunvalorválido.Tengaencuentaqueloscaracteresinicialesyfinalesnopuedenserespacios",
  "t-input-invalid-pattern-password": "Ingreseunvalorválido.Contengaalmenosunnúmerooletra.Tengaencuentaqueloscaracteresinicialyfinalnopuedenserespacios",
  "t-input-invalid-pattern-letters-numbers": "Solo se permiten letras y números.",
  "t-minlength-valid-pattern": "Ellímitemínimodecaractereses",
  "t-maxlength-valid-pattern": "Ellímitemáximodecaractereses",
  "t-file-maximum-size": "Eltamañomáximodearchivoes",
  "t-file-upload-right-spec": "Carguearchivosquecumplanconlosrequisitos",
  "t-model-name": "Nombredelmodelo",
  "t-log-info": "Informaciónderegistro",
  "t-clean-success": "Limpiezaexitosa",
  "t-push-event-id": "IDdeleventopush",
  "t-operation": "operación",
  "t-input-password-mismatch": "Lacontraseñanocoincide",
  "t-generated": "generado",
  "t-entity": "entidad",
  "t-entity-name": "Nombredelaentidad",
  "t-minutes": "minutos",
  "t-hours": "horas",
  "t-app-incremental-upgrade": "Actualizaciónincrementaldelaaplicación",
  "t-restart": "reiniciar",
  "t-shutdown-device": "Apagadodeldispositivo",
  "t-system-parameter": "Parámetrodelsistema",
  "t-start": "inicio",
  "t-end": "fin",
  "t-stop": "parar",
  "t-time": "tiempo",
  "t-geo-fencing": "geofencing",
  "t-initialization": "Inicialización",
  "t-erase": "eliminar",
  "t-initial-key": "Clavedeinicialización",
  "t-geo-tracking": "Seguimientogeográfico",
  "t-automatic": "automático",
  "t-sma-data-synchronization": "SincronizacióndedatosSMA",
  "t-pubkey-synchronization": "Sincronizacióndeclavepública",
  "t-push-select-device-group": "Seleccioneeldispositivoogrupoquedeseaenviar",
  "t-m20-transaction-param": "ParámetrosdetransacciónM20",
  "t-push-status-push-sent": "Pushenviado",
  "t-push-status-push-received": "Pushrecibido",
  "t-push-status-downloading": "Descargando",
  "t-push-status-installing": "Instalando",
  "t-push-status-executing": "Ejecutando",
  "t-push-status-success": "Éxito",
  "t-push-status-fail": "fallido",
  "t-push-status-app-not-signed": "Error,laaplicaciónnoestáfirmada",
  "t-push-status-install-later": "Instalarmástarde",
  "t-push-status-higher-version-exist": "Error,existeunaversiónsuperiordelaaplicación",
  "t-push-status-app-not-installed": "Error,laaplicaciónnoestáinstalada",
  "t-push-status-broadcast-transmitted": "Transmisióntransmitida",
  "t-push-status-increment-file-error": "Error,errordeincrementodelarchivo",
  "t-push-status-file-format-error": "Error,errordeformatodearchivo",
  "t-push-status-download-file-error": "Error,erroraldescargarelarchivo",
  "t-push-status-task-reached-the-maximum": "Error,latareaalcanzóelmáximo",
  "t-push-status-insufficient-electricity": "Error,bateríainsuficiente,inténtalodenuevomástarde",
  "t-push-status-app-patch-updating": "Actualizacióndelparchedelaaplicación",
  "t-push-status-app-patch-update-error": "Error,errordeactualizacióndelparchedelaaplicación",
  "t-push-status-parameter-error": "Error,errordeparámetro",
  "t-push-status-download-completed": "Descargacompletada",
  "t-push-status-same-task-exist": "Error,existelamismatarea",
  "t-push-status-push-uploading": "Subidapush",
  "t-push-status-push-ota-file-mismatch": "Error,elarchivopushOTAnocoincide",
  "t-push-status-start-capture": "Iniciarcaptura",
  "t-push-status-stop": "Detener",
  "t-push-status-key-parameter-error": "Error,errordeparámetroclave",
  "t-push-status-already-activated": "Activado",
  "t-push-status-no-space-left-on-device": "Error,elespaciodealmacenamientodeldispositivoesinsuficiente",
  "t-push-status-initkey-failed": "Laalarmadedesmontajeseborróexitosamente,perolainicializacióndelaclavefalló",
  "t-push-status-erase-tamper-failed": "Error,nosepudoborrarlaalarmadedesmontaje",
  "t-push-status-close-2nd-sig-failed": "Falló,fallóalcerrarlasegundafirma",
  "t-push-status-open-2nd-sig-failed": "Error,nosepudoabrirlasegundafirma",
  "t-push-status-verify-2nd-sig-cert-failed": "Erroralverificarelsegundocertificadodefirma",
  "t-push-status-push-to-pulsar-failed": "Falló,fallóelenvíoaPulsar",
  "t-push-status-push-to-mpush-failed": "Falló,fallóelenvíoaMpush",
  "t-push-status-status-push-sp-server-is-busy": "ElservidorSPestáocupado",
  "t-push-status-reverted": "Revocado",
  "t-push-status-factory-setting-cause-no-log": "Error,larestauracióndelaconfiguracióndefábricanoprovocóningúnregistro",
  "t-push-status-md5-verification-failed": "Falló,laverificaciónMD5falló",
  "t-push-status-device-offline": "Eldispositivoestádesconectado,inténtalodenuevomástarde",
  "t-push-status-mpush-push-to-device-fail": "FallóelenvíodeMpushaldispositivo,inténtelodenuevomástarde",
  "t-push-status-download-completed-wait-for-upgrade": "Descargacompletada,esperandoactualización",
  "t-push-status-push-event-has-been-fetched": "Eleventopushhasidoobtenido",
  "t-push-status-get-push-event-fail": "Error,nosepudoobtenereleventopush",
  "t-push-status-apk-install-failed-invalid": "Error,lainsercióndeAPKnoesválida",
  "t-push-status-apk-install-failed-system-mistake": "Error,errordelsistemaalinstalarAPK",
  "t-push-status-apk-install-failed": "Error,anomalíaenlatarjetaSDoalmacenamientoinsuficientedurantelainstalacióndelAPK",
  "t-push-status-apk-install-failed-certificate-mistake": "Error,errordecertificadoalinstalarAPK",
  "t-push-status-apk-install-failed-other": "Error,nosepudoinstalarelAPK,otrosmotivos",
  "t-push-status-init-key-failed": "Falló,laclavedeinicializaciónfalló",
  "t-push-status-kiosk-mode-in-progress": "Error,eldispositivodominalapantalla",
  "t-push-status-network-issue": "Error,problemadered,inténtalodenuevomástarde",
  "t-push-status-network-failed": "Error,elestadodelareddeldispositivoesanormal",
  "t-push-status-unsupported-action": "Error,eldispositivonoadmiteelservicio",
  "t-push-status-initialization-interupted": "Error,inicializacióninterrumpida",
  "t-push-status-cert-install-failed": "Falló,lainstalacióndelcertificadofalló",
  "t-push-status-apk-install-failed-device-os-version-not-support": "Error,laversióndelsistemaoperativonoadmitelafirmaV2",
  "t-push-status-invalid-apk-file-caused-signature-failure": "Error,errordefirmacausadoporunarchivoAPKnoválido",
  "t-push-status-device-unusual-status-unactive": "Error,eldispositivonoestáactivado",
  "t-push-status-device-unusual-status-geoFence": "Error,eldispositivoexcedelageocerca",
  "t-push-status-device-unusual-status-regionOut": "Error,eldispositivoexcedelabarreradelaregióndelpaís",
  "t-push-status-device-unusual-status-tamper": "Error,eldispositivoestáenestadodedesmontaje",
  "t-push-status-device-unusual-status-regionOut-tamper": "Error,eldispositivoexcedelavalladelaregiónnacionalyestádesmontado",
  "t-push-status-device-unusual-status-region-geoFence": "Error,eldispositivoexcedelavallaylageocercadelaregiónnacional",
  "t-push-status-device-unusual-status-under-activation": "Error,eldispositivoestáenestadodeactivaciónpendiente",
  "t-push-status-app-not-enable-kiosk-mode": "Error,elmododedominaciónnoestáhabilitado",
  "t-push-status-device-region-geoFence-tamper": "Error,eldispositivoexcedelacercadelaregióndelpaís,estáenunestadoanormaldedesmontajeyexcedelageocerca",
  "t-push-status-device-geoFence-tamper": "Error,eldispositivoexcedelageocercayseencuentraenunestadoanormalaldesensamblarlo",
  "t-push-status-push-has-expired-please-try-again": "Latareadeinserciónhacaducado,inténtelodenuevo",
  "t-push-status-public_key_no_mismatch": "Laclavepúblicadeldispositivonocoincide",
  "t-push-status-device-upgrading": "FALLO, LA TAREA NO SE PUDO EJECUTAR PORQUE EL DISPOSITIVO SE ESTÁ ACTUALIZANDO.",
  "t-push-status-sp-unavailable-state": "FALLO, SP EN ESTADO NO DISPONIBLE.",
  "t-data-exception-sync-completed": "Excepcióndedatos,lasincronizaciónsehacompletado",
  "t-data-is-normal-no-need-to-sync": "Losdatossonnormales,noesnecesariosincronizarlos",
  "t-pubkey-uploaded": "Clavepúblicacargada",
  "t-pubkey-exception-sync-completed": "ExcepcióndePubkey,lasincronizaciónsehacompletado",
  "t-system-param-version": "Versióndeparámetrosdelsistema",
  "t-profile": "Perfil",
  "t-profile-details": "Detallesdelperfil",
  "t-wallpaper-file": "Archivodefondodepantalla",
  "t-picture-file": "Elprimerarchivodefotogramaalarrancar",
  "t-animation-file": "Archivodeanimacióndearranque",
  "t-server-mfm-picture-resolution-not-match": "¡Fallólacarga,laresolucióndelaimagenenelpaquetecomprimidonocoincide!",
  "t-server-mfm-picture-format-not-match": "¡Fallólacarga,elformatodeimagenenelpaquetecomprimidonocoincide!",
  "t-server-mfm-boot-animatio-upload-failed": "Lacargafalló.¡Elcontenidodelarchivozipnocumpleconlasreglasdelaimagendeanimacióndearranque!",
  "t-server-mfm-resolution-and-model-version-not-match": "¡Lacargafalló,laresoluciónyelformatodelarchivonocoincidenconlaversióndelmodelo!",
  "t-key-capture-records-status-hsm-error": "ErrordeHSM",
  "t-key-capture-records-status-kcv-value-error": "ErrordevalordeclaveKCV",
  "t-date-range-90-day": "Elrangodefechasseleccionadonopuedeexcederlos90días",
  "t-select-start-end-time": "Debesseleccionarlahoradeinicioylahoradefinalización",
  "t-In Progress": "enprogreso",
  "t-Approved": "Aprobado",
  "t-action-type": "Tipodeacción",
  "t-client": "DirecciónIPdelcliente",
  "t-client-ip": "DirecciónIPdelcliente",
  "t-add.profile.check.application": "AsegúresedequelafirmadelAPKseaexitosa",
  "t-select.identical.application": "Seleccionóunaaplicaciónduplicada",
  "t-log-details": "Descripcióndelobjetodeoperación",
  "t-key-capture-records-status-public-key-not-exist": "Laclavepúblicadeldispositivonoexiste",
  "t-log-capture-not-start": "Lacapturanohacomenzado",
  "t-log-capture-completed": "Capturacompletada",
  "t-log-capture-failed": "Errordecaptura",
  "t-log-capture-capturing": "Capturando",
  "t-plaintext": "textosinformato",
  "t-cipher": "textocifrado",
  "t-bdk-lmk": "BDK/LMK",
  "t-error-match-password": "Doscontraseñassoninconsistentes",
  "t-ui-settings": "Configuracióndelainterfazdeusuario",
  "t-license-mgmt": "Gestióndeautorizaciones",
  "t-license": "Autorización",
  "t-license-settings": "Configuracióndeautorización",
  "t-tamper-authorization-times": "Tiemposdeautorizacióndedesmontaje",
  "t-number-assignable-authorizations": "Númerodeautorizacionestransferibles",
  "t-license-information": "Usuario Autorizado",
  "t-allocate-authorization": "Autorizacióndeasignación",
  "t-add-allocate-authorization": "Agregarautorizacióndeasignación",
  "t-edit-allocate-authorization": "Editarautorizacióndeasignación",
  "t-authorization-times": "Tiemposdeautorización",
  "t-remaining-times": "tiemposrestantes",
  "t-enter-authorization.timetimes": "Ingreselostiemposdeautorización",
  "t-email-use-for-code": "CorreoelectrónicopararecibirelcódigodeverificaciónOTP",
  "t-allocate-authorization-created-successfully": "¡Crearautorizacióndeasignación{param}exitosamente!",
  "t-allocate-authorization-updated.successfullsuccessfully": "¡Actualicelaautorizacióndeasignación{param}exitosamente!",
  "t-allocate-authorization-updated-times-successfully": "¡Actualicelostiemposdeautorizacióndeasignaciónexitosamente!",
  "t-error-allocate-authorization-created": "Seprodujounerroralcrearlaautorizacióndeasignación",
  "t-error-allocate-authorization-updated": "Seprodujounerroralactualizarlaautorizacióndeasignación",
  "t-error-allocate-authorization-updated.timetimes": "Seprodujounerroralactualizarlostiemposdeautorizacióndeasignación",
  "t-correct": "correcto",
  "t-check-kcv-values": "Porfavoringresedosvalores",
  "t-adb-enable": "ADB",
  "t-bluetooth-enable": "Bluetooth",
  "t-mobile-data-enable": "DatosMóviles",
  "t-nfc-enable": "NFC",
  "t-hot-spot-enable": "puntocaliente",
  "t-on": "ENCENDIDO",
  "t-off": "APAGADO",
  "t-no-content-selected": "Ningúncontenidoseleccionado",
  "t-m": "minutos",
  "t-action-list": "Listadeacciones",
  "t-key-capture-records-sn-repeatedly": "SNnosepuedeimportarrepetidamente",
  "t-key-capture-records-sn-empty": "SN no puede estar vacío, el número de serie solo puede introducir letras, números y barras horizontales",
  "t-key-capture-records-key-value-empty": "EL VALOR DE LA CLAVE NO PUEDE ESTAR VACÍO",
  "t-key-capture-records-kcv-empty": "KCVnopuedeestarvacío",
  "t-key-capture-records-device-not-exist": "El dispositivo no se encuentra en las condiciones actuales",
  "t-key-capture-records-sn-not-bound-partner": "SNnoestávinculadoalsocio",
  "t-key-capture-records-device-not-belong-user": "Eldispositivonopertenecealusuarioactual",
  "t-key-capture-records-device-not-activated": "Eldispositivonoestáactivado",
  "t-key-capture-records-key-applied-device-model": "Laclavenosepuedeaplicaraestemodelodedispositivo",
  "t-key-capture-records-failed-verify-countries-currencies": "Erroralverificarlospaísesymonedasrelacionados",
  "t-key-capture-records-tid-format-mismatch": "ElformatoTIDnocoincide",
  "t-key-capture-records-tid-repeated": "TIDseharepetido",
  "t-key-capture-records-tid-not-match-country-region": "LacantidaddeTIDdelpaís/regiónylacantidaddemonedanocoinciden",
  "t-key-capture-records-country-currency-not-empty": "ElpaísylamonedanopuedenestarvacíosporqueelTIDnoestávacío",
  "t-key-capture-records-tid-not-empty": "Elpaís/regiónomonedanoestávacío.TIDnopuedeestarvacío",
  "t-key-capture-records-kcv-keyvalue-mismatch": "ElvalordelaclaveKCVnocoincide",
  "t-expiry-date": "Horadevencimiento",
  "t-papers-available": "Nohayescasezdepapel",
  "t-out-of-papers": "Sin papel o no compatible",
  "t-lack-of-paper": "¿Faltapapel?",
  "t-bind-device-information-details": "Vinculardetallesdeinformacióndeldispositivo",
  "t-unbind-device-information-details": "Desvinculardetallesdeinformacióndeldispositivo",
  "t-device-has-been-bind-partner-file": "Eldispositivohasidovinculadoalarchivoasociado(hagaclicparadescargar)",
  "t-device-bind-confirm-info": "Estedispositivoyaestávinculadoaunsocio.¿Estásegurodequedeseavincularloaunsocio?",
  "t-role-type": "tipoderol",
  "t-user-type": "Tipodeusuario",
  "t-user-source": "fuentedeusuario",
  "t-json": "JSON",
  "t-excel": "Excel",
  "t-release-notes": "Notasdelaversiónde",
  "t-cloud-message": "mensajeenlanube",
  "t-select-duration": "Seleccionarrangodevencimiento",
  "t-onboard-merchants": "ComercianteRegistrado",
  "t-access-key": "Clavedeacceso",
  "t-notifications": "Notificaciones",
  "t-signIn": "Iniciarsesión",
  "t-email-userName": "correoelectrónico/nombredeusuario",
  "t-forgot-password": "Olvidémicontraseña",
  "t-devices": "dispositivos",
  "t-manufacturer-name": "Nombredelfabricante",
  "t-manipulate": "operación",
  "t-firmwares": "firmware",
  "t-applications": "aplicaciones",
  "t-group-management": "Gestióndegrupos",
  "t-key-capture-event-id": "IDdeleventodegeneracióndeclave",
  "t-key-capture-records": "Registrosdegeneracióndeclaves",
  "t-key-capture-records-details": "Detallesdelregistrodegeneracióndeclaves",
  "t-search-key-capture-records-details": "Buscardetallesdelregistro",
  "t-key-capture-records-status-success": "Éxito",
  "t-file-management": "Administracióndearchivos",
  "t-ads-reporter": "Registrodeinsercióndeanuncios",
  "t-push-scheduler": "Enviartareasprogramadas",
  "t-device-import": "Importacióndedispositivos",
  "t-manufacturer-import": "Importacióndelfabricante",
  "t-partner-import": "Importacióndesocios",
  "t-customer-import": "Importacióndeclientes",
  "t-merchant-import": "Importacióndecomerciantes",
  "t-store-import": "importacióndetienda",
  "t-key-import": "Importacióndeclaves",
  "t-device-upstream": "Cargadeldispositivo",
  "t-device-downstream": "Descargadeldispositivo",
  "t-user-management": "Gestióndeusuarios",
  "t-roles-permissions": "Permisosderoles",
  "t-brands": "HSM",
  "t-ui-management": "administracióndelainterfazdeusuario",
  "t-system-params": "Parámetrosdelsistema",
  "t-keys-management": "Gestióndeclaves",
  "t-media": "medios",
  "t-import-mgmt": "Gestióndeimportaciones",
  "t-log-mgmt": "Gestiónderegistros",
  "t-system-mgmt": "Gestióndelsistema",
  "t-add-device": "Agregardispositivo",
  "t-edit-device": "Editardispositivo",
  "t-placeholder-enter-sn": "Ingreseelnúmerodeserie",
  "t-error-enter-sn": "Elnombredelnúmerodeserieesobligatorio",
  "t-error-enter-valid-sn": "Sólosepermitenletrasmayúsculasyminúsculas,númerosyguionesparaelnúmerodeserie",
  "t-error-enter-valid-tid": "TIDsólopermiteingresarletrasmayúsculasyminúsculas,númerosyguiones",
  "t-error-enter-minlength-sn": "Lalongituddelnúmerodeserienopuedeserinferiora2",
  "t-error-enter-minlength-tid": "LalongituddelTIDnopuedeserinferiora2",
  "t-placeholder-enter-imei": "IngresarIMEI",
  "t-update-imei-successfully": "IMEIactualizadoexitosamente",
  "t-error-enter-imei": "SerequiereIMEI",
  "t-error-enter-minlength-imei": "LalongituddelIMEInopuedeserinferiora2",
  "t-error-enter-valid-imei": "IMEIsólopuedeingresarnúmeros",
  "t-error-enter-valid-pusheventid": "SólopuedesingresarnúmerosparaelIDdeleventopush",
  "t-placeholder-enter-tid-name": "IngreseelnombredelTID",
  "t-error-enter-tid-name": "ElnombreTIDesobligatorio",
  "t-error-model-version-required": "Serequierelaversióndelmodelo",
  "t-save-changes": "Guardarcambios",
  "t-saving": "guardar---",
  "t-search-by-model-name": "Buscarpornombredemodelo",
  "t-search-device": "Dispositivodebúsqueda",
  "t-bind-devices": "Vinculardispositivos",
  "t-unbind-devices": "Desvinculardispositivos",
  "t-export-to-excel": "ExportaraExcel",
  "t-select-model-version": "t--versióndelmodelo-",
  "t-search-by-name": "Buscarpornombre",
  "t-all": "todos",
  "t-search-selected-device": "Buscareldispositivoseleccionado",
  "t-search-available-device": "Buscardispositivosdisponibles",
  "t-required-partner": "Serequieresocio",
  "t-enter-manufacturer": "Ingreseelnombredelfabricante",
  "t-loading-dashboard": "Cargandomódulodelpanel---",
  "t-signing-in": "Iniciarsesión---",
  "t-error-manufacturer-required": "Elnombredelfabricanteesobligatorio",
  "t-enter-website": "IngreselaURL",
  "t-error-url-required": "IngreseunaURLválida",
  "t-select-logo": "seleccionarlogotipo",
  "t-add-manufacturer": "Agregarfabricante",
  "t-edit-manufacturer": "editarfabricante",
  "t-error-loading-category": "Seprodujounerroralcargarlacategoría",
  "t-error-loading-group": "Ocurrióunerroralcargarelgrupo",
  "t-error-loading-production-batch": "Ocurrióunerroralcargarellotedeproducción",
  "t-error-loading-sales-batch": "Ocurrióunerroralcargarellotedeventas",
  "t-error-loading-model-version": "Ocurrióunerroralcargarlaversióndelmodelo",
  "t-error-loading": "Erroralcargar",
  "t-timeline-device-title": "Ciclodevidadeldispositivo",
  "t-device-created-successfully": "¡Eldispositivo{sn}fuecreadoexitosamente!",
  "t-error-created-device": "Seprodujounerroralagregareldispositivo",
  "t-device-updated-successfully": "¡Eldispositivo{sn}seactualizóexitosamente!",
  "t-error-updated-device": "Seprodujounerroralactualizareldispositivo",
  "t-package-name-required": "Elnombredelpaqueteesobligatorio",
  "t-submit-kiosk": "Enviar",
  "t-uninstall-app": "Desinstalaraplicación",
  "t-uninstall-application-successfully": "Aplicacióndesinstaladaexitosamente",
  "t-error-occurred": "Ocurrióunerror",
  "t-no-data-avaliable": "Nohaydatosdisponibles",
  "t-no-data": "Nohaydatosdisponibles",
  "t-no-data-selected": "Nohaydatosseleccionados",
  "t-no-firmware-version-in-folder": "No hay versión de firmware disponible en esta carpeta de firmware",
  "t-lat": "Latitud",
  "t-lng": "Longitud",
  "t-device-out-of-region": "Estedispositivoestáfueradelaregión,verifiquelaregióndondeseencuentraeldispositivo",
  "t-technical-details": "Detallestécnicos",
  "t-en": "ES",
  "t-android-version": "VersióndeAndroid",
  "t-base-band-version": "versióndebandabase",
  "t-battery-usage": "Usodelabatería",
  "t-cpu-usage": "UsodeCPU",
  "t-emv-kernel-version": "VersióndelkernelEMV",
  "t-express-pay-kernel-version": "VersióndelkerneldeExpressPay",
  "t-ifm-module-name-version": "Versióndelabibliotecadetarjetasdecontacto",
  "t-jspeedy-kernel-version": "VersióndelkernelJSpeedy",
  "t-bootloader": "Cargadordearranque",
  "t-kernel-version": "versióndelkernel",
  "t-pay-pass-kernel-version": "VersióndelkernelPayPass",
  "t-pay-wave-kernel-version": "VersióndelkernelPayWave",
  "t-pcd-module-name-version": "Versióndelabibliotecadetarjetassincontacto",
  "t-platform-type": "Tipodeplataforma",
  "t-printer-density": "Impresoraenescaladegrises",
  "t-quics-kernel-version": "VersióndelkernelQUICS",
  "t-ram": "memoria",
  "t-ram-usage": "Usodememoria",
  "t-screen-density": "densidaddepantalla",
  "t-android-security-level": "Nivel de seguridad de Android",
  "t-system-type": "Tipo de sistema",
  "t-google-play-system-update": "Actualización del sistema de Google Play",
  "t-storage": "almacenamiento",
  "t-storage-usage": "Usodealmacenamiento",
  "t-cortex-scanner-version": "VersióndelescánerCortex",
  "t-signal-type": "tipodeseñal",
  "t-telecom-operators": "operadores",
  "t-tamper-operation": "Hagadobleclicparaborrarlaoperacióndealarmadedesmontaje",
  "t-network-status": "Estadodelared",
  "t-system-status": "Estadodelsistema",
  "t-gb": "GB)",
  "t-device-activated-successfully": "¡Dispositivoactivadoexitosamente!",
  "t-check-device-status": "Compruebesieldispositivofuncionacorrectamente",
  "t-error-device-updated": "Fallólaactualizacióndelestadodeldispositivo",
  "t-device-status-updated-successfully": "Estadodeldispositivoactualizadoexitosamente",
  "t-clear-tamper": "Primeroborrelaalarmadedesmontaje",
  "t-model-created-successfully": "¡Elmodelo{sn}fuecreadoexitosamente!",
  "t-model-updated-successfully": "¡Modelo{sn}actualizadoexitosamente!",
  "t-model-deleted-successfully": "¡Elmodelo{param}fueeliminadoexitosamente!",
  "t-error-creating-model": "Ocurrióunerroralagregarelmodelo",
  "t-error-loading-model": "Ocurrióunerroralcargarelmodelo",
  "t-error-loading-manufacturers": "Seprodujounerroralcargarlosfabricantes",
  "t-error-loading-manufacturer": "Ocurrióunerroralcargarelfabricante",
  "t-add-model": "Agregarmodelo",
  "t-collapse": "contraer",
  "t-restore": "restaurar",
  "t-no-result-found": "Noseencontróningúnresultado",
  "t-search-model": "modelo",
  "t-search-manufacturer": "fabricante",
  "t-enter-model-name": "Ingreseelnombredelmodelo",
  "t-model-name-required": "Elnombredelmodeloesobligatorio",
  "t-manufacturer-required": "Serequierefabricante",
  "t-model-deleted ": "Modeloeliminadoexitosamente",
  "t-error-deleting-model": "Ocurrióunerroraleliminarelmodelo",
  "t-add-model-version": "Agregarversióndelmodelo",
  "t-edit-model-version": "Editarversióndelmodelo",
  "t-image-upload": "Cargadeimagen",
  "t-please-upload": "Porfavorsubefotos",
  "t-maximum-file-size": "Eltamañodelarchivonodebeexcederlos300KB",
  "t-maximum-file-size-6m": "Eltamañodelarchivonodebeexcederlos6MB",
  "t-please-upload-file-type": "Porfavorsubaarchivostipobin,zip",
  "t-please-upload-certificate-file": "Cargueelarchivodelcertificado",
  "t-please-upload-apk": "Porfavor,subeelarchivoapk",
  "t-please-upload-dat-zip": "Porfavor,subeelarchivodatozip",
  "t-device-binding": "Enlacededispositivo",
  "t-device-unbinding": "Desvinculacióndedispositivo",
  "t-enter-version-name": "Ingreseelnombredelaversión",
  "t-version-name-required": "Elnombredelaversiónesobligatorio",
  "t-year": "año",
  "t-select-year": "Seleccionaraño",
  "t-year-required": "Añorequerido",
  "t-enter-valid-year": "Porfavoringreseunañoválido",
  "t-select-icon": "Seleccionaricono",
  "t-resolution-required": "Serequiereresolución",
  "t-model-required": "Serequieremodelo",
  "t-search-model-version": "Versióndelmodelo",
  "t-delete-model-version-confirmation": "Eliminarconfirmacióndeversióndelmodelo",
  "t-delete-model-version": "¿Estássegurodequedeseaseliminarlaversióndelmodelo-{param}?",
  "t-error-deleting-model-version": "Seprodujounerroraleliminarlaversióndelmodelo",
  "t-select-valid-model": "Porfavorseleccioneunmodeloválido",
  "t-confirm-delete-operation": "Confirmaroperacióndeeliminación",
  "t-warning-to-delete": "¿Estássegurodequedeseaseliminar-{param}?",
  "t-manufacturer-deleted": "¡Elfabricante{param}fueeliminadoexitosamente!",
  "t-model-version-deleted": "¡Laversióndelmodelo{param}seeliminóexitosamente!",
  "t-mfa-configuration": "Configuracióndesocios",
  "t-error-fill-mandatory-fields": "Porfavorcompletetodosloscamposobligatorios",
  "t-processing": "Procesamiento",
  "t-reset-email-sent": "Sehaenviadouncorreoelectrónicopararestablecerlacontraseña",
  "t-delete-model-confirmation": "Eliminarconfirmacióndelmodelo",
  "t-delete-confirmation-model": "¿Estássegurodequedeseaseliminarelmodelo-{param}?",
  "t-device-deleted-successfully": "¡Eldispositivo{param}seeliminóexitosamente!",
  "t-error-deleted-device": "Seprodujounerroraleliminareldispositivo",
  "t-error-loading-devices": "Ocurrióunerroralcargarlosdispositivos",
  "t-no-response-from-device": "Eldispositivonoresponde",
  "t-installed-applications": "Aplicacionesinstaladas",
  "t-add-application": "Agregaraplicación",
  "t-edit-application": "Editaraplicación",
  "t-add-application-version": "Agregarversióndelaaplicación",
  "t-edit-application-version": "Editarversióndelaaplicación",
  "t-application-version-saved-successfully": "¡Laversióndelaaplicación{param}seguardócorrectamente!",
  "t-application-version-updated-successfully": "¡Laversióndelaaplicación{param}seactualizóexitosamente!",
  "t-search-application-version": "Versióndelaaplicación",
  "t-application-device-name": "Nombredelaaplicación",
  "t-version-name": "nombredelaversión",
  "t-select-valid-application": "Porfavorseleccioneunaaplicaciónválida",
  "t-delete-application-version-confirmation": "Confirmacióndeversióndeeliminacióndelaaplicación",
  "t-warning-delete-application-version": "¿Estásegurodequedeseaeliminarlaversióndelaaplicación-{param}?",
  "t-application-version-deleted": "¡Laversióndelaaplicación{param}seeliminóexitosamente!",
  "t-error-deleting-application-version": "Seprodujounerroraleliminarlaversióndelaaplicación",
  "t-error-application-name-required": "Elnombredelaaplicaciónesobligatorio",
  "t-error-application-pattern": "Elnombredelaaplicaciónconstadeletras,números,guionesbajos,puntosyespacios,ynopuedecomenzarniterminarconunespacio",
  "t-placeholder-enter-application-name": "Ingreseelnombredelaaplicación",
  "t-placeholder-enter-application-description": "Ingreseladescripcióndelaaplicación",
  "t-error-loading-application": "Ocurrióunerroralcargarlaaplicación",
  "t-application-created-successfully": "¡Laaplicación{param}secreóexitosamente!",
  "t-error-created-application": "Ocurrióunerroralcrearlaaplicación",
  "t-application-updated-successfully": "¡Laaplicación{param}seactualizóexitosamente!",
  "t-error-updated-application": "Ocurrióunerroralactualizarlaaplicación",
  "t-application-version-file": "Archivodeversióndelaaplicación",
  "t-select-application-file": "Seleccionararchivodeaplicación",
  "t-placeholder-enter-application-version-name": "Ingreseelnombredelaversión",
  "t-error-application-version-required": "Elnombredelaversióndelaaplicaciónesobligatorio",
  "t-error-application-version-pattern": "Elnombredelaversióndelaaplicaciónconstadeletras,números,guionesbajos,puntosyespacios,ynopuedecomenzarniterminarconespacios",
  "t-error-application-required": "Serequieresolicitud",
  "t-error-loading-application-version": "Seprodujounerroralcargarlaversióndelaaplicación",
  "t-error-created-application-version": "Ocurrióunerroralcrearlaversióndelaaplicación",
  "t-error-updated-application-version": "Seprodujounerroralactualizarlaversióndelaaplicación",
  "t-select-certificate": "Seleccionarcertificado",
  "t-select-certificate-to-signed": "Seleccioneelcertificadoautilizar",
  "t-application-deleted-successfully": "¡Laaplicación{param}seeliminóexitosamente!",
  "t-error-deleting-application": "Seprodujounerroraleliminarlaaplicación",
  "t-application-choose-type": "Elijaeltipoparadescargar{param}",
  "t-cannot-submit-repeatedly": "Nosepuedeenviarrepetidamente",
  "t-activate-kiosk": "Activardominacióndepantalla",
  "t-deactivate-kiosk": "Desactivareldominiodelapantalla",
  "t-activate-kiosk-mode": "Habilitarmododedominación",
  "t-deactivate-kiosk-mode": "Desactivarelmododedominiodepantalla",
  "t-actions": "operación",
  "t-device-bulk-upload": "Importaciónmasivadedispositivos",
  "t-manufacturer-bulk-upload": "Fabricantesdeimportaciónmasiva",
  "t-partner-bulk-upload": "Sociosdeimportaciónmasiva",
  "t-customer-bulk-upload": "Clientesdeimportaciónmasiva",
  "t-merchant-bulk-upload": "Comerciantesdeimportaciónmasiva",
  "t-store-bulk-upload": "Tiendadeimportaciónmasiva",
  "t-cortex-scanner-bulk-upload": "ImportaciónporlotesdeCortexScanner",
  "t-import-devices": "Importardispositivos",
  "t-from-date": "fechadeinicio",
  "t-to-date": "fechadefinalización",
  "t-error-from-date-required": "Lafechadeinicioesobligatoria",
  "t-error-to-date-required": "Lafechadefinalizaciónesobligatoria",
  "t-state": "estado",
  "t-delete-device-confirmation": "Confirmacióndeeliminacióndeldispositivo",
  "t-warning-to-delete-device": "¿Estásegurodequedeseaeliminareldispositivo-{param}?",
  "t-warning-to-recover-device": "¿Estásegurodequedeseaborrarlaadvertenciadedesmontajedeldispositivo?",
  "t-confirm-to-lock-device": "¿Estássegurodequedeseasdesbloqueareldispositivo?",
  "t-delete-activated-device": "Nosepuedeeliminarundispositivoactivado",
  "t-cannot-delete-device-has-tid": "NosepuedeeliminarundispositivoconTID",
  "t-delete-device": "Eliminardispositivo",
  "t-add-transaction-param": "Agregarparámetrosdetransacción",
  "t-add-transaction-param-version": "Agregarversióndelparámetrodetransacción",
  "t-search-transaction-param": "Parámetrosdetransacción",
  "t-search-transaction-param-version": "Versióndelparámetrodetransacción",
  "t-transaction-param-version": "Versióndelparámetrodetransacción",
  "t-total-version": "versióntotal",
  "t-add-partner": "Agregarsocio",
  "t-search-push": "Enviarregistros",
  "t-search-partner": "Socio",
  "t-add-customer": "Agregarcliente",
  "t-search-customer": "cliente",
  "t-edit-transaction-param": "Editarparámetrosdetransacción",
  "t-error": "error",
  "t-error-loading-template": "Ocurrióunerroralcargarlaplantilla",
  "t-error-creating-template": "Ocurrióunerroralcrearlaplantilla",
  "t-error-update-template": "Seprodujounerroralactualizarlaplantilla",
  "t-invalid-json": "JSONnoesválido",
  "t-validate": "validar",
  "t-template-updated-successfully": "¡Elparámetrodetransacción{param}seactualizóexitosamente!",
  "t-template-created-successfully": "¡Elparámetrodetransacción{param}fuecreadoexitosamente!",
  "t-enter-transaction-paramName": "Ingreseelnombredelparámetrodetransacción",
  "t-required-transaction-name": "Elnombredelparámetrodetransacciónesobligatorio",
  "t-transaction-name-criteria": "Losnombresdelosparámetrosdetransacciónsolopuedencontenerletras,números,guionesbajos,puntosyespacios,ynopuedencomenzarniterminarconespacios",
  "t-action-code": "códigodeacción",
  "t-required-transaction-action-code": "Elcódigodeaccióndelparámetrodetransacciónesobligatorio",
  "t-min-transaction-action-code": "Elcódigodeoperacióndelparámetrodetransaccióndebesermayorque200",
  "t-max-transaction-action-code": "Elcódigodeoperacióndelparámetrodetransaccióndebesermenorque299",
  "t-pattern-transaction-action-code": "Elcódigodeoperacióndelparámetrodetransacciónsólopuedesernúmeros",
  "t-enter-action-code": "Ingreseelcódigodeacción",
  "t-transaction-deleted-successfully": "¡Elparámetrodetransacción{param}seeliminóexitosamente!",
  "t-error-deleting-transaction": "Seprodujounerroraleliminarlosparámetrosdelatransacción",
  "t-error-deleting-transaction-child": "Hayunaversióndelparámetrodetransaccióndebajodelosparámetrosdetransacción,¡elimineprimerolaversióndelparámetrodetransacción!",
  "t-edit-transaction-param-version": "Editarversióndelparámetrodetransacción",
  "t-enter-transaction-param-version-name": "Ingreseelnombredelaversióndelparámetrodetransacción",
  "t-error-transaction-param-version-required": "Laversióndelparámetrodetransacciónesobligatoria",
  "t-enter-intent-name": "Ingreseelnombredelaintención",
  "t-enter-file-name": "Ingreseelnombredelarchivo",
  "t-error-loading-template-param-version": "Ocurrióunerroralcargarlaversióndelparámetrodetransacción",
  "t-template-version-updated-successfully": "¡Laversióndelparámetrodetransacción{param}seactualizóexitosamente!",
  "t-template-version-created-successfully": "¡Laversióndelparámetrodetransacción{param}fuecreadaexitosamente!",
  "t-error-creating-transaction-param-version": "Ocurrióunerroralcrearlaversióndelparámetrodetransacción",
  "t-error-updating-transaction-param-version": "Ocurrióunerroralactualizarlaversióndelparámetrodetransacción",
  "t-groups": "grupo",
  "t-search-group": "grupo",
  "t-add-group": "Agregargrupo",
  "t-edit-group": "Editargrupo",
  "t-search-group-device": "Buscardispositivosenelgrupo",
  "t-group-name-required": "Elnombredelgrupoesobligatorio",
  "t-group-name-pattern": "Losnombresdelosgrupossólopuedencontenerletras,números,guionesbajos,puntosyespacios,ynopuedencomenzarniterminarconespacios",
  "t-enter-group-name": "Ingreseelnombredelgrupo",
  "t-group-created-successfully": "¡Elgrupo{param}fuecreadoexitosamente!",
  "t-error-group-created": "Ocurrióunerroralcrearelgrupo",
  "t-group-updated-successfully": "¡Grupo{param}actualizadoexitosamente!",
  "t-error-group-updated": "Ocurrióunerroralactualizarelgrupo",
  "t-drag-device-to-group": "Arrastraeldispositivodesdelalistadisponiblealalistaseleccionada",
  "t-to": "a",
  "t-device-update": "Actualizacióndeldispositivo",
  "t-updated-group-device-successfully": "¡Actualiceelgrupo{param}exitosamente!",
  "t-please-enter-name": "Porfavoringresaunnombre",
  "t-minimum-radius": "Elradiomínimodebeser50",
  "t-maximum-radius": "Elradiomáximodebeser9999",
  "t-duration-in-hours": "Duración(horas)",
  "t-please-enter-duration": "Porfavoringresaladuración",
  "t-minimum-duration": "Laduraciónmínimadebeser0",
  "t-maximum-duration": "Laduraciónmáximadebeser72",
  "t-please-enter-action": "Porfavoringresalaacción",
  "t-already-have-lock-action": "Siyahayunaaccióndebloqueo,laduracióndelaaccióndeadvertenciadebesermenorqueladuracióndelbloqueo,yaqueeldispositivodejaráderealizarmásaccionesdespuésdelaaccióndebloqueo",
  "t-add-locak-action-info": "Siagregasunaaccióndebloqueo,laduracióndebesermayorquelaúltimaduración,porquesiseseleccionaunaaccióndebloqueo,eldispositivodejaráderealizarmásaccionesdespuésdeestaacción",
  "t-invalid-warning-message": "Mensajedeadvertencianoválido",
  "t-invalid-action": "Acciónnoválida",
  "t-invalid-duration": "Duraciónnoválida",
  "t-geo-fence-created-successfully": "Lageocerca{param}secreócorrectamente",
  "t-error-geo-fence-created": "Ocurrióunerroralcrearlageocerca",
  "t-geo-fence-updated-successfully": "Geofence{param}actualizadoexitosamente",
  "t-error-geo-fence-updated": "Seprodujounerroralactualizarlageocerca",
  "t-category-name": "Nombredecategoría",
  "t-model-version-name": "Nombredelaversióndelmodelo",
  "t-production-batch-name": "Nombredellotedeproducción",
  "t-sales-batch-name": "Nombredellotedeventas",
  "t-select-valid-transaction-param": "Porfavorseleccioneunparámetrodetransacciónválido",
  "t-delete-transaction-param-version-confirmation": "Eliminarconfirmacióndeversióndelparámetrodetransacción",
  "t-warning-delete-transaction-param-version": "¿Estásegurodequedeseaeliminarlaversióndelparámetrodetransacción-{param}?",
  "t-transaction-param-version-deleted-successfully": "¡Laversióndelparámetrodetransacción{param}seeliminóexitosamente!",
  "t-error-deleting-transaction-param-version": "Seprodujounerroraleliminarlaversióndelparámetrodetransacción",
  "t-please-check-values": "Porfavoringresadosvalores",
  "t-check-value": "verificarvalor",
  "t-error-check-value": "Ocurrióunerroralverificarelvalor",
  "t-error-combine-keys": "Seprodujounerroralfusionarclaves",
  "t-error-invalid-key-check": "ElvalorKCVesincorrecto",
  "t-error-loading-checking-key": "Ocurrióunerroralcargarlaclavedeverificación",
  "t-form-invalid-fill-mandatory": "Elformularionoesválido,completeloscamposobligatorios",
  "t-create-key": "Crearclave",
  "t-error-creating-key": "Ocurrióunerroralcrearlaclave",
  "t-key-created-successfully": "¡Laclave{param}fuecreadaexitosamente!",
  "t-error-key-created": "Ocurrióunerroralcrearlaclave",
  "t-add-key": "Agregarclave",
  "t-edit-key": "Editarclave",
  "t-error-loading-created": "Ocurrióunerroralcargarlaclave",
  "t-error-loading-algorithms": "Ocurrióunerroralcargarelalgoritmo",
  "t-error-loading-partner": "Seprodujounerroralcargarsocios",
  "t-error-loading-keys": "Ocurrióunerroralcargarlasclaves",
  "t-key-deleted-successfully": "¡Laclave{param}fueeliminadaexitosamente!",
  "t-error-deleting-key": "Seprodujounerroraleliminarlaclave",
  "t-key-name-criteria": "Losnombresdelasclavessolopuedencontenerletras,númerosyguionesbajos,ynopuedencomenzarniterminarconespacios",
  "t-delete-key-confirmation": "Eliminarclave",
  "t-warning-delete-key": "¿Estásegurodequedeseaeliminarlaclave-{param}?",
  "t-zeros-not-allowed": "cerosnopermitidos",
  "t-enter-key-name": "Ingreseelnombredelaclave",
  "t-required-key-name": "Elnombredelaclaveesobligatorio",
  "t-enter-index": "Ingresaríndice",
  "t-required-index": "Elíndiceesobligatorio",
  "t-only-allowed-positive-integer-index": "Sólosepermitennúmerosenterospositivos",
  "t-index-max": "Elvalordelíndicenopuedeexceder255",
  "t-select-date": "Seleccionarfecha",
  "t-select-customer": "Seleccionarcliente",
  "t-select-merchant": "Seleccioneuncomerciante",
  "t-select-store": "Seleccionartienda",
  "t-enter-key-group": "Ingresargrupodeclaves",
  "t-required-key-group": "Serequieregrupodeclaves",
  "t-required-encrypted-key-under": "Laclavedecifradoesrequerida",
  "t-enter-key-value": "Ingreseelvalordelaclave",
  "t-required-key-value-1": "Elvalorclave1esobligatorio",
  "t-key-kcv": "KCV",
  "t-key-bdk-lmk": "BDK/LMK",
  "t-key-zmk-lmk": "ZMK/LMK",
  "t-key-lmk": "ClaveLMK",
  "t-required-key-kcv-1": "SerequiereKCV1",
  "t-expiry-date-greater-than-current-date": "Lafechadevencimientodebesermayorquelafechaactual",
  "t-error-loading-key": "Seprodujounerroralcargarlaclave",
  "t-partners": "Socios",
  "t-keys": "teclas",
  "t-key-name": "Nombredeclave",
  "t-is-required": "Campoobligatorio",
  "t-enter-kcv": "IngresarKCV",
  "t-final-key": "clavefinal",
  "t-full-apk": "Paquetecompleto",
  "t-patch-file": "Paquetedediferencia",
  "t-application-certificate-message": "Mostrarunalistadedispositivossegúnelcertificadodeaprobacióndelcliente",
  "t-error-patch-file-fail": "ErroralgenerarelpaquetedediferenciaAPK",
  "t-create-patch-file-success": "ElpaquetediferencialAPKsegeneraexitosamenteyseinicialainserción.Vayaalinformedeinserciónparaobtenerelestadodetallado",
  "t-create-patch-file": "Comenzaragenerarpaquetesdiferenciales",
  "t-required-type": "Eltipoesobligatorio",
  "t-required-version": "Elnúmerodeversiónesobligatorio",
  "t-list-group": "Listadegrupos",
  "t-list-device": "Listadedispositivos",
  "t-list": "list",
  "t-search-by-serial-number": "Buscardispositivospornúmerodeserie",
  "t-sort": "Ordenar",
  "t-sort-asc": "Ascendente",
  "t-sort-desc": "Descendente",
  "t-sort-devices": "Ordenardispositivos",
  "t-uploading": "Subiendo",
  "t-please-select-group-devices": "Porfavorseleccioneungrupoodispositivo",
  "t-error-push-group-empty": "¡Elgruposeleccionadonocontienedispositivos!",
  "t-error-push-group-empty-by-model-version": "¡Elgruposeleccionadonocontienedispositivosconlaversióndelmodelo{param}!",
  "t-error-push-group-store-empty": "¡Eldispositivoenelgruposeleccionadonotieneunalmacénvinculado!",
  "t-error-key-formation": "Errordeformatodeclave",
  "t-key-generation": "Generarclave",
  "t-error-push-operation": "Algunosdispositivospuedentenerproblemasdurantelasoperacionesdeinserción",
  "t-error-push-device-inactive": "Erroralenviar,haydispositivosinactivoseneldispositivoseleccionado",
  "t-error-push-device-abnormal": "Fallólainserción,hayundispositivoanormaleneldispositivoseleccionado",
  "t-push-completed-successfully": "Enviar{param}exitosamente",
  "t-push-batch-completed-successfully": "Elmensaje{param}seenvióexitosamente,vayaalregistrodeenvíoparaobtenermásdetalles",
  "t-push-device-certificate-unpush": "{param}hasidoeliminadodelsocioyyanoseráenviado",
  "t-went-wrong": "Ocurrióunerror",
  "t-add-folder": "Agregarcarpeta",
  "t-edit-folder": "Editarcarpeta",
  "t-required-file-name": "Elnombredelarchivoesobligatorio",
  "t-file-name-pattern": "Losnombresdearchivossóloadmitenletras,números,guionesbajosyguiones",
  "t-select-file-type": "Seleccionartipodearchivo",
  "t-select-file": "Seleccionararchivo",
  "t-maximum-folder-file-size": "Eltamañodelarchivonodebeexcederlos100MB",
  "t-error-loading-folder": "Ocurrióunerroralcargarlacarpeta",
  "t-error-creating-folder": "Ocurrióunerroralcrearlacarpeta",
  "t-error-updating-folder": "Seprodujounerroralactualizarlacarpeta",
  "t-folder-created-successfully": "¡Lacarpeta{param}secreóexitosamente!",
  "t-folder-updated-successfully": "¡Carpeta{param}actualizadaexitosamente!",
  "t-folder-deleted-successfully": "¡Lacarpeta{param}seeliminóexitosamente!",
  "t-required-folder-name": "Elnombredelacarpetaesobligatorio",
  "t-folder-name-pattern": "Losnombresdecarpetassóloadmitenletras,números,guionesbajosyguiones",
  "t-select-partner": "Seleccioneunsocio",
  "t-warning-delete-folder": "¿Estásegurodequedeseaeliminar{param}?",
  "t-enter-folder-name": "Ingreseelnombredelacarpeta",
  "t-error-deleting-file": "Seprodujounerroraleliminarelarchivo",
  "t-file-deleted-successfully": "¡Elarchivo{param}fueeliminadoexitosamente!",
  "t-select-folder": "Porfavorseleccioneunacarpetaválida",
  "t-error-select-file": "Seleccioneunaimagenquecoincidaconunodelosformatos{param}",
  "t-error-select-file-video": "Seleccioneunvideoquecoincidaconunodelosformatos{param}",
  "t-file-created-successfully": "Elarchivo{param}fuecreadoexitosamente",
  "t-create-file": "Agregararchivo",
  "t-create-folder": "Agregarcarpeta",
  "t-file-creation-failed": "Erroralcrearelarchivo",
  "t-file-updated-successfully": "Archivoactualizadoexitosamente",
  "t-file-updated-failed": "Seprodujounerroralactualizarelarchivo",
  "t-warning-delete-file": "¿Estásegurodequedeseaeliminarelarchivo-{param}?",
  "t-add-file": "Agregararchivo",
  "t-edit-file": "Editararchivo",
  "t-search-file": "archivo",
  "t-search-advertisement": "anuncio",
  "t-preview": "vistaprevia",
  "t-file-uploaded-failed": "Errorenlacargadelarchivo",
  "t-file-uploaded-successfully": "Archivocargadoexitosamente",
  "t-select-role": "Seleccionarrol",
  "t-add-role": "Agregarrol",
  "t-edit-role": "Editarrol",
  "t-delete-role": "Eliminarrol",
  "t-delete-role-successfully": "¡Elrol-{param}seeliminóexitosamente!",
  "t-widget-settings": "Configuracióndelcomplemento",
  "t-enter-role-name": "Ingreseelnombredelrol",
  "t-required-role-name": "Elnombredelrolesobligatorio",
  "t-role-name-criteria": "Losnombresderolessolopuedencontenerletras,números,guionesbajos,puntosyespacios,ynopuedencomenzarniterminarconespacios",
  "t-role-created-successfully": "¡Elrol{param}fuecreadoexitosamente!",
  "t-error-creating-role": "Ocurrióunerroralcrearelrol",
  "t-role-updated-successfully": "¡Elrol{param}seactualizóexitosamente!",
  "t-error-updating-role": "Ocurrióunerroralactualizarelrol",
  "t-permissions-updated-successfully": "Permisosactualizadosexitosamente",
  "t-permissions-error-updated": "Ocurrióunerroralactualizarlospermisos",
  "t-permissions-updated-error": "Ocurrióunerroralactualizarlospermisos",
  "t-permission": "permiso",
  "t-browser-local-time": "horalocaldelnavegador",
  "t-panel-name": "Nombredelpanel",
  "t-add-system-param": "Agregarparámetrosdelsistema",
  "t-edit-system-param": "Editarparámetrosdelsistema",
  "t-search-system-param": "Parámetrosdelsistemadebúsqueda",
  "t-enter-system-param-name": "Ingreseelnombredelparámetrodelsistema",
  "t-required-system-param": "Elnombredelparámetrodelsistemaesobligatorio",
  "t-error-loading-system-param": "Ocurrióunerroralcargarlosparámetrosdelsistema",
  "t-system-param-created-successfully": "¡Elparámetrodelsistema{param}fuecreadoexitosamente!",
  "t-error-creating-system-param": "Ocurrióunerroralcrearlosparámetrosdelsistema",
  "t-system-param-updated-successfully": "¡Elparámetrodelsistema{param}seactualizóexitosamente!",
  "t-error-updating-system-param": "Ocurrióunerroralactualizarlosparámetrosdelsistema",
  "t-system-param-deleted-successfully": "¡Elparámetrodelsistema{param}seeliminóexitosamente!",
  "t-error-deleting-system-param": "Seprodujounerroraleliminarlosparámetrosdelsistema",
  "t-enter-system-param-version-name": "Ingreseelnombredelaversióndelparámetrodelsistema",
  "t-required-system-param-verion": "Laversióndelosparámetrosdelsistemaesobligatoria",
  "t-system-param-name-criteria": "Elnombredelaversióndelparámetrodelsistemasólopuedecontenerletras,números,guionesbajos,puntosyespacios,ynopuedecomenzarniterminarconunespacio",
  "t-add-system-param-version": "Agregarversióndeparámetrosdelsistema",
  "t-edit-system-param-version": "Editarversióndeparámetrosdelsistema",
  "t-error-loading-system-param-version": "Erroralcargarlaversióndeparámetrosdelsistema",
  "t-system-param-version-created-successfully": "¡Laversióndelparámetrodelsistema{param}secreóexitosamente!",
  "t-error-creating-system-param-version": "Ocurrióunerroralcrearlaversióndelosparámetrosdelsistema",
  "t-search-system-param-version": "Versióndeparámetrosdelsistemadebúsqueda",
  "t-select-valid-system-param-version": "Seleccioneunparámetrodesistemaválido",
  "t-delete-system-param-version-confirmation": "Eliminarconfirmacióndeversióndeparámetrosdelsistema",
  "t-warning-delete-system-param-version": "¿Estásegurodequedeseaeliminarlaversióndelparámetrodelsistema-{param}?",
  "t-system-param-version-deleted-successfully": "¡Laversióndelparámetrodelsistema{param}seeliminóexitosamente!",
  "t-error-deleting-system-param-version": "Seprodujounerroraleliminarlaversióndelosparámetrosdelsistema",
  "t-add-ui-settings": "AgregarconfiguracióndeUI",
  "t-edit-ui-settings": "Editarconfiguracióndelainterfazdeusuario",
  "t-error-loading-ui-settings": "Seprodujounerroralcargarlaconfiguracióndelainterfazdeusuario",
  "t-error-creating-ui-settings": "Seprodujounerroralcrearlaconfiguracióndelainterfazdeusuario",
  "t-error-updating-ui-settings": "Seprodujounerroralactualizarlaconfiguracióndelainterfazdeusuario",
  "t-ui-settings-created": "¡LaconfiguracióndeUI{param}secreócorrectamente!",
  "t-ui-settings-updated": "¡LaconfiguracióndeUI{param}seactualizócorrectamente!",
  "t-enter-ui-settings-name": "Ingreseelnombredelaconfiguracióndelainterfazdeusuario",
  "t-required-ui-settings": "ElnombredelaconfiguracióndelaUIesobligatorio",
  "t-error-description-pattern": "Ladescripciónsólopuedecontenerletras,números,guionesbajos,puntosyespacios,ynopuedecomenzarniterminarconunespacio",
  "t-enter-ui-settings-description": "Ingreseladescripcióndelaconfiguracióndelainterfazdeusuario",
  "t-required-ui-settings-action": "SerequiereaccióndeconfiguracióndeUI",
  "t-file-type": "Tipodearchivo",
  "t-search-ui-settings": "Configuracióndelainterfazdeusuariodebúsqueda",
  "t-error-deleting-ui-settings": "Seprodujounerroraleliminarlaconfiguracióndelainterfazdeusuario",
  "t-ui-settings-deleted-successfully": "¡LaconfiguracióndeUI{param}seeliminócorrectamente!",
  "t-no-preview-available-zip": "NosepuedeobtenerunavistapreviadelosarchivosZIP",
  "t-no-preview-available-file": "Lavistapreviadeesteformatodearchivonoescompatible",
  "t-no-preview-available-video": "Nosepuedeobtenerunavistapreviadelosarchivosdevídeo",
  "t-browser-not-support-video-tags": "Sunavegadornoadmiteetiquetasdevídeo",
  "t-preview-ui-settings": "Vistapreviadelaconfiguracióndelainterfazdeusuario",
  "t-download-failed": "Errorenladescarga",
  "t-add-ui-settings-version": "AgregarversióndeconfiguracióndeUI",
  "t-pushable": "empujable",
  "t-ui-settings-version": "VersióndeconfiguracióndeUI",
  "t-please-select-valid-setting": "Seleccioneunaconfiguraciónválida",
  "t-warning-delete-ui-setting-version": "¿EstásegurodequedeseaeliminarlaversióndeconfiguracióndeUI-{param}?",
  "t-confirmation-delete-ui-settings-version": "ConfirmacióndeversióndeconfiguracióndeeliminacióndeUI",
  "t-ui-settings-version-deleted-successfully": "¡LaversióndeconfiguracióndeUI{param}seeliminóexitosamente!",
  "t-error-deleting-ui-settings-version": "SeprodujounerroraleliminarlaversióndeconfiguracióndelaUI",
  "t-enter-description": "Ingresedescripción",
  "t-required-ui-setting": "SerequierenconfiguracionesdeUI",
  "t-ui-setting-version-file": "archivodeversióndeconfiguracióndeUI",
  "t-select-setting-file": "Seleccionararchivodeconfiguración",
  "t-ui-setting-version": "VersióndeconfiguracióndeUI",
  "t-add-ui-setting-version": "AgregarversióndeconfiguracióndeUI",
  "t-edit-ui-setting-version": "EditarversióndeconfiguracióndeUI",
  "t-file-resolution-does-not-match": "Laresolucióndelarchivonocoincideconlaresolucióndelmodelo",
  "t-file-type-does-not-match": "Por favor, suba el archivo correcto",
  "t-file-read-failed": "Falló la lectura del archivo, por favor vuelva a subirlo",
  "t-ui-setting-version-file-type": "Cargueelarchivo{param}",
  "t-error-loading-setting-version": "Seprodujounerroralcargarlaversióndeconfiguracióndelainterfazdeusuario",
  "t-ui-setting-version-saved-successfully": "¡LaversióndeconfiguracióndeUI{param}seguardóexitosamente!",
  "t-ui-setting-version-updated-successfully": "¡LaversióndeconfiguracióndeUI{param}seactualizóexitosamente!",
  "t-error-creating-ui-settings-version": "Seprodujounerroralcrearlaversióndeconfiguracióndelainterfazdeusuario",
  "t-error-updating-ui-settings-version": "SeprodujounerroralactualizarlaversióndelaconfiguracióndelaUI",
  "t-delete-brand": "EliminarconfiguracióndeHSM",
  "t-brand": "ConfiguracióndeHSM",
  "t-search-brand": "BuscarconfiguracióndeHSM",
  "t-add-brand": "AgregarconfiguracióndeHSM",
  "t-edit-brand": "EditarconfiguracióndeHSM",
  "t-warning-delete-model": "¿Estásegurodequedeseaeliminarelmodelo-{param}?",
  "t-error-loading-brands": "SeprodujounerroralcargarlaconfiguracióndeHSM",
  "t-brand-created-successfully": "¡HSM{param}creadoexitosamente!",
  "t-error-creating-brand": "SeprodujounerroralcrearlaconfiguracióndeHSM",
  "t-brand-updated-successfully": "¡HSM{param}actualizadoexitosamente!",
  "t-error-updating-brand": "SeprodujounerroralactualizarlaconfiguracióndeHSM",
  "t-brand-deleted-successfully": "¡HSM{param}eliminadoexitosamente!",
  "t-error-deleting-brand": "SeprodujounerroraleliminarlaconfiguracióndeHSM",
  "t-enter-brand-name": "IngreseelnombredelaconfiguracióndeHSM",
  "t-required-brand-name": "SerequiereelnombredeconfiguracióndeHSM",
  "t-edit-model": "Editarmodelo",
  "t-error-updating-model": "Ocurrióunerroralactualizarelmodelo",
  "t-spec-url": "URLdeespecificación",
  "t-enter-spec-url": "IngreselaURLdeespecificación",
  "t-required-spec-url": "IngreseunaURLdeespecificaciónválida",
  "t-hsm-brand": "MarcaHsm",
  "t-add-interface": "Agregarinterfaz",
  "t-edit-interface": "Editarinterfaz",
  "t-error-loading-interfaces": "Ocurrióunerroralcargarlasinterfaces",
  "t-interface-created-successfully": "¡Lainterfaz{param}fuecreadaexitosamente!",
  "t-error-creating-interface": "Ocurrióunerroralcrearlainterfaz",
  "t-interface-updated-successfully": "¡Lainterfaz{param}seactualizóexitosamente!",
  "t-error-updating-interface": "Seprodujounerroralactualizarlainterfaz",
  "t-search-interface": "Interfazdebúsqueda",
  "t-enter-interface-name": "Ingreseelnombredelainterfaz",
  "t-required-interface-name": "Elnombredelainterfazesobligatorio",
  "t-enter-user-name": "Ingreseelnombredeusuario",
  "t-required-user-name": "Ingreseunnombredeusuarioválido",
  "t-required-password": "Ingreseunacontraseñaválida",
  "t-enter-primary-host": "Ingreseladireccióndelhost",
  "t-required-primary-host": "Ingreseunadireccióndehostválida",
  "t-enter-primary-port": "Ingreseelpuertodelhost",
  "t-required-primary-port": "Ingreseunnúmerodepuertodehostválido",
  "t-enter-secondary-host": "Ingreseladireccióndelhostsecundario",
  "t-required-secondary-host": "Ingreseunadireccióndehostsecundariaválida",
  "t-enter-secondary-port": "Ingresarpuertosecundario",
  "t-required-secondary-port": "Ingreseunnúmerodepuertodehostsecundarioválido",
  "t-is-enable": "Sihabilitar",
  "t-select-valid-interface": "Porfavorseleccioneunainterfazválida",
  "t-delete-interface-confirmation": "Confirmacióndeeliminacióndeinterfaz",
  "t-warning-delete-interface": "¿Estásegurodequedeseaeliminarlainterfaz-{param}?",
  "t-delete-interface": "Eliminarinterfaz",
  "t-interface-deleted-successfully": "¡Lainterfaz{param}seeliminóexitosamente!",
  "t-error-deleting-interface": "Seprodujounerroraleliminarlainterfaz",
  "t-partner-name": "Nombredelsocio",
  "t-enable-2FA": "HabilitarOTP",
  "t-enable-signature": "Habilitarfirma",
  "t-enable-remote-control": "Controlremoto",
  "t-partner-setting": "Configuracióndesocios",
  "t-search-user": "usuario",
  "t-add-user": "Agregarusuario",
  "t-edit-user": "Editarusuario",
  "t-error-creating-user": "Ocurrióunerroralcrearelusuario",
  "t-user-created-successfully": "¡Elusuario{param}fuecreadoexitosamente!",
  "t-error-updating-user": "Ocurrióunerroralactualizarelusuario",
  "t-required-email": "Elcorreoelectrónicoesobligatorio",
  "t-enter-correct-email": "Ingreseelformatodecorreoelectrónicocorrecto",
  "t-enter-email": "Ingresecorreoelectrónico",
  "t-enter-first-name": "Ingreseelnombre",
  "t-required-first-name": "Elnombreesobligatorio",
  "t-enter-last-name": "Ingreseelapellido",
  "t-current-password": "Contraseñaactual",
  "t-new-password": "Nuevacontraseña",
  "t-please-fill-all-mandatory-fields": "Porfavor,completetodosloscamposobligatorios",
  "t-user-password-changed-successfully": "Lacontraseñadeusuariosecambiócorrectamente,¡iniciesesiónnuevamente!",
  "t-error-changing-user-password": "Lacontraseñaactualesincorrectaoocurrióunerroralcambiarlacontraseñadelusuario",
  "t-user-profile": "Perfildeusuario",
  "t-user-avatar-modified-successfully": "¡Elavatardeusuariosemodificóexitosamente!",
  "t-user-avatar-modified-failed": "¡Fallólamodificacióndelavatardelusuario!",
  "t-user-avatar-deletion-successfully": "¡Elavatardelusuarioseeliminóexitosamente!",
  "t-user-avatar-deletion-failed": "¡Fallólaeliminacióndelavatardelusuario!",
  "t-user-avatar-not-exist": "¡Elavatardelusuarionoexiste!",
  "t-user-avatar-select-failed": "¡Seleccioneelavatardelusuario!",
  "t-roles": "roles",
  "t-error-length-password": "Lalongituddelacontraseñaesalmenos",
  "t-error-minimum-length-password": "Lacontraseñadebeteneralmenos6caracteres",
  "t-error-maximum-length-password": "Lalongituddelacontraseñanopuedeexcederlos32caracteres",
  "t-error-password-criteria": "Elformatodelacontraseñadebeserunacombinacióndenúmerosyletras",
  "t-enter-confirm-password": "Ingreselacontraseñadeconfirmación",
  "t-warning-reset-password": "¿Estássegurodequedeseasrestablecertucontraseña?",
  "t-sent-reset-password": "Перезагрузка пароля электронной почты отправлена успешно.",
  "t-resend-token-email": "EnviarcódigoQRdeactivación",
  "t-resend-email-successfully": "¡Elusuarioenvióelcorreoelectrónicoexitosamente!",
  "t-error-resend-email": "¡Elusuarionopudoenviarelcorreoelectrónico!",
  "t-delete-user": "Eliminarusuario",
  "t-cannot-delete-activated-user": "Nosepuedeeliminarelusuarioactivado",
  "t-user-deactivated-successfully": "Usuariodesactivado",
  "t-user-permission-update-successfully": "Permisodeusuarioactualizadoconéxito",
  "t-user-activated-successfully": "Usuarioactivadoexitosamente",
  "t-reset-password-sent-successfully": "Elcorreoelectrónicoderestablecimientodecontraseñaseenviócorrectamente",
  "t-user-activated-token-successfully": "¡Elusuarioactivóeltokenmóvilexitosamente!",
  "t-user-updated-successfully": "¡Elusuario{param}seactualizóexitosamente!",
  "t-warning-delete-user": "¿Estássegurodequedeseaseliminarelusuario-{param1}{param2}?",
  "t-delete-user-confirmation": "Eliminarconfirmacióndeusuario",
  "t-token-replaced-successfully": "¡Elusuarioreemplazóeltokendelteléfonomóvilexitosamente!",
  "t-error-token-replace": "¡Elusuarionopudoreemplazareltokendelteléfonomóvil!",
  "t-error-token-activation": "¡Elusuarionopudoactivareltokenmóvil!",
  "t-group-deleted-successfully": "¡Eliminargrupo{param}exitosamente!",
  "t-error-deleting-group": "Ocurrióunerroraleliminarelgrupo",
  "t-delete-partner": "Eliminarsocio",
  "t-partner-deleted-successfully": "¡Elsocio{param}fueeliminadoexitosamente!",
  "t-error-deleted-partner": "Seprodujounerroraleliminarelsocio",
  "t-edit-partner": "Sociodeedición",
  "t-error-loading-partners": "Ocurrióunerroralcargarsocios",
  "t-partner-created-successfully": "¡Elsocio{param}fuecreadoexitosamente!",
  "t-error-created-partner": "Ocurrióunerroralcrearelsocio",
  "t-partner-updated-successfully": "¡Elsocio{param}seactualizóexitosamente!",
  "t-error-updated-partner": "Seprodujounerroralactualizarelsocio",
  "t-required-continent-name": "Elnombredelcontinenteesobligatorio",
  "t-required-region-name": "Elnombredelaregiónesobligatorio",
  "t-required-country-name": "Elnombredelpaísesobligatorio",
  "t-select-continent": "Seleccionarcontinente",
  "t-select-region": "Seleccionarregión",
  "t-error-loading-countries": "Seprodujounerroralcargarlospaíses",
  "t-enter-partner-name": "Ingreseelnombredelsocio",
  "t-required-partner-name": "Elnombredelsocioesobligatorio",
  "t-partner-name-criteria": "Elnombredelsociosolopuedecontenerletras,números,guionesbajos,puntosyespacios,ynopuedecomenzarniterminarconespacios",
  "t-enter-phone-no": "Ingreseelnúmerodeteléfono",
  "t-required-valid-phone-no": "Ingreseunnúmerodeteléfonoválido",
  "t-enter-email-address": "Ingreseladireccióndecorreoelectrónico",
  "t-required-valid-email-address": "Ingreseunadireccióndecorreoelectrónicoválida",
  "t-enter-address": "Ingresedirección",
  "t-error-enter-valid-address": "Sólosepermitenletrasmayúsculasyminúsculas,númerosyguionesparaladirección",
  "t-required-parent-partner": "Porfavoringreseelsociopadre",
  "t-edit-customer": "Editarcliente",
  "t-enter-customer-name": "Ingreseelnombredelcliente",
  "t-required-customer-name": "Elnombredelclienteesobligatorio",
  "t-required-customer": "Serequierecliente",
  "t-customer-name-criteria": "Elnombredelclientesólopuedecontenerletras,números,guionesbajos,puntosyespacios,ynopuedecomenzarniterminarconespacios",
  "t-error-loading-customers": "Ocurrióunerroralcargarclientes",
  "t-customer-created-successfully": "¡Elcliente{param}fuecreadoexitosamente!",
  "t-error-created-customer": "Ocurrióunerroralcrearelcliente",
  "t-customer-updated-successfully": "¡Cliente{param}actualizadoexitosamente!",
  "t-error-updated-customer": "Seprodujounerroralactualizarelcliente",
  "t-warning-delete-customer": "¿Estásegurodequedeseaeliminarelcliente-{param}?",
  "t-warning-delete-merchant": "¿Estásegurodequedeseaeliminaralcomerciante-{param}?",
  "t-warning-delete-store": "¿Estássegurodequedeseaseliminarlatienda-{param}?",
  "t-delete-customer": "Eliminarcliente",
  "t-customer-deleted-successfully": "¡Elcliente{param}fueeliminadoexitosamente!",
  "t-error-deleted-customer": "Ocurrióunerroraleliminaralcliente",
  "t-add-merchant": "Agregarcomerciante",
  "t-edit-merchant": "EditarComerciante",
  "t-enter-mid": "IngresarMID",
  "t-error-loading-merchant": "Seprodujounerroralcargarelcomerciante",
  "t-merchant-created-successfully": "¡Elcomerciante{param}fuecreadoexitosamente!",
  "t-error-created-merchant": "Ocurrióunerroralcrearelcomerciante",
  "t-merchant-updated-successfully": "¡Comerciante{param}actualizadoexitosamente!",
  "t-error-updated-merchant": "Seprodujounerroralactualizarelcomerciante",
  "t-enter-merchant-name": "Ingreseelnombredelcomerciante",
  "t-required-merchant-name": "Elnombredelcomercianteesobligatorio",
  "t-required-merchant": "Serequierecomerciante",
  "t-merchant-name-criteria": "Elnombredelcomerciantesólopuedecontenerletras,números,guionesbajos,puntosyespacios,ynopuedecomenzarniterminarconespacios",
  "t-merchant-deleted-successfully": "¡Elcomerciante{param}fueeliminadoexitosamente!",
  "t-error-deleted-merchant": "Seprodujounerroraleliminarelcomerciante",
  "t-delete-merchant": "Eliminarcomerciante",
  "t-search-merchant": "Comerciante",
  "t-merchant-name": "Nombredelcomerciante",
  "t-error-loading-store": "Ocurrióunerroralcargarlatienda",
  "t-store-created-successfully": "¡Latienda{param}secreóexitosamente!",
  "t-error-created-store": "Ocurrióunerroralcrearlatienda",
  "t-store-updated-successfully": "¡Almacenar{param}actualizadoexitosamente!",
  "t-error-updated-store": "Seprodujounerroralactualizarlatienda",
  "t-enter-store-name": "Ingreseelnombredelatienda",
  "t-required-valid-customer": "Porfavorseleccioneunclienteválido",
  "t-required-valid-merchant": "Porfavorseleccioneuncomercianteválido",
  "t-required-store-name": "Elnombredelatiendaesobligatorio",
  "t-store-name-criteria": "Elnombredelatiendasólopuedecontenerletras,números,guionesbajos,puntosyespacios,ynopuedeempezarniterminarconespacios",
  "t-search-store": "tienda",
  "t-add-store": "Agregartienda",
  "t-edit-store": "Editartienda",
  "t-required-valid-store": "Porfavorseleccioneunatiendaválida",
  "t-delete-store": "Eliminartienda",
  "t-store-deleted-successfully": "¡Latienda{param}seeliminóexitosamente!",
  "t-deleting-store": "Eliminandotienda",
  "t-error-store-deleted": "Seprodujounerroraleliminarlatienda",
  "t-manufacturer-created-successfully": "¡Elfabricante{param}fuecreadoexitosamente!",
  "t-error-manufacturer-created": "Ocurrióunerroralcrearelfabricante",
  "t-manufacturer-updated-successfully": "¡Fabricante{param}actualizadoexitosamente!",
  "t-error-manufacturer-updated": "Ocurrióunerroralactualizarelfabricante",
  "t-manufacturer-deleted-successfully": "¡Elfabricante{param}fueeliminadoexitosamente!",
  "t-error-manufacturer-deleted": "Seprodujounerroraleliminarelfabricante",
  "t-error-model-pattern": "Elnombredelmodelodebeconstardeletras,números,guionesbajos,puntosyespacios,ynopuedecomenzarniterminarconespacios",
  "t-error-model-version-pattern": "Elnombredelaversióndelmodelodebeconstardeletras,números,guionesbajos,puntosyespacios,ynopuedecomenzarniterminarconespacios",
  "t-error-format-required": "Serequiereformato",
  "t-model-version-created-successfully": "¡Laversióndelmodelo{param}fuecreadaexitosamente!",
  "t-model-version-updated-successfully": "¡Laversióndelmodelo{param}seactualizóexitosamente!",
  "t-error-creating-model-version": "Ocurrióunerroralcrearlaversióndelmodelo",
  "t-error-updated-model-version": "Ocurrióunerroralactualizarlaversióndelmodelo",
  "t-error-deleted-model": "Ocurrióunerroraleliminarelmodelo",
  "t-error-deleted-model-version": "Seprodujounerroraleliminarlaversióndelmodelo",
  "t-error-deleting-transaction-param": "Seprodujounerroraleliminarlosparámetrosdelatransacción",
  "t-transaction-param-deleted-successfully": "¡Elparámetrodetransacción{param}seeliminóexitosamente!",
  "t-required-valid-group": "Porfavorseleccioneungrupoválido",
  "t-firmware-deleted-successfully": "¡Elfirmware{param}seeliminóexitosamente!",
  "t-error-deleting-firmware": "Seprodujounerroraleliminarelfirmware",
  "t-required-valid-firmware": "Seleccionefirmwareválido",
  "t-firmware-version-deleted-successfully": "¡Laversióndefirmware{param}seeliminóexitosamente!",
  "t-error-deleting-firmwareversion": "Seprodujounerroraleliminarelfirmware",
  "t-download-firmware": "Descargarfirmware",
  "t-add-firmware-version": "Agregarversióndefirmware",
  "t-edit-firmware-version": "Editarversióndefirmware",
  "t-firmware-name": "nombredelfirmware",
  "t-search-firmware": "firmware",
  "t-add-firmware": "Agregarfirmware",
  "t-edit-firmware": "Editarfirmware",
  "t-enter-firmware-name": "Ingreseelnombredelfirmware",
  "t-required-firmware-name": "Elnombredelfirmwareesobligatorio",
  "t-firmware-name-criteria": "Elnombredelfirmwaredebeconsistirenletras,números,guionesbajos,puntosyespacios,ynopuedecomenzarniterminarconespacios",
  "t-error-loading-firmware": "Seprodujounerroralcargarelfirmware",
  "t-firmware-created-successfully": "¡Elfirmware{param}secreóexitosamente!",
  "t-error-creating-firmware": "Seprodujounerroralcrearelfirmware",
  "t-firmware-updated-successfully": "¡Firmware{param}actualizadoexitosamente!",
  "t-error-updating-firmware": "Seprodujounerroralactualizarelfirmware",
  "t-firmware-file": "archivodefirmware",
  "t-select-firmware-file": "Seleccionararchivodefirmware",
  "t-firmware-version-name": "Nombredelaversióndelfirmware",
  "t-required-version-name": "Elnombredelaversiónesobligatorio",
  "t-required-firmware": "Serequierefirmware",
  "t-error-firmware-version-pattern": "Elnombredelaversióndelfirmwaredebeconsistirenletras,números,guionesbajos,puntos,guionesyespacios,ynopuedecomenzarniterminarconespacios",
  "t-error-loading-firmware-version": "Ocurrióunerroralcargarlaversióndelfirmware",
  "t-firmware-version-created-successfully": "¡Laversióndefirmware{param}secreóexitosamente!",
  "t-error-creating-firmware-version": "Seprodujounerroralcrearlaversióndelfirmware",
  "t-firmware-version-updated-successfully": "¡Laversióndefirmware{param}seactualizóexitosamente!",
  "t-error-updating-firmware-version": "Seprodujounerroralactualizarlaversióndelfirmware",
  "t-manufacturer-consists": "Elnombredelfabricantedebeconstardeletras,números,guionesbajos,puntosyespacios,ynopuedecomenzarniterminarconespacios",
  "t-ui-settings-consists": "LosnombresdelasconfiguracionesdelaUIdebenconsistirenletras,números,guionesbajos,puntosyespacios,ynopuedencomenzarniterminarconespacios",
  "t-log-capture-title-types": "Tiposderegistro",
  "t-log-capture-title-logs": "Registros",
  "t-log-capture-title-main": "Registroprincipal",
  "t-log-capture-title-kernel": "Registrodelkernel",
  "t-btn-stop": "Detener",
  "t-btn-capture": "Capturar",
  "t-log-type": "Tipoderegistro",
  "t-log-type-main": "Registroprincipal",
  "t-log-type-kernel": "Registrodelkernel",
  "t-create-log-capture-event": "¡Latareadecapturaderegistrosecreóexitosamente!",
  "t-search-logs": "registros",
  "t-error-creating-log-capture": "Ocurrióunerroralcapturarelregistro",
  "t-log-capture-process": "Capturandoregistros",
  "t-stop-log-capture-event": "¡Detenerlacapturaderegistros!",
  "t-error-stop-log-capture-event": "¡Ocurrióunerroraldetenerlacapturaderegistros!",
  "t-stop-log-capture-info": "¡Latareadecapturaderegistrosestácompleta!",
  "t-error-enter-log-capture": "¡Compruebesisehacompletadoelnúmerodeseriedeldispositivooeltipoderegistro!",
  "t-time-limit": "Límitedetiempo",
  "t-download-log": "Descargarregistro",
  "t-file-download-failed": "¡Fallóladescargadelarchivo!",
  "t-error-log-forbidden": "Lacapturadelregistroaúnnosehacompletado,¡espere!",
  "t-error-deleting-log-file": "¡Ocurrióunerroraleliminarelarchivoderegistro!",
  "t-error-show-detail-log": "¡Ocurrióunerroralverinformacióndetallada!",
  "t-delete-log-file": "¡Elarchivoderegistro{param}seeliminóexitosamente!",
  "t-detail-log-title": "Archivoderegistro:{param}{fecha}",
  "t-add-log-capture-event": "Agregareventodecapturaderegistro",
  "t-ap": "AP",
  "t-sp": "SP",
  "t-apFirmware": "AP",
  "t-spFirmware": "SP",
  "t-general-all": "todo",
  "t-to-include": "incluir",
  "t-otp-password": "contraseñaOTP",
  "t-select-entity": "Seleccionarentidad",
  "t-other-settings": "Otrasconfiguraciones",
  "t-metadata": "metadatos",
  "t-available-servers": "Servidoresdisponibles",
  "t-service": "servicio",
  "t-url": "URL",
  "t-download-progress": "Descargaencurso",
  "t-send": "enviar",
  "t-enter-email-instructions-to-tou": "¡Ingresesucorreoelectrónicoyseleenviaránlasinstrucciones!",
  "t-search-message": "Mensaje",
  "t-enter-message": "Ingresarmensaje",
  "t-send-message": "Enviarmensaje",
  "t-message-mgmt": "Gestióndemensajes",
  "t-required-duration": "Laduraciónesobligatoria",
  "t-required-message": "Elmensajeesobligatorio",
  "t-message-sent": "Mensajeenviadoexitosamente",
  "t-ad-planner": "planpublicitario",
  "t-add-ad-planner": "Agregarplandeanuncios",
  "t-search-ad-planner": "planpublicitario",
  "t-enter-planner-name": "Ingreseelnombredelplandepublicidad",
  "t-required-planner-name": "Elnombredelplandepublicidadesobligatorio",
  "t-add-advertisement": "Agregaranuncio",
  "t-edit-advertisement": "Editaranuncio",
  "t-error-end-time-greater-than-start": "Lahoradefinalizacióndebesermayorquelahoradeinicio",
  "t-advertisement-updated-successfully": "¡Anuncio{param}actualizadoexitosamente!",
  "t-error-updating-advertisement": "Ocurrióunerroralactualizarlapublicidad",
  "t-advertisement-created-successfully": "¡Elanuncio{param}secreócorrectamente!",
  "t-error-creating-advertisement": "Ocurrióunerroralcrearelanuncio",
  "t-error-loading-advertisement": "Ocurrióunerroralcargarelanuncio",
  "t-add-planner": "Agregarplandepublicidad",
  "t-edit-planner": "Editarplanpublicitario",
  "t-select-planner": "Seleccioneunplandepublicidadválido",
  "t-error-loading-planner": "Ocurrióunerroralcargarelplanpublicitario",
  "t-planner-created-successfully": "¡Elplanpublicitario{param}secreóexitosamente!",
  "t-error-created-planner": "Ocurrióunerroralcrearelplanpublicitario",
  "t-planner-updated-successfully": "¡Elplandepublicidad{param}seactualizóexitosamente!",
  "t-error-updated-planner": "Ocurrióunerroralactualizarelplanpublicitario",
  "t-delete-advertisement": "Eliminaranuncio",
  "t-advertisement-deleted-successfully": "¡Elanuncio{param}seeliminóexitosamente!",
  "t-error-deleting-advertisement": "Seprodujounerroraleliminarelanuncio",
  "t-advertisement-expired": "Elanunciohacaducado",
  "t-advertisement-end-time": "Lahoradefinalizacióndebesermayorquelahoraactual",
  "t-planner-deleted-successfully": "¡Elplanpublicitario{param}seeliminóexitosamente!",
  "t-error-deleting-planner": "Seprodujounerroraleliminarelplanpublicitario",
  "t-warning-delete-advertisement": "¿Estásegurodequedeseaeliminarelanuncio-{param}?",
  "t-warning-delete-planner": "¿Estásegurodequedeseaeliminarelplandepublicidad-{param}?",
  "t-select-ads-start-date": "Seleccionalafechadeiniciodelosanuncios",
  "t-select-ads-end-date": "Seleccionarfechadefinalizacióndeanuncios",
  "t-ads-name": "Nombredelanuncio",
  "t-ads-name-required": "Elnombredelanuncioesobligatorio",
  "t-enter-ad-name": "Ingreseelnombredelanuncio",
  "t-ads-start-required": "Lafechadeiniciodelosanunciosesobligatoria",
  "t-ads-end-required": "Lafechadefinalizacióndelanuncioesobligatoria",
  "t-enter-detail-url": "IngreselaURLdetallada",
  "t-detail-url-required": "LaURLdetalladaesobligatoria",
  "t-start-date": "Fechayhoradeinicio",
  "t-end-date": "Fechayhoradefinalización",
  "t-message-name-required": "Elnombredelmensajeesobligatorio",
  "t-required-message-type": "Eltipodemensajeesobligatorio",
  "t-message-content-required": "Elcontenidodelmensajeesobligatorio",
  "t-placeholder-message-text": "Escribeelmensajedetextoaquí---",
  "t-select-execute-date": "Seleccionarfechadeejecución",
  "t-select-expired-date": "Seleccionefechadevencimiento",
  "t-select-executed-date": "Seleccionarfechadeejecución",
  "t-expiration-time-greater-than-execution-time": "Eltiempodevencimientodebesermayorqueeltiempodeejecución",
  "t-execution-time-less-than-current-time": "Eltiempodeejecucióndebesermayorqueeltiempoactual",
  "t-expiration-time-less-than-current-time": " Tiempo de expiración debe ser mayor que el tiempo actual",
  "t-message-created-successfully": "¡Elmensaje{param}fuecreadoexitosamente!",
  "t-error-creating-message": "Ocurrióunerroralcrearelmensaje",
  "t-message-updated-successfully": "¡Mensaje{param}actualizadoexitosamente!",
  "t-error-updated-message": "Ocurrióunerroralactualizarelmensaje",
  "t-folders": "carpetas",
  "t-available-files": "Archivosdisponibles",
  "t-selected-files": "Archivosseleccionados",
  "t-start-remote-control": "Iniciarcontrolremoto",
  "t-stop-remote-control": "Detenercontrolremoto",
  "t-account-not-exist": "Lacuentadeiniciodesesiónnoexiste,verifíquelacuidadosamente",
  "t-search-Keys": "Buscar",
  "t-details": "Detalles",
  "t-transaction-id": "IDdetransacción",
  "t-payment-certificates": "certificadoTLS",
  "t-payment-application-certificates": "certificadoTLS",
  "t-add-payment-application-certificate": "AgregarcertificadoTLS",
  "t-search-certificate": "Certificado",
  "t-add-certificate": "Agregarcertificado",
  "t-edit-certificate": "Editarcertificado",
  "t-enter-name": "Ingreseelnombre",
  "t-set-password": "Establecercontraseña",
  "t-enter-password": "Ingreselacontraseña",
  "t-enter-new-password": "Ingreselanuevacontraseña",
  "t-confirm-new-password": "Confirmarnuevacontraseña",
  "t-private-key-password": "Contraseñadeclaveprivada",
  "t-certificateLevel-1": "Certificadodenivel1",
  "t-certificateLevel-2": "Certificadodenivel2",
  "t-level1-certificates": "Certificadodeprimernivel",
  "t-please-select-customer": "Porfavorseleccioneuncliente",
  "t-please-select-certificate": "Porfavorseleccioneelcertificado",
  "t-please-select-common-name": "Porfavoringreseelnombrecomún",
  "t-please-select-org-unit": "Ingreselaunidadorganizativa",
  "t-please-select-org-name": "Ingreseelnombredelaorganización",
  "t-please-select-city": "Porfavoringresalaciudad",
  "t-please-select-state": "Porfavoringreseelestado/provincia",
  "t-please-select-country": "Porfavoringresaelpaís",
  "t-please-select-rsa-key": "PorfavorseleccionelaclaveRSA",
  "t-please-enter-password": "Porfavoringresalacontraseña",
  "t-prohibit-enter-space": "Prohibido ingresar espacios.",
  "t-error-maximum-length-key-password": "Lalongituddelacontraseñadebetenercomomáximo10caracteres",
  "t-error-confirm-password-equal-new-password": "Lacontraseñadeconfirmacióndebeserlamismaquelanuevacontraseña",
  "t-signed-l2-certificate": "Certificadodenivel2firmado",
  "t-cert-name": "Nombredelcertificado",
  "t-enter-common-name": "Ingreseelnombrecomún",
  "t-enter-org-unit": "Ingresarunidadorganizativa",
  "t-enter-org": "Ingresarorganización",
  "t-enter-city": "Ingresarciudad",
  "t-enter-state": "Ingresarestado/provincia",
  "t-enter-country": "Ingresarpaís",
  "t-certificate-updated-successfully": "Certificado{param}actualizadoexitosamente",
  "t-certificate-created-successfully": "Elcertificado{param}fuecreadoexitosamente",
  "t-reover-tamper-status": "¿Estásegurodequedeseaborrarlaalarmadedesmontajedeldispositivo?",
  "t-recover-tamper-success": "Laalarmadedesmontajedeldispositivosehaenviadocorrectamentealdispositivo",
  "t-recover-tamper-error": "Fallóelenvíodelasolicitudparaborrarlaalarmadedesmontajedeldispositivo",
  "t-recover-key-error": "Erroralenviarlasolicituddeclavedeinicializacióndeldispositivo",
  "t-add-message": "Agregarmensaje",
  "t-select-message": "Porfavorseleccioneunsocioválido",
  "t-enter-message-name": "Ingreseelnombredelmensaje",
  "t-warning-delete-messageList": "¿Estásegurodequedeseaeliminarelmensaje-{param}?",
  "t-messageList-deleted-successfully": "¡Elmensaje{param}fueeliminadoexitosamente!",
  "t-error-deleting-messagelist": "Fallólaeliminacióndelmensaje",
  "t-error-loading-message": "Ocurrióunerroralcargarelmensaje",
  "t-create-message": "Agregarmensaje",
  "t-edit-message": "Editarmensaje",
  "t-key-bulk-upload": "Cargamasivadeclaves",
  "t-import-key": "Importarclave",
  "t-update-type": "Tipodeactualización",
  "t-full": "paquetecompleto",
  "t-patch": "Paquetedediferencia",
  "t-warning-delete-certificate": "¿Estásegurodequedeseaeliminarelcertificado-{param}?",
  "t-cert-mgmt": "Gestióndecertificados",
  "t-upload-certificate": "Cargarcertificado",
  "t-create-certificate": "Crearcertificado",
  "t-error-deleting-certificate": "Seprodujounerroraleliminarelcertificado",
  "t-certificate-deleted-successfully": "¡Elcertificado{param}seeliminóexitosamente!",
  "t-upload-successfully": "¡Archivocargadoexitosamente!",
  "t-upload-failed": "¡Fallólacargadelarchivo!",
  "t-delete-sub-ca-confirm-tip": "Al eliminar este Sub CA también se eliminarán el Server Cert y la clave privada del mismo socio; los dispositivos afectados deben volver a vincularse.",
  "t-delete-server-cert-confirm-tip": "Al eliminar este Server Cert, los dispositivos vinculados del mismo socio deben volver a vincularse.",
  "t-certificateLevel": "Niveldecertificado",
  "t-signature-success": "Certificadogeneradoexitosamente",
  "t-error-creating-certificate": "Ocurrióunerroralcrearelcertificado",
  "t-error-updating-certificate": "Ocurrióunerroralactualizarelcertificado",
  "t-import-customer": "Importarcliente",
  "t-import-manufacturer": "Importarfabricante",
  "t-import-partner": "Sociodeimportación",
  "t-import-merchant": "Importarcomerciante",
  "t-import-store": "Importartienda",
  "t-search-folder": "carpeta",
  "t-timeline-device": "ciclodevida",
  "t-login-confirm-partner": "Sedetectóeliniciodesesióndelsocio,¿quierescerrarsesiónenelsocioocontinuar?",
  "t-created-date": "Fechadecreación",
  "t-created-by": "creadopor",
  "t-created-time": "Horadecreación",
  "t-partner-open-2nd-signature": "Elsociohaabiertolasegundafirma",
  "t-signed-by-feitian": "FirmadoconcertificadoFeitian",
  "t-add-profile": "Agregararchivodeinicializacióndeterminal",
  "t-edit-profile": "Editararchivodeinicializacióndelterminal",
  "t-delete-profile": "Eliminararchivodeinicializacióndelterminal",
  "t-profile-name": "Nombredelarchivodeinicializacióndelterminal",
  "t-partnerName": "Nombredelsocio",
  "t-modelVersionName": "Nombredelaversióndelmodelo",
  "t-profile-name-required": "Serequiereelnombredelarchivodeinicializacióndelterminal",
  "t-profile-created": "¡Elarchivodeinicializacióndeterminal{param}secreóexitosamente!",
  "t-profile-updated": "¡Elarchivodeinicializacióndelterminal{param}seactualizóexitosamente!",
  "t-error-creating-profile": "Ocurrióunerroralcrearelarchivodeinicializacióndelterminal",
  "t-error-updating-profile": "Seprodujounerroralactualizarelarchivodeinicializacióndelterminal",
  "t-enable-profile-success": "Elarchivodeinicializacióndelterminalseabriócorrectamente",
  "t-enable-profile-close": "Elarchivodeinicializacióndelterminalsecerrócorrectamente",
  "t-select-least-operation": "Porfavorseleccionealmenosunaoperación",
  "t-select-identical-application": "Seleccionasteunaaplicaciónduplicada",
  "t-enable-profile-fail": "Fallólaactivacióndelarchivodeinicializacióndelterminal",
  "t-delete-profile-error": "¡Elarchivodeinicializacióndelterminalhasidohabilitadoynosepuedeeliminar!",
  "t-search-profile": "Archivodeinicializacióndeterminal",
  "t-warning-delete-profile": "¿Estásegurodequedeseaeliminarelarchivodeinicializacióndelterminal-{param}?",
  "t-delete-profile-confirmation": "Eliminarlaconfirmacióndelarchivodeinicializacióndelterminal",
  "t-profile-deleted": "¡Elarchivodeinicializacióndelterminal{param}fueeliminadoexitosamente!",
  "t-cancel-push": "Cancelarenvío",
  "t-abort": "cancelar",
  "t-warning-delete-geo-fence": "¿Estásegurodequedeseaeliminarlageocerca-{param}?",
  "t-geoFence-deleted-successfully": "¡GeoFenceeliminadoexitosamente!",
  "t-error-deleting-geoFence-version": "Seprodujounerroraleliminarlageocerca",
  "t-add-geo-fencing": "Agregargeocercado",
  "t-edit-geo-fencing": "Editargeocercas",
  "t-search-geo-fencing": "geofencing",
  "t-save": "guardar",
  "t-delete-file": "Eliminararchivo",
  "t-warning-message": "Mensajedeadvertencia",
  "t-warning-add-block-device": "Siseseleccionaunaoperacióndebloqueo,eldispositivonorealizarámásoperacionesdespuésdeestaoperación",
  "t-confirm-block-device": "Confirmarbloqueodeldispositivo",
  "t-proceed": "continuar",
  "t-fix-report": "Informeestático",
  "t-start-time": "Horadeinicio",
  "t-end-time": "Horadefinalización",
  "t-select-start-time": "Seleccionarfechadeinicio",
  "t-select-end-time": "Seleccionarfechadefinalización",
  "t-error-exporting-report": "Erroralexportarelinforme",
  "t-report-mgmt": "Gestióndeinformes",
  "t-select-all": "Seleccionartodo",
  "t-select-current-page": "Seleccionar página actual",
  "t-deselect-all": "Deseleccionartodo",
  "t-transaction-version-information": "STORMhaintegradoautomáticamenteTIDyMIDenJsonsegúnelnúmerodeserie,porloquenonecesitaconfigurarTIDyMIDenJson.SiaúnconfiguraTIDyMID,loharemosusatuversión",
  "t-support-mgmt": "Gestióndesoporte",
  "t-tickets-updated-successfully": "¡Boletoactualizadoexitosamente!",
  "t-error-push-ui-group-empty": "¡Haydispositivosdediferentesmodelosyversionesenelgruposeleccionado!",
  "t-warning-to-delete-push-event": "¿Estássegurodequedeseaseliminareleventopush?",
  "t-push-event-deleted-successfully": "¡Eventopusheliminadoexitosamente!",
  "t-application-push-by-group-error": "{param}nosehavinculadoalniveldecliente,¡vincúleloprimero!",
  "t-merchant-redirect-confirm": "¿Quieresserredirigidoalportaldecomerciantes?¿OcontinuarusandoSTORM?",
  "t-merchant-redirect-title": "Redirigiralportaldecomerciantes",
  "t-merchant-redirect": "redireccionar",
  "t-abnormal-device": "Dispositivoanormal",
  "t-log-download-failed": "Errorenlaadquisicióndelregistroynosepuededescargar",
  "t-log-deleting-error": "Cuandofallalaadquisicióndelregistro,deberíaindicarquelaadquisicióndelregistrofallóynosepuedeeliminar",
  "t-account-exception": "Sucuentaestáenunestadoanormal,¡comuníqueseconeladministrador!",
  "t-account-permission-exception": "Elpermisodeusuariohaactualizado,¡comuníqueseconeladministrador!",
  "t-signed": "firmado",
  "t-unsigned": "Sinfirmar",
  "t-select-valid-partner": "Porfavorseleccioneunsocioválido",
  "t-password-mismatch": "Lacontraseñanocoincide",
  "t-support-gms": "SoporteGms",
  "t-search-repository": "repositorio",
  "t-repository": "repositorio",
  "t-add-repository": "Agregarrepositorio",
  "t-edit-repository": "Editarrepositorio",
  "t-error-loading-repository": "Ocurrióunerroralcargarelrepositorio",
  "t-repository-updated-successfully": "¡Repositorio{param}actualizadoexitosamente!",
  "t-error-updating-repository": "Ocurrióunerroralactualizarelrepositorio",
  "t-repository-created-successfully": "¡Elrepositorio{param}fuecreadoexitosamente!",
  "t-error-creating-repository": "Ocurrióunerroralcrearelrepositorio",
  "t-error-deleting-repository": "Seprodujounerroraleliminarelrepositorio",
  "t-repository-name-criteria": "Elnombredelrepositoriosólopuedecontenerletras,números,guionesbajos,puntosyespacios,ynopuedecomenzarniterminarconunespacio",
  "t-required-repository-name": "Elnombredelrepositorioesobligatorio",
  "t-enter-repository-name": "Ingreseelnombredelrepositorio",
  "t-add-cloud-message": "Agregarmensajeenlanube",
  "t-required-valid-cloud-message": "Seleccioneunmensajeenlanubeválido",
  "t-required-cloud-name": "Elnombreesobligatorio",
  "t-token": "token",
  "t-repository-deleted-successfully": "¡Elrepositorio{param}seeliminóexitosamente!",
  "t-cloud-message-deleted-successfully": "¡Elmensajeenlanube{param}seeliminóexitosamente!",
  "t-search-cloud-message": "Mensajeenlanube",
  "t-cloud-name-criteria": "Losnombresdelosmensajesenlanubesolopuedencontenerletras,números,guionesbajos,puntosyespacios,ynopuedencomenzarniterminarconespacios",
  "t-enter-token": "Ingresartoken",
  "t-edit-cloud-message": "Editarmensajeenlanube",
  "t-error-loading-cloud-message": "Seprodujounerroralcargarmensajesenlanube",
  "t-cloud-message-updated-successfully": "¡Elmensajeenlanube{param}seactualizócorrectamente!",
  "t-error-loading-updating-cloud-message": "Seprodujounerroralactualizarlosmensajesenlanube",
  "t-cloud-message-created-successfully": "¡Elmensajeenlanube{param}fuecreadoexitosamente!",
  "t-error-loading-creating-cloud-message": "Seprodujounerroralcrearelmensajeenlanube",
  "t-error-deleting-cloud-message": "Seprodujounerroraleliminarmensajesenlanube",
  "t-push-setting": "Configuracióndeempuje",
  "t-error-deleting-folder": "Seprodujounerroraleliminarlacarpeta",
  "t-cortex-scanner-import": "ImportacióndeescánerCortex",
  "t-import-cortex-scanner": "Importarescánerdecorteza",
  "t-import-cortex-scanner-success": "¡Archivoimportadoexitosamente!",
  "t-system-info": "Informacióndelsistema",
  "t-payment-kernel": "núcleodepago",
  "t-device-configuration": "Configuracióndeldispositivo",
  "t-functional-info": "Informaciónfuncional",
  "t-push-install-type": "Tipodeinstalación",
  "t-automatic-upgrade": "Actualizaciónautomática",
  "t-push-transaction-detail": "push",
  "t-push-is-mobile-traffic": "Sisedebenutilizardatosmóviles",
  "t-push-start-time": "Horadeinicio",
  "t-push-end-time": "Horadefinalización",
  "t-push-details": "Detallesdeenvío",
  "t-activated-kiosk-mode": "Activarmododedominiodepantalla",
  "t-unActivated-kiosk-mode": "Desactivarelmododedominiodepantalla",
  "t-push-abort-successfully": "¡Cancelarelenvíoexitosamente!",
  "t-error-push-abort": "Seprodujounerroralcancelarelenvío",
  "t-push-event": "Tareaprogramada",
  "t-add-push-event": "Agregartareaprogramada",
  "t-edit-push-event": "Editartareaprogramada",
  "t-required-event-name": "Elnombredelatareaprogramadaesobligatorio",
  "t-event-name-pattern": "Losnombresdelastareasprogramadassólopuedencontenerletras,números,guionesbajos,puntosyespacios,ynopuedencomenzarniterminarconespacios",
  "t-event-is-planned": "plan",
  "t-required-action": "Serequiereacción",
  "t-search-group-by-name": "Buscargrupopornombre",
  "t-search-device-by-sn": "Buscardispositivopornúmerodeserie",
  "t-push-event-application-version": "Aplicaciónyversión",
  "t-old": "viejo",
  "t-is-planned": "plan",
  "t-inStalled-application": "Aplicacióninstalada",
  "t-push-event-firmware-version": "Firmwareyversión",
  "t-new-version": "nuevaversión",
  "t-old-version": "versiónantigua",
  "t-enable-disable": "Activar/Desactivar",
  "t-ui-setting-list": "listadeconfiguracionesdeUI",
  "t-select-group-or-device": "Seleccioneelgrupoodispositivoquecontieneeldispositivo",
  "t-select-application-to-install": "Seleccionelaversióndelaaplicaciónquedeseaenviar",
  "t-select-fireware-to-install": "Seleccionelaversióndefirmwareparainstalar",
  "t-select-application-to-uninstall": "Seleccionelaaplicaciónparadesinstalar",
  "t-select-ui-setting": "Seleccionelaconfiguracióndelainterfazdeusuario",
  "t-push-event-created-successfully": "Eleventopush{param}secreóexitosamente",
  "t-error-created-push-event": "Seprodujounerroralcreareleventopush",
  "t-execution-time-greater-than-current-time": "Eltiempodeejecucióndebesermayorqueeltiempoactual",
  "t-push-event-updated-successfully": "Eventopush{param}actualizadoexitosamente",
  "t-import-device-information-details": "Importardetallesdeinformacióndeldispositivo",
  "t-import-customer-information-details": "Importardetallesdeinformacióndelcliente",
  "t-import-partner-information-details": "Importardetallesdeinformacióndelsocio",
  "t-import-manufacturer-information-details": "Importardetallesdeinformacióndelfabricante",
  "t-import-merchant-information-details": "Importardetallesdeinformacióndelcomerciante",
  "t-import-store-information-details": "Importardetallesdeinformacióndelatienda",
  "t-import-key-information-details": "Importardetallesdeinformaciónclave",
  "t-import-cortex-scanner-information-details": "ImportardetallesdeinformacióndelCortexScanner",
  "t-push-key-empty-error": "Nohayningúndispositivoquecoincidaconestaclaveenelgrupo",
  "t-total-number": "Númerototal",
  "t-select-tid-to-use": "PorfavorseleccioneelTIDausar",
  "t-import-failed": "Errorenlaimportación",
  "t-network-gateway-timeout": "Seagotóeltiempodeesperadelasolicituddered,¡inténtelodenuevo!",
  "t-network-service-unavailable": "Enmantenimiento,¡inténtalodenuevomástarde!",
  "t-network-bad-gateway": "Solicitudnoválida,¡inténtelodenuevo!",
  "t-network-not-found": "¡Elrecursonoexiste,porfavorcontactealadministrador!",
  "t-network-forbidden": "¡Sinpermiso,sinacceso!",
  "t-network-bad-request": "Elcuerpodelasolicitudesincorrecto,¡inténtalodenuevo!",
  "t-network-method-not-allowed": "Elmétodonoestápermitido,¡inténtalodenuevo!",
  "t-spring-configuration": "Configuraciónderesorte",
  "t-prefix": "prefijo",
  "t-properties": "propiedades",
  "t-done": "hecho",
  "t-property": "propiedad",
  "t-git-branch": "ramagit",
  "t-git-version": "versióngit",
  "t-zone": "zonahoraria",
  "t-management-port": "Puertodegestión",
  "t-git-commit": "compromisodegit",
  "t-health-checks": "Controlesdesalud",
  "t-service-name": "Nombredelservicio",
  "t-otp-mobile-installation-manual": "Manualdeinstalacióndeltokenmóvil",
  "t-otp-mobile-installation-manual-android": "Manualdeinstalacióndeltokenmóvil(Android)",
  "t-installation-manual-android-1": "1-IngresaalGoogleMarket,busca'OTPMobile',descárgaloeinstálaloentuteléfono",
  "t-installation-manual-android-2": "2-Cuandoabreslaaplicaciónmóvilotpporprimeravez,necesitashabilitarunaseriedepermisosparaevitarproblemasduranteeluso.Serecomiendaquelosusuarioshabilitenestospermisos",
  "t-installation-manual-android-3": "3-Utilicelafunción“Escanear“paraescanearlainformacióndelcódigoQRenelcorreoelectrónicoparaactivareltoken",
  "t-installation-manual-android-4": "4-Despuésdeunaactivaciónexitosa,elvalorOTPsemostraráenlainterfazdelaaplicación",
  "t-installation-manual-android-5": "5-Cuandounusuarionormaliniciasesión,sielsocioalquepertenecehahabilitadolaautenticacióndedosfactores,debeingresarunacontraseñaparainiciarsesión",
  "t-otp-mobile-installation-manual-ios": "Manualdeinstalacióndeltokenmóvil(IOS)",
  "t-installation-manual-ios-1": "1-IngresaalaAppStore,busca'otpmobiletoken',descárgaloeinstálaloentuteléfono",
  "t-installation-manual-ios-2": "2-Abrirlaaplicaciónmóvilotp",
  "t-installation-manual-ios-3": "3-Utilicelafunción“Escanear“paraescanearlainformacióndelcódigoQRenelcorreoelectrónicoparaactivareltoken",
  "t-installation-manual-ios-4": "4-Despuésdeunaactivaciónexitosa,elvalorOTPsemostraráenlainterfazdelaaplicación",
  "t-installation-manual-ios-5": "5-Cuandounusuarionormaliniciasesión,sielsocioalquepertenecehahabilitadolaautenticacióndedosfactores,necesitaingresarunacontraseñaparainiciarsesión",
  "t-password-configuration": "Configuracióndecontraseña",
  "t-passeord-use-least-one-uppercase-letter": "Usaalmenosunaletramayúscula",
  "t-not-allows-use-special-characters": "Nopermiteelusodecaracteresespeciales",
  "t-not-allows-use-chinese-special-characters": "No permite el uso de caracteres especiales chinos",
  "t-default-template": "Plantillapredeterminada",
  "t-user-changed-to-partner": "Rolcambiadoasocio:{param}",
  "t-smart-terminal-operations-remote-manager": "Administradorremotodeoperacionesdeterminalinteligente",
  "t-account-profile": "Perfil",
  "t-sign-out": "Salir",
  "t-merchant-portal": "Portaldecomerciantes",
  "t-storm": "TORMENTA",
  "t-init-key": "Clavedeinicialización",
  "t-password-does-not-match": "Lacontraseñanocoincide",
  "t-password-changed": "Lacontraseñahasidocambiada,iniciesesión",
  "t-selectd-devices": "Dispositivosseleccionados",
  "t-store-not-associated": "Latiendanoestáasociada",
  "t-push-group": "grupo",
  "t-error-loading-group-device": "Ocurrióunerroralcargareldispositivoenelgrupo",
  "t-reset-password-link-invalid": "Fallóelcambiodecontraseña:elenlacenoesválido",
  "t-changed-password": "Cambiarcontraseña",
  "t-continue": "continuar",
  "t-invalid-credentials": "Credencialesnoválidas",
  "t-storm-version-release-notes": "NotasdelaversiónSTORMV1-3-3",
  "t-version-notes-content": "Enestaversión,noscentramosenelmódulodeinformes,losinformesfijosledaránunavistageneraldelosdatosdediferentesmódulos",
  "t-version-notes-one-title": "Gestióndeinformes:Informeestático",
  "t-version-notes-one-content": "STORMahoraleproporcionaestafuncióndegeneracióndeinformes.STORMpuedegenerarmúltiplesformatosdeinformesdesdediferentesperspectivas:dispositivo,aplicación,firmware,inserciónyciclodevida.TambiénseadmitePDFyformatoExcel.informe",
  "t-version-notes-two-title": "Estadodelareddeldispositivo",
  "t-version-notes-two-content": "Ahoraproporcionamosvarioscolorespararepresentarelestadodediferentesdispositivos,paraquelosusuariospuedancomprenderelestadoactualdelareddeldispositivomásrápidamente",
  "t-version-notes-two-content-green": "Verde:Enlínea",
  "t-version-notes-two-content-red": "Rojo:sinconexión",
  "t-version-notes-two-content-orange": "Naranja:másalládelageocerca",
  "t-version-notes-two-content-blue": "Azul:Paraactivar",
  "t-version-notes-two-content-grey": "Gris:Inactivo",
  "t-version-notes-three-title": "PushReport",
  "t-version-notes-three-content": "STORMproporcionaunaformaobviadeindicarelestadodelenvío.Yaseaqueelenvíoseaexitoso,fallidooenprogreso,losusuariospuedenverelestadoaprimeravistasegúncoloresynúmerosespecíficos..Además,elusuariopuederevocarelenvíoenunaetapaanterior,loquesignificaquelasolicitudaúnnosehaenviadoaldispositivo.",
  "t-version-optimisaziton-points": "Puntosdeoptimización:",
  "t-version-optimisaziton-points-one-title": "Actualizacióndeseleccióndesocios",
  "t-version-optimisaziton-points-one-content": "Anteriormentesoloproporcionábamosunaformadebuscarnombresdesocios,ahoraofrecemosdosmétodosdeselecciónycuadrodebúsquedaparaadaptarnosalasdiferentesperspectivasdelosusuarios",
  "t-version-optimisaziton-points-two-title": "InformedeexportacióndeExceldeequipos",
  "t-version-optimisaziton-points-two-content": "EnExcel,hayinformaciónmásdetalladasobreundispositivoespecífico,porloqueelusuariosólonecesitaobtenermásinformaciónen1Excel",
  "t-version-optimisaziton-points-three-title": "notificaciónpushdelaaplicación",
  "t-version-optimisaziton-points-three-content": "Alenviarunaaplicaciónaunconjuntodedispositivos,apareceráunanotificaciónsiunoomásdispositivosnoestánvinculadosalniveldecliente",
  "t-certificate-file": "Archivodecertificado",
  "t-select-certificate-file": "Seleccionararchivodecertificado",
  "t-cannot-empty-existing-imei": "NosepuedeborrarelImeiexistente",
  "t-required-payment-certificate-name": "SerequiereelnombredelcertificadoTLS",
  "t-payment-certificate-saved-successfully": "CertificadoTLSguardadoexitosamente",
  "t-payment-certificate-deleted-successfully": "¡ElcertificadoTLS{param}seeliminóexitosamente!",
  "t-error-deleting-payment-certificate": "SeprodujounerroraleliminarelcertificadoTLS",
  "t-select-start-end-time-limit": "Elperíododeverificaciónnopuedeexcederlos3meses",
  "t-select-multiple-options": "Seleccionealmenosunacondicióndefiltro",
  "t-warning-to-delete-payments": "¿EstásegurodequedeseaeliminarelcertificadoTLS-{param}?",
  "t-delete-device-payments": "EliminarconfirmacióndelcertificadoTLS",
  "t-enable_tid": "EditarTID",
  "t-key-expired": "Laclavehacaducado,creeunanuevaclaveparaevitaríndicesdeclavesduplicados",
  "t-sub-partner": "subsocio",
  "t-open-enable-otp": "EladministradorhabilitaOTP",
  "t-otp-identification-code": "Códigodeidentificacióndeltoken",
  "t-token-identification-code-setting": "(Aplicacióndetokenmóvil->Configuración->Acercade)",
  "t-required-identification-code": "Elcódigodeidentificacióndeltokenesobligatorio",
  "t-enter-otp-code": "Ingreseelcódigodeidentificacióndeltoken",
  "t-generate-qr-code": "GenerarcódigoQR",
  "t-otp-code-to-active": "IngreseelcódigoOTPparaactivar:",
  "t-enter-otp-code-to-active": "IngreseelcódigoOTP",
  "t-generated-code": "Generar código",
  "t-enter-generated-code-to-active": "Ingrese el código de activación",
  "t-required-otp-code": "SerequierecódigoOTP",
  "t-identification-code-criteria": "ElcódigodeidentificaciónOTPconstadenúmeros",
  "t-otp-code-criteria": "ElcódigoOTPconstadenúmeros",
  "t-please-generate-qr-code": "PrimeroobtengaelcódigoQR",
  "t-enable-update-token": "Tokendereemplazo",
  "t-active-otp-success": "¡ActivaOTPexitosamente!",
  "t-error-enter-minlength-identification-code": "Lalongituddelcódigodeidentificacióndeltokennopuedeserinferiora20",
  "t-bind-token-sn": "Elusuariohavinculadoeltoken(númerodetoken:",
  "t-activation-otp": "ActivarOTP",
  "t-activation-otp-link-invalid": "FallólaactivacióndeOTP:Elenlacenoesválido",
  "t-generate-qr-code-failed": "ErroralgenerarelcódigoQR",
  "t-activation-otp-failed": "FallólaactivacióndeOTP",
  "t-error-reset-password": "Erroralrestablecerlacontraseña",
  "t-error-download-repeat": "Elarchivohasidodescargado,nolovuelvaadescargar",
  "t-profile-application-layout": "Sihaactivadolafirmadeaplicaciones(loquesignificaquehacargadouncertificadodeaplicación),¡asegúresedequesudispositivoestévinculadoaunclienteespecífico!",
  "t-export-to-json": "ExportaraarchivoJSON",
  "t-device-status": "Estadodeldispositivo",
  "t-versions": "versiones",
  "t-search-application": "Aplicación",
  "t-tls-certificate-import": "ImportacióndecertificadoTLS",
  "t-tls-certificate-bulk-upload": "CargamasivadecertificadosTLS",
  "t-import-tls-certificate": "ImportarcertificadoTLS",
  "t-import-tls-certificate-information-details": "ImportardetallesdeinformacióndelcertificadoTLS",
  "t-tls-file-name": "Nombredearchivo:{param}",
  "t-push-confirm": "Confirmacióndeenvío",
  "t-install-cer": "instalar-cer",
  "t-push-confirm-desc": "Confirmequedeseaenviartodosloscertificadosalosdispositivoscontenidosenelarchivozip",
  "t-tls-certificate": "CertificadoTLS",
  "t-add-event": "Agregarevento",
  "t-modified-date": "Fechademodificación",
  "t-main-log": "registroprincipal",
  "t-bluetooth": "Bluetooth",
  "t-kernel-log": "Registrodelkernel",
  "t-security-processor-log": "Registrodelprocesadordeseguridad",
  "t-pos-server-log": "registrodelservidorPOS",
  "t-log-seconds": "segundos",
  "t-log-mins": "minutos",
  "t-log-hour": "hora",
  "t-log-hours": "horas",
  "t-previous": "páginaanterior",
  "t-today": "hoy",
  "t-month-view": "vistamensual",
  "t-week-view": "vistasemanal",
  "t-day-view": "vistadedía",
  "t-message-version": "Versióndelmensaje",
  "t-search-firmware-version": "versióndefirmware",
  "t-capturen-not-start": "Lacapturanohacomenzado",
  "t-capture-completed": "Capturacompletada",
  "t-capture-failed": "Errordecaptura",
  "t-capturing": "Capturando",
  "t-modelversion": "Versióndelmodelo",
  "t-firmwareversion": "versióndefirmware",
  "t-applicationversion": "Versióndelaaplicación",
  "t-keymanagement": "Gestióndeclaves",
  "t-message-management": "Gestióndemensajes",
  "t-pushmanagement": "Gestióndeenvíos",
  "t-importmanagement": "Gestióndeimportaciones",
  "t-logmanagement": "Gestiónderegistros",
  "t-ui-mgmt": "administracióndelainterfazdeusuario",
  "t-roles---permissions": "Permisosderoles",
  "t-certificate-mgmt": "Gestióndecertificados",
  "t-rki-certificate": "Certificado RKI",
  "t-application-certificate": "Certificadodesolicitud",
  "t-under_activation": "Paraseractivado",
  "t-block~disabldisable": "BLOQUEAR~DESHABILITAR",
  "t-disable~blocblock": "DESACTIVAR~BLOQUEAR",
  "t-kiosk-mode-activated": "Mododepantallasuperioractivado",
  "t-install-app": "Instalaraplicación",
  "t-firmware-incremental-upgrade": "Actualizaciónincrementaldelfirmware",
  "t-firmware-full-package": "Actualizacióndefirmware",
  "t-restart-device": "Reiniciardispositivo",
  "t-storm-factory-reset-device": "Restaurarlaconfiguracióndefábrica-STORM",
  "t-device-factory-reset-device": "Restaurarlaconfiguracióndefábrica-Dispositivo",
  "t-unlock-device": "Desbloqueardispositivo",
  "t-device-initialization": "Inicializacióndeldispositivo",
  "t-start-log-capture": "Iniciarcapturaderegistro",
  "t-stop-log-capture": "Detenercapturaderegistros",
  "t-erase-tamper": "Liberareldesmontaje",
  "t-payment-application-certificate": "CertificadodeSolicituddePago",
  "t-automatic-active": "activaciónautomática",
  "t-device-automatic-initialization": "Inicializaciónautomáticadeldispositivo",
  "t-transaction-parameter": "Parámetrodetransacción",
  "t-not-yet-executed": "Aúnnoejecutado",
  "t-application---full-package": "Aplicación-paquete-completo",
  "t-application---batch-update": "Paquetedediferenciadeaplicación",
  "t-factory-reset-device-storm": "Restaurarlaconfiguracióndefábrica-STORM",
  "t-factory-reset-device-device": "Restaurarlaconfiguracióndefábrica-DISPOSITIVO",
  "t-please-improve-tid": "Porfavor,mejoratid",
  "t-please-clear-tid-bind": "BorretodoslosTIDrelacionadosconlosnúmerosdeserie",
  "t-profile-application-fail-cause": "Estado de procesamiento de la aplicación",
  "t-profile-uisettings-fail-cause": "Estado de procesamiento de temas",
  "t-profile-systemparam-fail-cause": "Estado de procesamiento de parámetros del sistema",
  "t-profile-application-name": "Nombredelaaplicación",
  "t-profile-application-version-name": "Nombredelaversióndelaaplicación",
  "t-profile-firmware-fail-cause": "Causa de Falla del Firmware",
  "t-profile-firmware-processing-status": "Estado de procesamiento de firmware",
  "t-profile-firmware-name": "Nombre del Firmware",
  "t-profile-firmware-version-name": "Nombre de la Versión del Firmware",
  "t-profile-fail-cause": "Motivodelfallo",
  "t-profile-uisettings-name": "NombredeconfiguracióndeUI",
  "t-profile-uisettings-version-name": "nombredelaversióndelaconfiguracióndeUI",
  "t-profile-systemparam-name": "Nombredelparámetrodelsistema",
  "t-profile-systemparam-version-name": "Nombredelaversióndelparámetrodelsistema",
  "t-profile-systemparam-version": "Versióndeparámetrosdelsistema",
  "t-error-geo-fence-action-list": "Lalistadeaccionesnopuedeestarvacía",
  "t-error-geo-fence-region-list": "La lista de regiones no puede estar vacía",
  "t-error-geo-fence-action": "Laacciónnopuedeestarvacía",
  "t-maximize": "maximizar",
  "t-dashboard-widget-selection": "Seleccióndewidgetsdelpanel",
  "t-ui-management-version": "VersióndeadministracióndeUI",
  "t-system-params-version": "Versióndeparámetrosdelsistema",
  "t-action-create": "Crear",
  "t-action-update": "actualizar",
  "t-action-delete": "eliminar",
  "t-add-region": "Agregarregión",
  "t-password-configuration-select": "Seleccionealmenosunapolíticadecontraseña",
  "t-network-try-again": "Errordered,inténtelodenuevo",
  "t-connection-time-out": "Seagotóeltiempodeconexión,inténtelodenuevo",
  "t-test-connection": "ProbarConexión",
  "t-connection-test-success": "Pruebadeconexiónexitosa",
  "t-connection-test-failed": "Pruebadeconexiónfallida",
  "t-application-signed-failed": "Fallólafirmadelaaplicación",
  "t-add-profile-check-application": "AsegúresedequeelAPKfirmadosedetectecorrectamente",
  "t-tid-require-valid": "SicompletasTID,necesitascompletarelpaísylaregión",
  "t-file-upload": "Cargadearchivos",
  "t-application-control": "Controldeaplicaciones",
  "t-remove-uninstall-block": "Eliminarprohíbeladesinstalación",
  "t-remove-password": "Eliminarcontraseña",
  "t-app-set-uninstall-block": "Laconfiguracióndelaaplicaciónprohíbeladesinstalación",
  "t-app-remove-uninstall-block": "Laeliminacióndelaaplicaciónprohíbeladesinstalación",
  "t-app-set-password": "Contraseñadeconfiguracióndeaplicación",
  "t-app-remove-password": "Contraseñadeeliminacióndeaplicación",
  "t-configuration-success": "Configuracióndelaaplicaciónenviadaaldispositivo",
  "t-error-enter-minlength-password": "Lalongituddelacontraseñanopuedeserinferiora6",
  "t-error-enter-password": "Serequierecontraseña",
  "t-warning-to-remove-uninstall-block": "¿Estássegurodequedeseaseliminaraplicacionescuyadesinstalaciónestáprohibida?",
  "t-warning-to-logout": "Está seguro de que quiere cancelar？",
  "t-email-name-required": "Elnombredelaconfiguracióndecorreoelectrónicoesobligatorio",
  "t-email-created-successfully": "¡Laconfiguracióndecorreoelectrónico{param}fuecreadaexitosamente!",
  "t-email-updated-successfully": "¡Laconfiguracióndecorreoelectrónico{param}seactualizóexitosamente!",
  "t-error-creating-email": "Ocurrióunerroralcrearlaconfiguracióndelcorreoelectrónico",
  "t-error-updating-email": "Ocurrióunerroralactualizarlaconfiguracióndelcorreoelectrónico",
  "t-enable-email-success": "Laconfiguracióndelcorreoelectrónicosehahabilitadocorrectamente",
  "t-enable-email-close": "Laconfiguracióndelcorreoelectrónicosehacerradocorrectamente",
  "t-enable-email-fail": "Erroralhabilitarlaconfiguracióndecorreoelectrónico",
  "t-delete-email-error": "¡Laconfiguracióndecorreoelectrónicoestáhabilitadaynosepuedeeliminar!",
  "t-search-email": "correoelectrónico",
  "t-warning-delete-email": "¿Estásegurodequedeseaeliminarlaconfiguracióndecorreoelectrónico-{param}?",
  "t-delete-email-confirmation": "Eliminarconfirmacióndeconfiguracióndecorreoelectrónico",
  "t-email-deleted": "¡Laconfiguracióndecorreoelectrónicosehaeliminadoexitosamente!",
  "t-add-email": "Agregarcorreoelectrónico",
  "t-edit-email": "Editarcorreoelectrónico",
  "t-enter-email-name": "Ingreseelnombredelcorreoelectrónico",
  "t-enter-email-server": "Ingreseelservidordecorreoelectrónico",
  "t-enter-port": "Puertodeentrada",
  "t-enter-email-account": "Ingresarcuentadecorreoelectrónico",
  "t-enter-email-sender": "Ingreseelremitentedelcorreoelectrónico",
  "t-required-email-sender": "Serequiereremitentedelcorreoelectrónico",
  "t-error-email-name-pattern": "Losnombresdeloscorreoselectrónicosconstandeletras,números,guionesbajos,puntosyespacios,ynopuedencomenzarniterminarconespacios",
  "t-error-email-server-required": "Serequiereservidordecorreoelectrónico",
  "t-error-email-account-required": "Serequiereunacuentadecorreoelectrónico",
  "t-error-email-port-required": "Elpuertoesrequerido",
  "t-error-email-port-pattern": "Elpuertodebeestarentre1-65535",
  "t-error-email-host-pattern": "Ingreseunservidordecorreoelectrónicoválido",
  "t-search-key": "clave",
  "t-search-push-detail": "Buscardetallesdeinserción",
  "t-search-push-event": "Buscareventopush",
  "t-search-log-capture-event": "Registrodebúsqueda",
  "t-search-partner-setting": "Socio",
  "t-search-ui-settings-version": "Versióndeconfiguracióndelainterfazdeusuariodebúsqueda",
  "t-search-payment-application-certificate": "CertificadoTLS",
  "t-search-message-sidebar": "Buscarsocios",
  "t-email-setting-connection-success": "Conexióndeconfiguracióndecorreoelectrónicoexitosa",
  "t-email-setting-connection-failed": "Errorenlaconexióndeconfiguracióndecorreoelectrónico",
  "t-lat-and-lng": "Longitudylatitud",
  "t-version-low-to-upgrade": "Laversiónactualesdemasiadobajaparaadmitirestafunción,actualicelaversión",
  "t-email-settings-enable-ssl": "HabilitarSSL",
  "t-email-settings-enable-starttls": "HabilitarSTARTTLS",
  "t-email-settings-meanwhile-enbale": "NosepuedenhabilitarelprotocoloSSLyelprotocoloTLSalmismotiempo",
  "t-error-update-application": "Errorenlaaplicacióndeactualización",
  "t-file-size-bigger": "Eltamañodelarchivoesdemasiadogrande",
  "t-error-bind-device": "Erroralvinculareldispositivo",
  "t-error-unbind-device": "Erroraldesvinculareldispositivo",
  "t-required-transaction-param-version-name": "Elnombredelaversióndelparámetrodetransacciónesobligatorio",
  "t-required-package-name": "Elnombredelpaqueteesobligatorio",
  "t-required-intent-name": "Elnombredelaintenciónesobligatorio",
  "t-upload-file": "Subirarchivo",
  "t-deleted": "eliminar",
  "t-customer-name": "Nombredelcliente",
  "t-store-name": "nombredelatienda",
  "t-expired-at": "Tiempodevencimiento",
  "t-hsm-model-name": "NombredelmodeloHsm",
  "t-pushes": "empujar",
  "t-is-batch-upload": "Cargaporlotes",
  "t-system-param-name": "Nombredelparámetrodelsistema",
  "t-model-type": "Tipodemodelo",
  "t-model-type-required": "Serequieretipodedispositivo",
  "t-smart-pos": "POSinteligente",
  "t-id-pos": "IDPOS",
  "t-mpos": "MPOS",
  "t-folder-name": "nombredecarpeta",
  "t-batch-devices-details": "Detallesdeinformacióndeldispositivodevinculación/desvinculacióndelotes",
  "t-execute-date": "Fechadeejecución",
  "t-expired-date": "Fechadevencimiento",
  "t-empty-device-password": "Eldispositivoactualaúnnohaestablecidounbloqueodecontraseña",
  "t-pubkey-is-normal-no-need-to-sync": "Laclavepúblicaesnormal,noesnecesariosincronizarla",
  "t-task-scheduler-name": "Nombredelatareaprogramadadelsistema",
  "t-add-task-scheduler": "Agregartareaprogramadadelsistema",
  "t-edit-task-scheduler": "Editartareaprogramadadelsistema",
  "t-delete-task-scheduler": "Eliminartareasprogramadasdelsistema",
  "t-warning-delete-task-scheduler": "¿Estásegurodequedeseaeliminarlatareaprogramadadelsistema-{param}?",
  "t-task-scheduler-deleted": "¡Latarea{param}programadaporelsistemaseeliminóexitosamente!",
  "t-error-deleting-task-scheduler": "Seprodujounerroraleliminarlatareaprogramadadelsistema",
  "t-second": "segundo",
  "t-cycle-by": "ciclo",
  "t-not-specified": "Noespecificado",
  "t-follow": "seguir",
  "t-this-month": "estemes",
  "t-this-week": "estasemana",
  "t-specified": "especificado",
  "t-last-five-runs": "Últimas5carreras",
  "t-permissible-wildcards": "Permitircomodines",
  "t-last": "último",
  "t-monthly": "cadames",
  "t-most-recent-working-day": "eldíalaborablemásreciente",
  "t-warning-execute-task-scheduler": "¿Estásegurodeejecutarlatarea'{param}'inmediatamente?",
  "t-error-execute-task-scheduler": "Ocurrióunerroralejecutarlatareaprogramadadelsistema",
  "t-enable-task-scheduler-success": "Tareaprogramadadelsistemahabilitadaexitosamente",
  "t-enable-task-scheduler-close": "Latareaprogramadadelsistemasecerrócorrectamente",
  "t-enable-task-scheduler-fail": "Erroralhabilitarlastareasprogramadasdelsistema",
  "t-please-select-model-version": "¡Seleccionelaversióndelmodelo!",
  "t-path": "ruta",
  "t-rom-version": "VersiónROM",
  "t-k21-version": "VersiónK21",
  "t-memory-total": "Memoriatotal",
  "t-memory-available": "Memoriadisponible",
  "t-flash-total": "Memoriaflashtotal",
  "t-flash-available": "Memoriaflashdisponible",
  "t-battery": "batería",
  "t-model-type-exist": "Eltipodemodeloyaexiste,eliminelosdatosexistentesyagréguelosnuevamente",
  "t-model-functions": "Funcionesdelmodelo",
  "t-error-enter-valid-cleancondition": "Sólosepuedeningresarnúmerosparaborrarlacondición",
  "t-cleancondition": "Borrarcondición",
  "t-set-version-type": "Establecertipodeversión",
  "t-not-support-log-capture": "Losterminalestradicionalesnoadmitenlacapturamanualderegistros",
  "t-example": "ejemplo",
  "t-type-of-30-second": "Tipo1significa30segundos",
  "t-type-of-60-second": "Eltipo2representa60segundos",
  "t-example-of-capture": "{\"nombredearchivo\"t-:\"11.txt\"t-,\"ruta\"t-:\"\"t-,\"tipo\"t-:\"\"t-}",
  "t-push-scheduled-tasks": "Enviarregistrosdetareasprogramadas",
  "t-executing": "Ejecutando",
  "t-task-created": "Latareahasidocreada",
  "t-search-push-scheduled-tasks": "Buscarregistrosdetareasprogramadaspush",
  "t-res[i]-name": "¿Estásegurodequedeseacancelarlatareaprogramadadeenvío?",
  "t-push-scheduled-tasks-abort-successfully": "¡Abortarlastareaspushprogramadasconéxito!",
  "t-error-push-scheduled-tasks-abort": "Seprodujounerroralcancelarunatareaprogramadadeenvío",
  "t-error-version-type-required": "Eltipodeversiónesrequerido",
  "t-not-support-log-capture-if-id": "Eltipodeprotocolodeesteterminaldeautenticaciónnoadmitelacapturaderegistros",
  "t-cancel-push-success": "Cancelarenvíoexitosamente",
  "t-error-enter-maxlength-password": "Lalongituddelacontraseñadebeserde6caracteres",
  "t-not-allow-same-duration": "Nosepermitelamismaduración",
  "t-signature-file-currently-creating": "Actualmentecreandounarchivodefirma---",
  "t-differential-package-creating": "Generandopaquetediferencial---",
  "t-connection-type-required": "Serequieretipodeconexión",
  "t-message-protocol-required": "Serequiereprotocolodemensajes",
  "t-apk": "APK",
  "t-zip-dat": "ZIP|DAT",
  "t-file-type-required": "Eltipodearchivoesrequerido",
  "t-no-preview-available-tiff": "NosepuedeobtenerunavistapreviadelosarchivosTIFF",
  "t-inconsistent-apk-signatures-unable-push-patch-file": "Lafirmadelaaplicaciónesinconsistenteyelarchivodediferencianosepuedeenviar",
  "t-enter-push-event-name": "Ingreseelnombredelatareaprogramadadeinserción",
  "t-downloading": "Descargando",
  "t-batch-delete": "Eliminarenlotes",
  "t-confirm-batch-delete": "¿Está seguro de que desea eliminar {count} elementos?",
  "t-batch-delete-devices": "Eliminardispositivosenlotes",
  "t-batch-delete-select-at-least-one": "Porfavor,seleccionealmenosunelemento",
  "t-batch-delete-invalid-id-format": "FormatodeIDinválido",
  "t-batch-delete-some-items-not-exist": "Algunoselementosnoexisten",
  "t-batch-delete-request-failed": "Lasolituddeeliminaciónenlotesfalló",
  "t-batch-delete-no-permission": "Sinpermisoparaeliminarenlotes",
  "t-batch-delete-success-count": "Elementos eliminados con éxito {count}",
  "t-search-by-group-name": "Buscargrupopornombre",
  "t-search-device-by-sn-tid-mid": "Buscardispositivospornúmerodeserie,TID,MID",
  "t-batch-delete-device": "Eliminardispositivo",
  "t-batch-delete-devices-details": "Eliminarinformacióndeldispositivoenlotes",
  "t-input-invalid-apk-password": "Solopuedesingresarnúmerosparalacontraseña",
  "t-batch-enable-disable-device": "Habilitarydeshabilitardispositivosenlotes",
  "t-search-by-firmware": "Buscarpornombredefirmware",
  "t-search-by-firmware-version": "Buscarpornombredeversióndefirmware",
  "t-batch-disable-device": "Dispositivosdeshabilitadosporlotes",
  "t-search-by-application": "Buscarpornombredeaplicación",
  "t-search-by-application-version": "Buscarpornombredeversióndelaaplicación",
  "t-partner-mgmt": "Gestióndesocios",
  "t-customer-mgmt": "Gestión de Clientes",
  "t-merchant-mgmt": "Gestión de Comerciantes",
  "t-system-general-parameter": "Parámetrogeneral",
  "t-add-wallpaper": "Agregarfondodepantalla",
  "t-enter-wallpaper-name": "Ingreseelnombredelfondodepantalla",
  "t-wallpaper-name-required": "Elnombredelfondodepantallaesobligatorio-",
  "t-add-boot-picture": "Agregarelprimercuadrodearranque",
  "t-enter-boot-picture-name": "Ingreseelnombredelprimermarcodeinicio",
  "t-boot-picture-name-required": "Elnombredelprimerfotogramadearranqueesobligatorio-",
  "t-add-boot-animation": "Agregaranimacióndearranque",
  "t-enter-boot-animation-name": "Ingreseelnombredelaanimacióndearranque",
  "t-boot-animation-name-required": "Elnombredelaanimacióndearranqueesobligatorio-",
  "t-boot-picture-file": "Elprimerarchivodefotogramadelarranque",
  "t-boot-animation-file": "Archivodeanimacióndearranque",
  "t-preview-wallpaper": "Vistapreviadelfondodepantalla",
  "t-preview-boot-picture": "Vistapreviadelprimercuadrodearranque",
  "t-preview-boot-animation": "Vistapreviadelaanimacióndearranque",
  "t-retract": "retraer",
  "t-expand": "expandir",
  "t-app-mgmt": "Administracióndeaplicaciones",
  "t-install-immediately-after-downloading": "Instalarinmediatamentedespuésdeladescarga",
  "t-install-immediately-for-tips": "Consejos:puedeafectarlasoperacionesencursodelosclientes",
  "t-select-installation-period": "Seleccioneelperíododeinstalación",
  "t-automatic-upgrade-after-startup": "Actualizarautomáticamentedespuésdelinicio",
  "t-specify-the-first-time-after-downloading": "Especifiqueeltiempodesdelaprimeravezdespuésdedescargarelarchivo",
  "t-support-upgrade-strategy-for-version-code": "SMAversiónXXXysuperioresadmitenestaestrategiadeactualización-",
  "t-installation-time-greater-than-current-time": "Eltiempodeinstalacióndebesermayorqueeltiempoactual",
  "t-installation-time": "Tiempodeinstalación",
  "t-please-select-installation-time": "Seleccionelaprimeravezdespuésdedescargarelarchivo",
  "t-key-mgmt": "Gestióndeclaves",
  "t-firmware-mgmt": "Gestióndefirmware",
  "t-system-settings": "Configuracióndelsistema",
  "t-search-sn-tid-mid": "SN、TID、MID、IMEI",
  "t-search-sn-mid": "SN、MID、IMEI",
  "t-search-sn-tid": "SN、TID",
  "t-search-name-mid": "NAME、MID",
  "t-search-wallpaper": "fondodepantalla",
  "t-search-boot-picture": "Elprimerfotogramadelarranque",
  "t-search-boot-animation": "Animacióndearranque",
  "t-search-hardware-parameter": "Parámetrosdehardware",
  "t-batch-operate-device": "Operaciónporlotesdeldispositivo",
  "t-import-device": "Importardispositivo",
  "t-apps-list": "Aplicaciones",
  "t-app-certificates": "CertificadosdeAplicación",
  "t-on-board-merchants": "ComercianteRegistrado",
  "t-device-status-tampered": "Desmontaje",
  "t-device-status-out-of-country": "Vallafueradelpaís",
  "t-device-status-out-of-fence": "Fueradegeocerca",
  "t-device-status-online": "enlínea",
  "t-device-status-offline": "fueradelínea",
  "t-device-status-disabled": "Desactivado",
  "t-edit-wallpaper": "Editarfondodepantalla",
  "t-edit-boot-picture": "Editarelprimercuadrodearranque",
  "t-edit-boot-animation": "Editaranimacióndearranque",
  "t-action-name": "Nombredelaacción",
  "t-currencyName": "Moneda",
  "t-add-hardware-parameter": "Agregarparámetrosdehardware",
  "t-edit-hardware-parameter": "Editarparámetrosdehardware",
  "t-add-system-general-parameter": "Agregarparámetrosgenerales",
  "t-edit-system-general-parameter": "Editarparámetrosgenerales",
  "t-error-push-search": "Consultapush",
  "t-boot-picture-version-saved-successfully": "Lacargadelprimerarchivodemarcodeiniciofueexitosa",
  "t-warning-unbind-device-for-group": "¿Realmentedeseasdesvinculareldispositivo-{param}?",
  "t-unbind-device-confirmation": "Desvincularconfirmacióndeldispositivo",
  "t-enable-device": "Habilitardispositivo",
  "t-warning-delete-role": "¿Estássegurodequedeseaseliminarelrol-{param}?",
  "t-confirmation-delete-role": "Eliminarconfirmaciónderol",
  "t-select-valid-manufacturer": "Porfavorseleccioneunfabricanteválido",
  "t-add-delete-device": "Agregar/eliminardispositivo",
  "t-add-tls-certificate": "AgregarcertificadoTLS",
  "t-delete-device-information-details": "Eliminardetallesdeinformacióndeldispositivo",
  "t-enable-device-information-details": "Habilitardetallesdeinformacióndeldispositivo",
  "t-disable-device-information-details": "Desactivardetallesdeinformacióndeldispositivo",
  "t-add-search-device": "Agregardispositivoalgrupo",
  "t-error-enable-device": "Seprodujounerroralhabilitareldispositivo",
  "t-error-disable-device": "Seprodujounerroraldesactivareldispositivo",
  "t-user-sourse": "Fuentedelusuario",
  "t-start-time-than-end-time-one-hour": "Lahoradeinicioplanificadaylahoradefinalizaciónplanificadadebensersuperioresatreintaminutos",
  "t-enter-tid": "IngreseTID",
  "t-enter-hardware-param-version-name": "Ingreseelnombredelparámetrodehardware",
  "t-required-hardware-param-version-name": "Elnombredelparámetrodehardwareesobligatorio-",
  "t-enter-system-general-param-version-name": "Ingreseelnombredelparámetrogeneraldelsistema",
  "t-required-system-general-param-version-name": "Elnombredelparámetrogeneraldelsistemaesobligatorio-",
  "t-import-failed-info": "Errorenlaimportación:",
  "t-import-file-not-allow-special-characters": "Elnombredelarchivocargadonopuedecontenercaracteresespeciales-",
  "t-dateYear": "Año",
  "t-num": "Cantidad",
  "t-placeholder-enter-device-secret": "Ingreseelsecretodeldispositivo",
  "t-placeholder-enter-product-key": "Ingreselaclavedelproducto",
  "t-error-enter-device-secret": "Serequiereelsecretodeldispositivo-",
  "t-error-enter-product-key": "Serequiereclavedeproducto-",
  "t-error-product-key-pattern": "Laclavedeldispositivosólopermiteletrasmayúsculasynúmeros-",
  "t-warning-delete-boot-animation": "¿Estásegurodequedeseaeliminarlaanimacióndeinicio-{param}?",
  "t-confirmation-delete-boot-animation": "Eliminarconfirmacióndeanimacióndearranque",
  "t-warning-delete-boot-picture": "¿Estásegurodequedeseaeliminarelprimermarcodeinicio-{param}?",
  "t-confirmation-delete-boot-picture": "Eliminarelprimercuadrodeconfirmacióndearranque",
  "t-warning-delete-wallpaper": "¿Estássegurodequedeseaseliminarelfondodepantalla-{param}?",
  "t-confirmation-delete-wallpaper": "Confirmacióndeeliminacióndelfondodepantalla",
  "t-delete-system-general-parameter-version-confirmation": "Eliminarconfirmacióndeversióndeparámetrosgenerales",
  "t-warning-delete-system-general-parameter-version": "¿Estásegurodequedeseaeliminarlaversióndelparámetrogeneral-{param}?",
  "t-system-general-parameter-version-deleted-successfully": "¡Laversióndelparámetrogeneral{param}seeliminóexitosamente!",
  "t-error-deleting-system-general-parameter-version": "Seprodujounerroraleliminarlaversióndelparámetrogeneral",
  "t-system-general-parameter-version": "Versióndeparámetrosgenerales",
  "t-delete-hardware-parameter-version-confirmation": "Eliminarconfirmacióndeversióndeparámetrosdehardware",
  "t-warning-delete-hardware-parameter-version": "¿Estásegurodequedeseaeliminarlaversióndelparámetrodehardware-{param}?",
  "t-hardware-parameter-version-deleted-successfully": "¡Laversióndelparámetrodehardware{param}seeliminócorrectamente!",
  "t-error-deleting-hardware-parameter-version": "Seprodujounerroraleliminarlaversióndelparámetrodehardware",
  "t-hardware-parameter-version": "Versióndeparámetrosdehardware",
  "t-system-general-parameter-version-created-successfully": "¡Laversióndelparámetrogeneral{param}fuecreadaexitosamente!",
  "t-error-creating-system-general-parameter-version": "Ocurrióunerroralcrearlaversióndelparámetrogeneral",
  "t-error-loading-system-general-parameter-version": "¡Laversióndelparámetrodehardware{param}secreócorrectamente!",
  "t-hardware-parameter-version-created-successfully": "¡Laversióndelparámetrodehardware{param}secreóexitosamente!",
  "t-error-creating-hardware-parameter-version": "Ocurrióunerroralcrearlaversióndelparámetrocomúndelsistema-",
  "t-error-loading-hardware-parameter-version": "Ocurrióunerroralcrearlaversióndelparámetrodehardware-",
  "t-boot-animation-saved-successfully": "¡Laanimacióndearranque{param}seguardóexitosamente!",
  "t-boot-picture-saved-successfully": "¡Elprimercuadro{param}delarranqueseguardóexitosamente!",
  "t-wallpaper-saved-successfully": "¡Elfondodepantalla{param}seguardócorrectamente!",
  "t-boot-animation-updated-successfully": "¡Laanimacióndearranque{param}seactualizóexitosamente!",
  "t-boot-picture-updated-successfully": "¡Elprimercuadro{param}delarranqueseactualizóexitosamente!",
  "t-wallpaper-updated-successfully": "¡Fondodepantalla{param}actualizadoexitosamente!",
  "t-error-updating-boot-animation": "Seprodujounerroralactualizarlaanimacióndeinicio",
  "t-error-updating-boot-picture": "Seprodujounerroralactualizarelprimercuadrodeinicio",
  "t-error-updating-wallpaper": "Seprodujounerroralactualizarelfondodepantalla",
  "t-error-creating-boot-animation": "Ocurrióunerroralcrearlaanimacióndearranque",
  "t-error-creating-boot-picture": "Seprodujounerroralcrearelprimermarcodeinicio",
  "t-error-creating-wallpaper": "Seprodujounerroralcrearelfondodepantalla",
  "t-error-loading-boot-animation": "Seprodujounerroralcargarlaanimacióndeinicio",
  "t-error-loading-boot-picture": "Seprodujounerroralcargarelprimercuadrodeinicio",
  "t-error-loading-wallpaper": "Seprodujounerroralcargarelfondodepantalla",
  "t-load-more": "Cargarmás",
  "t-load-earlier-records": "Ver anteriores",
  "t-timeline-hint": "Actualmente solo se muestran tareas de push del último año",
  "t-boot-animation-deleted-successfully": "¡Laanimacióndearranque{param}seeliminóexitosamente!",
  "t-boot-picture-deleted-successfully": "¡Elprimercuadro{param}delarranqueseeliminóexitosamente!",
  "t-wallpaper-deleted-successfully": "¡Elfondodepantalla{param}seeliminóexitosamente!",
  "t-error-deleting-boot-animation": "Seprodujounerroraleliminarlaanimacióndeinicio",
  "t-error-deleting-boot-picture": "Seprodujounerroraleliminarelprimermarcodeinicio",
  "t-error-deleting-wallpaper": "Seprodujounerroraleliminarelfondodepantalla",
  "t-recover-tamper-from-device": "¿Estásegurodequedeseasacareldispositivodelestadodesmontado?",
  "t-enter-otp-from-email": "PorfavoringreselaOTPdelcorreoelectrónico",
  "t-enter-authorization-times": "Ingresartiemposdeautorización",
  "t-allocate-authorization-updated-successfully": "¡Actualicelaautorizacióndeasignación{param}exitosamente!",
  "t-error-allocate-authorization-updated-times": "Ocurrióunerroralactualizarlostiemposdeautorizacióndeasignación",
  "t-list-header-updated-successfully": "¡Elencabezadodelalistaseactualizóexitosamente!",
  "t-list-header": "Encabezadodelista",
  "t-push-record": "Enviarregistro",
  "t-devices-report": "Informedeldispositivo",
  "t-dynamic-report-new": "Informedinámico-nuevo",
  "t-fixed-report-new": "Informeestático-nuevo",
  "t-functional-module": "Módulofuncional",
  "t-updated-successfully": "¡Actualizadoexitosamente!",
  "t-required-report-name": "Elnombredelinformeesobligatorio-",
  "t-required-report-attribute-name": "Elnombredelatributoesobligatorio-",
  "t-required-report-language": "Serequieretipodeidioma-",
  "t-deleted-successfully": "¡Eliminadoexitosamente!",
  "t-push-name": "Nombredeinserción",
  "t-reduce": "reducir",
  "t-increase": "aumento",
  "t-enable-tamper-auth": "Habilitarverificacióndedesmontaje",
  "t-otp": "OTP",
  "t-otp-password-sent-successfully": "¡Lacontraseñaotpseenviócorrectamente!",
  "t-authorization-times-required": "Serequiereelnúmerodevecesdeautorización",
  "t-resend-in": "Reenviar",
  "t-status-indicates-scheduled-task": "Esteestadosólosignificaqueestatareaprogramadahasidocreada-",
  "t-update-authorization-times": "Actualizartiemposdeautorización",
  "t-warning-delete-allocate-authorization": "¿Estásegurodequedeseaeliminarlaautorizacióndeasignación-{param}?",
  "t-allocate-authorization-deleted-successfully": "¡Laautorizacióndeasignación{param}seeliminóexitosamente!",
  "t-error-deleting-allocate-authorization": "¡Ocurrióunerroraleliminarlaautorizacióndeasignación!",
  "t-please-enter-authorization-times": "Porfavoringreseelnúmerodevecesdeautorización",
  "t-minimum-authorization-times": "Elnúmeromínimodeautorizacioneses1",
  "t-maximum-authorization-times": "Elnúmeromáximodetiemposdeautorizaciónes10000",
  "t-detamper": "Desatamper",
  "t-error-loading-allocate-authorization": "Seprodujounerroralcargarlaautorizacióndeasignación",
  "t-async-download": "Descargaasíncrona",
  "t-generate": "generar",
  "t-background-audio": "Audiodefondo",
  "t-upload-folder": "Carpetadecarga",
  "t-upload-folder-is-empty": "Elarchivocargadoestávacío",
  "t-upload-folder-maximum-length": "Lalongitudmáximadelarchivocargadonosuperalos100",
  "t-upload-folder-minimum-length": "Lalongitudmínimadelarchivocargadonoesinferiora1",
  "t-number-of-cycles": "númerodeciclos",
  "t-number-of-images-play-second": "Númerodereproduccionesporsegundo",
  "t-number-of-images-limited-sheets": "Elnúmerodearchivosestálimitadoa1-100hojas",
  "t-wav": "Wav",
  "t-sheets": "hojas",
  "t-number-of-5": "1-5",
  "t-customize": "personalizar",
  "t-license-information-name-required": "Elnombredelainformacióndeautorizaciónesobligatorio-",
  "t-upload-license-information-file": "Cargararchivodelicencia",
  "t-edit-license-information": "Editarcorreoelectrónicodenotificación",
  "t-error-license-information-created": "Ocurrióunerroralcrearlainformacióndelalicencia",
  "t-server-info": "Informacióndelservidordeautorización",
  "t-enable-server-authorization": "Habilitarautorizacióndelservidor",
  "t-specified-deployment-server-info": "Informacióndelservidordeimplementaciónespecificado",
  "t-ip-address": "DirecciónIPautorizada",
  "t-mac-address": "DirecciónMacautorizada",
  "t-authorization-period": "Período de Validez",
  "t-expiration-time-authorization": "Fechadevencimientodelaautorización",
  "t-buffer-after-expiration": "Tiempodegraciadespuésdelvencimientodelaautorización",
  "t-server-utc": "Lazonahorariadelservidor",
  "t-enable-pre-expiration-alarms": "Habilitaralarmaspreviasalaexpiración",
  "t-time-to-send-alarm-emails": "Cuántosdíasantesdelafechalímiteparaenviaralarmasporcorreoelectrónico",
  "t-reminder-interval": "Intervalodealarma",
  "t-licensed-nums": "Cantidad de Licencias",
  "t-num-of-devices": "Dispositivos",
  "t-num-of-keys": "Claves",
  "t-device-tamper-times": "Número de intentos de manipulación del dispositivo",
  "t-num-of-partners": "Socios",
  "t-num-of-apps-installed": "Aplicaciones instaladas",
  "t-num-of-firmwares": "Firmwares",
  "t-num-of-users": "Usuarios",
  "t-num-of-merchants": "Comerciantes",
  "t-num-of-transaction-params": "Parámetros de transacción",
  "t-send-email-notifications": "Enviaralertas",
  "t-others": "otros",
  "t-enable-ads": "Anuncios",
  "t-enable-open-api": "APIABIERTA",
  "t-remaining": "restante",
  "t-days": "天",
  "t-authorization-expiration-date": "Fechadevencimientodelaautorización",
  "t-please-charge-in-time": "Actualiceatiempo",
  "t-the-authorization-file-has-expired": "Elarchivodeautorizaciónhacaducado",
  "t-upload-authorization-file": "Cargueelarchivodeautorización",
  "t-alarm-email": "Correoelectrónicodenotificación",
  "t-enable-key-push": "Clave",
  "t-created-successfully": "Guardarexitosamente",
  "t-auth-file-parsing-failed": "Fallóelanálisisdelarchivodeautorización",
  "t-planned-push-after-auth-period": "Eltiempodeejecucióndelatareaplanificadanopuedesermayorqueelperíododevalidezdelaautorización",
  "t-expired-by": "Expirado",
  "t-task-created-successfully": "¡Latareaprogramadadelsistemasecreóexitosamente!",
  "t-error-creating-task": "Seprodujounerroralcrearunatareaprogramadadelsistema",
  "t-task-updated-successfully": "¡Latareaprogramadadelsistemaseactualizóexitosamente!",
  "t-error-updating-task": "Seprodujounerroralactualizarlatareaprogramadadelsistema",
  "t-player-second-cannot-exceed-total": "Elnúmerodejugadasporsegundonopuedeexcederelnúmerototal",
  "t-function-name": "Nombredeltipodenegocio",
  "t-key-block-value": "Valordelbloquedeclaves",
  "t-enter-key-block-value": "Ingreseelvalordelbloqueclave",
  "t-required-key-block-value": "Elvalordelbloquedeclavesesobligatorio",
  "t-enter-lmk-index": "IngreseelíndiceLMK",
  "t-required-lmk-index": "SerequiereelíndiceLMK",
  "t-required-currency-code": "Serequieremoneda",
  "t-required-country-code": "Elpaísesobligatorio",
  "t-terminal-action-analysis": "Generarcódigodeterminal",
  "t-copy-close": "Copiarycerrar",
  "t-add-tid": "AgregarTID",
  "t-update-tid": "ActualizarTID",
  "t-delete-tid": "EliminarTID",
  "t-server-mdm-delete-profile-error": "¡Elarchivodeinicializacióndelterminalestáhabilitadoynosepuedeeliminar!",
  "t-required-tid": "Tidesobligatorio",
  "t-device-to-swap": "Dispositivoaintercambiar",
  "t-swap": "intercambio",
  "t-swap-tid": "IntercambiarTID",
  "t-menu-start-color": "Colordeiniciodelmenú",
  "t-menu-end-color": "Colorfinaldelmenú",
  "t-menu-text-color": "Colordeltextodelmenú",
  "t-partner-icon": "Logotipodelportaldesocios",
  "t-cloud-message-push-history": "Historialdeenvíodemensajesenlanube",
  "t-push-history": "Historialdeenvío",
  "t-expiry-unlimited": "Indefinidamente",
  "t-enable-cloud-messaging": "mensajeríaenlanube",
  "t-receipt-layout-details": "Detallesdeldiseñodelrecibo",
  "t-receipt-type": "tipoderecibo",
  "t-layout-name": "nombredeldiseño",
  "t-receipt-layout": "diseñodelrecibo",
  "t-receipt-created": "Crearrecibo",
  "t-receipt-updated": "Reciboactualizado",
  "t-default-layout": "Diseñopredeterminado",
  "t-add-new-row": "Agregarnuevafila",
  "t-add-new-column": "Agregarnuevacolumna",
  "t-create-row": "Crearfila",
  "t-update-row": "Actualizarfila",
  "t-other": "otro",
  "t-full-screen": "pantallacompleta",
  "t-display": "pantalla",
  "t-row-number": "númerodefila",
  "t-text-style": "Estilodetexto",
  "t-text-align": "Alineacióndetexto",
  "t-receipt-rows": "filasderecibos",
  "t-label": "etiqueta",
  "t-onboard-merchant": "Comercianteregistrado",
  "t-feitian-iam": "plataforma de autenticación de Feitian",
  "t-feitian-partner": "plataforma de socios de Feitian",
  "t-user-activated": "Elusuariocomerciantehasidoactivado",
  "t-error-user-activation": "Ocurrióunerroralactivarelusuariocomerciante",
  "t-mobile-activated": "Elteléfonomóvilhasidoactivado",
  "t-kyc-completed": "KYCcompletado",
  "t-onboard-application": "Comercianteregistrado",
  "t-personal": "informaciónpersonal",
  "t-mobile-number": "Númerodeteléfonomóvil",
  "t-date-of-birth": "fechadenacimiento",
  "t-enter-date-of birth": "Porfavoringresalafechadenacimiento",
  "t-citizenship": "nacionalidad",
  "t-company": "Informacióndelaempresa",
  "t-country-of-registration": "Paísderegistro",
  "t-legal-form": "Formajurídica",
  "t-company-name": "Nombredelaempresa",
  "t-contact-number": "Númerodecontacto",
  "t-contact-person": "Personadecontacto",
  "t-business-sector": "SectorEmpresarial",
  "t-business-activity": "actividadempresarial",
  "t-registered-company-street": "Calledelaempresaregistrada",
  "t-registered-company-house-number": "Númerodedomiciliosocialregistrado",
  "t-registered-company-city": "Ciudaddelaempresaregistrada",
  "t-registered-company-zip": "Códigopostaldelaempresaregistrada",
  "t-registered-company-country": "Paísdelaempresaregistrada",
  "t-tax-country": "Paísdeimpuestos",
  "t-tax-id": "Númeroderegistrofiscal",
  "t-bank": "Informaciónbancaria",
  "t-account-holder-name": "Nombredeltitulardelacuenta",
  "t-account-type": "Tipodecuenta",
  "t-account-currency": "Monedadelacuenta",
  "t-bank-name": "Nombredelbanco",
  "t-account-number": "númerodecuenta",
  "t-additional": "Informaciónadicional",
  "t-intent-of-use": "Intencióndeuso",
  "t-source-of-use": "fuentedeingresos",
  "t-annual-turnover-foresee": "Facturaciónanualestimada",
  "t-expected-average-transaction-amount": "Montopromedioesperadodetransacción",
  "t-online-channel": "Canalenlínea",
  "t-documents": "documentos",
  "t-bank-statement": "Extractobancario",
  "t-id-proof": "Pruebadeidentidad",
  "t-address-proof": "Pruebadedirección",
  "t-address-proof1": "Pruebadedirección1",
  "t-alert-mgmt": "Gestióndenotificaciones",
  "t-alert-settings": "Configuracióndealarma",
  "t-add-alert": "Agregarconfiguracióndealarma",
  "t-edit-alert": "Editarconfiguracióndealarma",
  "t-notice-name": "Nombredelanotificación",
  "t-notice-start-time": "Avisodehoraefectiva",
  "t-alert-level-info": "General",
  "t-alert-level-warn": "advertencia",
  "t-alert-level-critical": "grave",
  "t-day-and-time": "semana",
  "t-notifying-email": "correoelectrónico",
  "t-add-alert-contacts-group": "Agregargrupodecontactos",
  "t-edit-contacts-group": "Editargrupodecontactos",
  "t-search-alert-contacts-group": "Buscarnombredelgrupodecontactos",
  "t-contacts-group-name": "nombre",
  "t-enter-contacts-group-name": "Ingreseelnombredelgrupodecontactos",
  "t-error-contacts-group-name-required": "Elnombredelgrupodecontactosesobligatorio",
  "t-warning-delete-contactGroup": "¿Estásegurodequedeseaeliminarelgrupodecontactos-{param}?",
  "t-add-alert-policy": "Agregarpolítica",
  "t-edit-alert-policy": "Editarpolítica",
  "t-search-alert-policy": "Nombredelapolíticadebúsqueda",
  "t-warning-delete-policy": "¿Estásegurodequedeseaeliminarlapolítica-{param}?",
  "t-policy-name": "nombre-política-t",
  "t-enter-policy-name": "Porfavoringreseelnombredelapolítica",
  "t-error-policy-name-required": "Elnombredelapolíticaesobligatorio",
  "t-error-policy-rule-template-required": "Serequiereplantilladeregla",
  "t-add-alert-contacts-user": "Agregarcontactos",
  "t-edit-contacts-user": "Editarcontactos",
  "t-search-alert-contacts-user": "Nombredebúsqueda",
  "t-attestation": "Autenticación",
  "t-add-attestation": "Agregarautenticación",
  "t-error-attestation-created": "Seprodujounerroralcrearlaautenticación",
  "t-error-attestation-updated": "Seprodujounerroralactualizarlaautenticación",
  "t-attestation-updated-successfully": "Actualizacióndeautenticaciónexitosa",
  "t-attestation-created-successfully": "Autenticacióncreadaexitosamente",
  "t-attestation-deleted-successfully": "¡Eliminacióndeautenticaciónexitosa!",
  "t-error-deleting-attestation": "Seprodujounerroraleliminarlaatestación",
  "t-search-attestation": "Autenticacióndebúsqueda",
  "t-warning-delete-attestation": "¿Estásegurodequedeseaeliminarlacertificación-{param}?",
  "t-error-deleting-attestation-version": "Seprodujounerroraleliminarlaversióndelaatestación",
  "t-attestation-history": "Historialdeautenticación",
  "t-old-rule": "antiguaregla",
  "t-new-rule": "Nuevaregla",
  "t-view": "ver",
  "t-attestation-monitor": "Monitordeautenticación",
  "t-alert-status-info-unread": "noleído",
  "t-notice-default-rule": "Regla",
  "t-add-rule": "Agregarplantilladeregla",
  "t-edit-rule": "Editarplantilla",
  "t-search-rule": "Plantilladeregladebúsqueda",
  "t-enter-alert-rule-name": "Porfavoringreseelnombredelaregla",
  "t-error-alert-rule-name-required": "Elnombredelareglaesobligatorio",
  "t-error-alert-name-required": "Elnombredelaalarmaesobligatorio",
  "t-rule-template-fence-template-name": "Alarmadevallaelectrónica",
  "t-alert-rule-updated-successfully": "¡Plantilladeregla{param}actualizadaexitosamente!",
  "t-rule-template-tampered-template-name": "Alarmadedesmontajedeldispositivo",
  "t-enable-tampered-alert": "Habilitaralarmademanipulación",
  "t-enable-out-of-country": "Habilitaralarmadecercadelpaís",
  "t-email-message": "mensajedecorreoelectrónico",
  "t-error-delay-time-required": "Serequiereelsiguienteintervalodenotificación",
  "t-error-delay-time-max": "Intervalomáximodesiguientenotificación:",
  "t-error-delay-time-min": "Intervalomáximodesiguientenotificación:1",
  "t-error-alert-channel-required": "Serequierecanaldenotificación",
  "t-error-alert-weeks-required": "Serequierensemanasdenotificación",
  "t-add-email-alert-template": "Agregarplantilladealertadecorreoelectrónico",
  "t-add-alert-alarm-template": "Agregarplantilladealarmadecorreoelectrónico",
  "t-update-alert-template": "Modificarplantilladealertadecorreoelectrónico",
  "t-search-alert-alarm-template": "Títulodelaplantilla",
  "t-please-select-the-person-to-alert": "Porfavorseleccionelapersonaaalertar",
  "t-alert-settings-created-successfully": "¡Laconfiguracióndealarma{param}secreóexitosamente!",
  "t-error-created-alert-settings": "Seprodujounerroralcrearlaconfiguracióndealerta",
  "t-alert-settings-updated-successfully": "¡Laconfiguracióndealarma{param}semodificócorrectamente!",
  "t-error-update-alert-settings": "Ocurrióunerroralmodificarlaconfiguracióndelaalarma",
  "t-alert-settings-deleted-successfully": "¡Eliminarlaconfiguracióndealarma{param}seeliminócorrectamente!",
  "t-error-deleting-alert-settings": "¡Ocurrióunerroraleliminarlaconfiguracióndealarma!",
  "t-contacts-user-created-successfully": "¡Usuariodecontactocreadoexitosamente!",
  "t-error-created-contacts-user": "Seprodujounerroralcrearelusuariodecontactos",
  "t-contacts-user-updated-successfully": "¡Elusuariodecontacto{param}semodificóexitosamente!",
  "t-error-update-contacts-user": "Ocurrióunerroralmodificarelusuariodelcontacto",
  "t-contacts-user-deleted-successfully": "¡Elusuariodecontacto{param}fueeliminadoexitosamente!",
  "t-error-deleting-contacts-user": "¡Ocurrióunerroraleliminarelusuariodecontactos!",
  "t-contacts-group-created-successfully": "¡Elgrupodecontactos{param}secreóexitosamente!",
  "t-error-created-contacts-group": "Ocurrióunerroralcrearelgrupodecontactos",
  "t-contacts-group-updated-successfully": "¡Elgrupodecontactos{param}semodificóexitosamente!",
  "t-error-update-contacts-group": "Ocurrióunerroralmodificarelgrupodecontactos",
  "t-contacts-group-deleted-successfully": "¡Eliminarelgrupodecontactos{param}exitosamente!",
  "t-error-deleting-contacts-group": "¡Ocurrióunerroraleliminarelgrupodecontactos!",
  "t-alerts-policy-created-successfully": "¡Lapolíticadealarma{param}secreóexitosamente!",
  "t-error-created-alerts-policy": "Ocurrióunerroralcrearlapolíticadealerta",
  "t-alerts-policy-updated-successfully": "¡Lapolíticadealarma{param}semodificóexitosamente!",
  "t-error-update-alerts-policy": "Ocurrióunerroralmodificarlapolíticadealarma",
  "t-alerts-policy-deleted-successfully": "¡Eliminelapolíticadealarma{param}exitosamente!",
  "t-error-deleting-alerts-policy": "¡Ocurrióunerroraleliminarlapolíticadealarma!",
  "t-alert-template-created-successfully": "¡Laplantilladecorreoelectrónicodealarma{param}secreócorrectamente!",
  "t-alert-template-updated-successfully": "¡Laplantilladecorreoelectrónicodealarma{param}semodificócorrectamente!",
  "t-error-updated-email-alert-template": "Seprodujounerroralmodificarlaplantilladecorreoelectrónicodealarma",
  "t-error-created-email-alert-template": "Seprodujounerroralmodificarlaplantilladecorreoelectrónicodealarma",
  "t-error-alert-email-template-title-required": "Eltítulodelaplantilladecorreoelectrónicodealarmaesobligatorio",
  "t-error-alert-email-template-subject-required": "Elasuntodelaplantilladecorreoelectrónicodealarmaesobligatorio",
  "t-error-update-alert-logs": "Ocurrióunerroralmodificarelestadodelregistrodealarmas",
  "t-alert-logs-updated-successfully": "Modificarelestadodelregistrodealarmasexitosamente",
  "t-notifier": "notificador",
  "t-minimum-mobile-phone-number": "Elnúmerodeteléfonomóvildebeteneralmenos8dígitos",
  "t-maximum-mobile-phone-number": "Elnúmerodeteléfonomóvilpuedetenerhasta50dígitos",
  "t-phone-duplicate": "Copiar el teléfono",
  "t-email-duplicate": "Correo electrónico duplicado",
  "t-select-valid-user-or-partner": "Porfavorseleccionelapersonadecontactonecesaria",
  "t-add-sms-gateway": "AgregarpuertadeenlaceSMS",
  "t-edit-sms-gateway": "EditarpuertadeenlaceSMS",
  "t-enable-sms-success": "LaconfiguracióndeSMSsehabilitócorrectamente",
  "t-enable-sms-close": "LaconfiguracióndeSMSsecerrócorrectamente",
  "t-enable-sms-fail": "ErrorenlaoperacióndeestadodeSMS",
  "t-sms-deleted": "¡LaconfiguracióndeSMSseeliminócorrectamente!",
  "t-error-deleting-sms-settings": "¡OcurrióunerroraleliminarlaconfiguracióndeSMS!",
  "t-delete-sms-error": "¡LaconfiguracióndeSMSestáhabilitadaynosepuedeeliminar!",
  "t-sms-settings-created-successfully": "¡Laconfiguracióndet-SMSsecreóexitosamente!",
  "t-error-create-sms-settings": "¡t-ErroralcrearlaconfiguracióndeSMS!",
  "t-sms-settings-updated-successfully": "¡LaconfiguracióndeSMSseactualizócorrectamente!",
  "t-error-updated-sms-settings": "OcurrióunerroralmodificarlaconfiguracióndeSMS",
  "t-sms-settings-accessKeySecret": "Clavedeaccesosecreta",
  "t-error-sms-settings-accessKeyId-required": "SerequierelaclavedeaccesoenlaconfiguracióndeSMS",
  "t-error-sms-settings-accessKeySecret-required": "SerequiereclavedeaccesosecretaenlaconfiguracióndeSMS",
  "t-error-sms-settings-signName-required": "ElnombredelafirmaenlaconfiguracióndeSMSesobligatorio",
  "t-error-silence-time-required": "Serequieretiempodesilencio",
  "t-error-silence-time-min": "Eltiempodesilencioesdealmenos5minutos",
  "t-error-silence-time-max": "Eltiempomáximodesilencioes1440minutos",
  "t-enable-manufacturer": "fabricante",
  "t-enable-tls-certificate": "certificadoTLS",
  "t-enable-ticket": "ticket",
  "t-enable-merchant-user": "comercianteregistrado",
  "t-enable-attestation": "autenticación",
  "t-enable-sms": "configuracióndeSMS",
  "t-enable-hsm": "HSM",
  "t-enable-geo-fence": "geocerca",
  "t-enable-messages": "mensajes",
  "t-enable-report": "informe",
  "t-enable-transaction-param": "Parámetro de Transacción",
  "t-enable-cortex-scanner": "Escáner Cortex",
  "t-enable-system-health": "Salud del Sistema",
  "t-enable-task-scheduler": "Programador de Tareas",
  "t-enable-feitian-partner": "Socio FeiTian",
  "t-enable-feitian-iam": "IAM de FeiTian",
  "t-enable-static-report": "informe estático",
  "t-enable-customize-report": "informe de componentes",
  "t-enable-widget-report": "informe dinámico",
  "t-enable-report-setting": "configuracióndeinformes",
  "t-enable-otp": "MFA",
  "t-enable-notice": "Gestióndealarmas",
  "t-enable-tamper": "laeliminacióndelaautorizacióndedesmontaje",
  "t-public-platform-type": "Plataformadenubepública",
  "t-use-password-length": "Elrangodelongituddelacontraseñaes4-32",
  "t-license-id": "IDdeautorización",
  "t-user-deleted-successfully": "¡Eliminarusuario{param}exitosamente!",
  "t-error-deleting-user": "¡Ocurrióunerroraleliminaralusuario!",
  "t-bind-unbind": "vincular/desvincular",
  "t-device-has-been-bind-other-partner": "Haydispositivosvinculadosaotrossociosenlalistadedispositivos(hagaclicparadescargar)",
  "t-device-has-been-bind-other": "Haydispositivosvinculadosaotrossocios/clientes/comerciantes/tiendasenlalistadedispositivos",

  "tool": {
    "routerTitle": "Configuracióndeinformes",
    "addbtn": "Agregarcategoría",
    "reportName": "Nombredelinforme",
    "createTime": "Horadecreación",
    "createBy": "Creador",
    "updateTime": "horadeactualización",
    "updateBy": "Actualizarpor",
    "reportType": "Tipodeinforme",
    "universal": "universal",
    "custom": "controlar",
    "popUp": "¿Estásegurodequedeseaeliminarelinforme-{param}?",
    "delectTool": "Eliminarinforme",
    "sortAllocation": "Configuracióndeclasificación",
    "conditions": "condiciones",
    "attributeCode": "códigodeatributo",
    "attributeName": "Nombredelatributo",
    "dataType": "tipodedatos",
    "enumeratedValue": "valorenumerado",
    "enumerationName": "nombredeenumeración",
    "sortDigit": "Ordenarnúmeros",
    "associatedPath": "rutaasociada",
    "associationSQL": "asociaciónSQL",
    "chartType": "tipodegráfico",
    "chartSQL": "ChartSQL",
    "internationalization": "internacionalización",
    "languageType": "tipodeidioma",
    "remark": "observaciones",
    "pleaseEnter": "Porfavoringrese",
    "pieChart": "gráficocircular",
    "barChart": "Gráficodebarras",
    "lineChart": "gráficodelíneas",
    "string": "cadena",
    "time": "tiempo",
    "timeFrame": "plazo",
    "enumeration": "enumeración",
    "year": "año",
    "month": "mes",
    "report": "informe"
  },
  "charts": {
    "fixedReport": "informeestático",
    "dynamicReport": "informedinámico",
    "search": "buscar",
    "export": "exportar",
    "editHeader": "Editartítulodelista",
    "log": {
      "routerTitle": "Enviarregistro",
      "partner": "socio",
      "customer": "cliente",
      "merchant": "comerciante",
      "store": "tienda",
      "modelCode": "Versióndelmodelo",
      "perform": "Realizaracción",
      "execution": "tiempodeejecución",
      "result": "estado",
      "resultCause": "razón",
      "push.name": "nombre"
    },
    "device": {
      "routerTitle": "Dispositivo",
      "sn": "númerodeserie",
      "imei": "IMEI",
      "tid": "TID",
      "signalStrength": "Red",
      "status": "activado",
      "activateTime": "horadeactivación",
      "tamper": "Desmontaje",
      "modelVersionName": "Versióndelmodelo",
      "buildNum": "númerodeversión",
      "spBootloader": "cargadordearranqueSP",
      "spFirmware": "FirmwareSP",
      "smaVersionCode": "NúmerodeversióndeSMA",
      "longitude": "latitudylongitud",
      "keyName": "Clave",
      "partnerName": "Socio",
      "customerName": "cliente",
      "merchantName": "comerciante",
      "storeName": "tienda",
      "merchantEmail": "Correoelectrónicodelcomerciante",
      "storeEmail": "almacenarcorreoelectrónico",
      "merchantPhone": "Teléfonodelcomerciante",
      "storePhone": "almacenarteléfono",
      "merchantAddress": "Direccióncomerciante",
      "storeAddress": "direccióndelatienda",
      "merchantWebsite": "SitioWebcomerciante",
      "storeWebsite": "storeWebsite",
      "currency": "moneda",
      "groupName": "grupo",
      "countryName": "región",
      "lastOnlineTime": "Últimavezenlínea",
      "lastDataUpdatedTime": "Últimahoradeactualizacióndedatos",
      "lastFactorySettingTime": "Últimahoraderestablecimientodefábrica",
      "mid": "medio"
    },
    "model": {
      "head": "Encabezadodelista",
      "applications": "Aplicaciones(hasta3)"
    }
  },
  "t-api-key": "ClaveAPI",
  "t-api-secret": "APISecreta",
  "t-online-status": "Estadoenlínea",
  "t-api-logs": "RegistrosdeAPI",
  "t-api-parameters": "Parámetrosdesolicitud",
  "t-click-or-drag-file-upload-file": "Hagaclicoarrastreelarchivoaestaáreaparacargarlo",
  "t-input-invalid-pattern-special-char-name": "Compuesto por números, letras, guiones bajos, puntos,coma, espacios y …, &, (, ), -, /, @, y no puede comenzar ni terminar con espacios.",
  "t-cancel-message": "Cancelarmensaje",
  "t-cancel-ad": "Cancelar el Planificador de Publicidad",
  "t-warning-to-cancel-message": "¿Estássegurodequedeseascancelarelmensaje?",
  "t-warning-to-cancel-ad": "¿Estássegurodequedeseascancelarelanuncio?",
  "t-select-device-for-operation": "Seleccioneeldispositivoparalaoperaciónporlotes",
  "t-select-operation-for-performed": "Porfavorseleccionelasoperacionesarealizarenlotes",
  "t-themes": "tema",
  "t-theme-customizer": "Personalizadordetemas",
  "t-layout": "diseño",
  "t-choose-layout": "Elegirdiseño",
  "t-color-scheme": "Esquemadecolores",
  "t-choose-color-scheme": "Eligeunesquemaclarouoscuro",
  "t-sidebar": "barralateral",
  "t-choose-sidebar-size": "Eligeeltamañodelabarralateral",
  "t-sidebar-color": "Colordelabarralateral",
  "t-choose-sidebar-color": "Eligeuncolordebarralateralclarouoscuro",
  "t-choose-sidebar-image": "Eligelaimagendelabarralateral",
  "t-light": "colordeluz",
  "t-dark": "oscuro",
  "t-vertical": "vertical",
  "t-horizontal": "horizontal",
  "t-small": "pequeño",
  "t-gradient": "gradiente",
  "t-add-more-notifier-tips": "Paraagregarmúltiplescontactos,use\",\"parasepararlos",
  "t-items": "elementos",
  "t-push.abort.successfully": "¡Cancelarelenvíoexitosamente!",
  "t-events": "eventos",
  "t-event": "evento",
  "t-working-time-period": "periododetiempodetrabajo",
  "t-repetition-interval-time": "tiempodeintervaloderepetición",
  "t-means-of-notification": "Métododenotificación",
  "t-close-left-tabs": "Cerrarpestañasdelaizquierda",
  "t-close-right-tabs": "Cerrarlaspestañascorrectas",
  "t-close-other-tabs": "Cerrarotraspestañas",
  "t-parameter-settings": "Configuración de parámetros",
  "t-transaction-mgmt": "Gestión de transacciones",
  "t-restore-default": "Restore Default",
  "t-device-extend-attribute": "Atributo extendido del dispositivo",
  "t-device-life-cycle": "Ciclo de vida del dispositivo",
  "t-otp-type-ft": "OTP Mobile",
  "t-otp-type-feitian": "Feitian OTP",
  "t-otp-type-google": "Google Authenticator",
  "t-otp-google-download-detail": "Descargar e instalar",
  "t-otp-google-download-detail-2": "En tu teléfono",
  "t-otp-install-notes": "Instrucciones de instalación",
  "t-otp-mobile-download": "Descargue una aplicación OTP Mobile",
  "t-error-enter-otp-code": "¡La contraseña dinámica es de 6 - 10 dígitos de longitud!",
  "t-scan-QRCode": "Escanear el código QR",
  "t-scan-QRCode-detail": "Abra la aplicación de autenticación y use la cámara de su teléfono para escanear la imagen a la izquierda",
  "t-otp-google-download": "Descargue la aplicación de autenticación",
  "t-google-otp-link-invalid": "Fallo en la activación del autenticador: El enlace no es válido",
  "t-product-model": "Modelo del producto",
  "t-release-time": "Fecha de lanzamiento",
  "t-wallpaper-format": "Formato del fondo de pantalla",
  "t-bootPicture-format": "Formato de la imagen de inicio",
  "t-BootAnimation-format": "Formato de la animación de inicio",
  "t-model-version-identification": "Identificación de la versión del modelo",
  "t-enable-device-extend-attribute": "Atributo extendido del dispositivo",
  "t-enable-device-life-cycle": "Ciclo de vida del dispositivo",
  "t-is-empty": "{param} No puede estar vacío",
  "t-error-updating-device-extend-attribute-value": "Se produjo un error al actualizar el valor del atributo extendido del dispositivo",
  "t-enter-attribute-value": "Ingrese el valor del atributo extendido",
  "t-server-attribute-type-string": "Longitud del valor del atributo: 0-50; Formato: letras, números",
  "t-server-attribute-type-integer": "El valor del atributo debe estar entre 0 y 65535",
  "t-server-attribute-type-boolean": "El valor del atributo es de tipo booleano. Por favor, verifique y modifique",
  "t-device-extend-attribute-value-updated-successfully": "¡El valor del atributo extendido del dispositivo se ha actualizado correctamente!",
  "t-export-to-csv": "Exportación a CSV",
  "t-tooltip-device-tid": "SN、TID",
  "t-tid-list": "TID List",
  "t-device-life-cycle-desc": "Ciclo de Vida Descripción",
  "t-device-life-cycle-modifyTime": "Ciclo de vida ModifyTime",
  "t-fence-boundary": "Límite de la cerca",
  "t-more": "Más",
  "t-visual-range": "Abierto a",
  "t-belong-to": "Mover a",
  "t-belong-to-application": "Mover a la aplicación",
  "t-belong-to-firmware": "Mover al firmware",
  "t-global-visibility": "Todo",
  "t-specified-range": "Jerarquía autorizada",
  "t-not-open-to": "No Abierto a",
  "t-shared-data-already-exists": "Ya existe una asignación de rango del mismo nivel. Si necesita hacer cambios, elimine primero el rango especificado existente antes de agregar el nuevo rango especificado.",
  "t-partner-users-cannot-add-partner-data": "No se permite seleccionar los datos de socio vinculados a uno mismo.",
  "t-belong-to-firmware-error": "El rango especificado no puede estar vacío",
  "t-remember-password": "Espera, recuerdo mi contraseña...",
  "t-log-in-again": "Espera, necesito iniciar sesión de nuevo...",
  "t-select-device-exist-disable-device": "El dispositivo seleccionado contiene dispositivos desactivados.",
  "t-select-device-exist-inactive-device": "El dispositivo seleccionado contiene dispositivos no activados",
  "t-device-sma-version-not-support": "FALLA, VERSIÓN SMA DEL DISPOSITIVO DE ENVÍO NO SOPORTADA",
  "t-owner": "Owner",
  "t-operator": "Operator",
  "t-support-format": "Apoyo al formato",
  "t-support-resolution": "Apoyo a la resolución",
  "t-device-life-cycle-bulk-upload": "Subida masiva del ciclo de vida del dispositivo",
  "t-import-device-life-cycle-information-details": "Detalles de la importación de la información del ciclo de vida del dispositivo",
  "t-have-joined-download-queue": "En proceso",
  "t-key-value-length-is-too-long": "LA LONGITUD DEL VALOR DE LA CLAVE ES DEMASIADO LARGA",
  "t-pad-mode": "Pad Mode Identifier",
  "t-key-not-support-pad-mode-type": "Not Support Pad Mode Type",
  "t-cipher-by-pubKey": "Cifrado por clave pública",
  "t-not-export": "No exportado",
  "t-exported": "Exportado",
  "t-key-has-been-changed": "La clave ha sido cambiada",
  "t-marker": "Marcador",
  "t-export-device-public-key": "Exportar clave pública",
  "t-import-tid-device-tid-conflict": "Existe un conflicto entre el TID del dispositivo y el TID en el archivo importado",
  "t-please-enter-account-password": "Por favor, ingrese la contraseña de su cuenta",
  "t-authorization-file": "archivo de autorización",
  "t-select-device-unbind": "Seleccione el dispositivo para desvincular",
  "t-signature-name": "Firma Nombre",
  "t-select-installed-numbers": "Solo se admite la selección de hasta tres archivos APK",
  "t-success-process-message": "oh, sí, has manejado este mensaje de alarma con éxito.",
  "t-fail-process-message": "oh, sí, no has podido procesar este mensaje de alarma.",
  "t-device-apk-password-length": "La contraseña debe tener solo 6 caracteres.",
  "t-no-permission": "El usuario no tiene acceso al sistema STORM. Por favor, contacte al administrador.",
  "t-hsm-message-header": "Cabecera de mensaje HSM",
  "t-direct-connection": "Conexión directa",
  "t-username-password": "Usuario y contraseña",
  "t-tls-certificate-connect": "Certificado TLS",
  "t-client-ks-certificate": "Certificado de cliente (.ks)",
  "t-client-ks-password": "Contraseña del certificado de cliente",
  "t-ca-ts-certificate": "Certificado CA (.ts)",
  "t-ca-ts-password": "Contraseña del certificado CA",
  "t-cert-uploaded": "Cargado",
  "t-cert-not-uploaded": "No cargado",
  "t-push-device-information": "Atención: La interfaz de envío solo muestra dispositivos activados, excepto al enviar el comando de activación, donde solo se muestran dispositivos no activados.",
  "t-delete-push-success": "Eliminación de la notificación enviada con éxito",
  "t-warning-to-delete-push-scheduled-tasks": "¿Está seguro de eliminar las tareas programadas de envío?",
  "t-app-uninstall-block": "App Uninstall Block",
  "t-app-password": "App Password",
  "t-mfa-type": "MFA Type",
  "t-only-add-up-to-10-items-events": "Sólo añadir hasta 10 eventos de elementos.",
  "t-search-name-sn": "Name、SN",
  "t-search-name-version": "Name、Version",
  "t-recorded-in-audit": "Solo registrado en el registro de auditoría",
  "t-device-status-active-key-not-exist": "Clave pública no existe",
  "t-pos-server-version": "Versión POS Serve",
  "t-transaction-param-version-json-desc": "(STORM ya ha integrado automáticamente TID y MID en Json según SN, por lo que no necesita configurar TID y MID dentro del Json. Si aún configura TID y MID, usaremos su versión)",
  "t-select-algorithm": "Seleccione el algoritmo",
  "t-direct-push-success": "Empuje directo exitoso",
  "t-app-file-upload-right-spec": "Los nombres de archivo solo admiten letras, números, guiones bajos y el punto inglés.",
  "t-range": "Rango",
  "t-add-more-package-name-tips": "Para agregar varios nombres de paquete, utilice una coma (,) para separarlos",
  "t-authorization-has-expired-contact-administrator": "La autorización ha expirado, por favor contacte al administrador",
  "t-confirm-modify-password": "Contraseña caducada: Su contraseña no se ha cambiado en más de {param} días. Restablézcala para continuar.",
  "t-static-report": "Informe Estático",
  "t-customize-time-before-days": "¿Hace cuántos días personalizaste",
  "t-report_export_successfully": "Exportado con éxito, vaya a \"Descarga de informes\" para descargar",
  "t-report-type": "Tipo de informe",
  "t-chart-type": "Tipo de Chart",
  "t-confirm-stop": "¿Estás seguro de que quieres detener este registro?",
  "t-enter-maximum-package": "Introduzca un máximo de 3 nombres de paquete, separados por comas",
  "t-log-capture-stop": "Captura detenida",
  "t-schedule": "Programar",
  "t-data-scope": "Ámbito de datos",
  "t-report-data-range": "Rango de datos del informe",
  "t-table-head": "Encabezado de tabla",
  "t-visual-widget": "Widget Visual",
  "t-custom-report": "Informe Personalizado",
  "t-generate-schedule": "Generar agenda",
  "t-authorized-list": "Lista Autorizada",
  "t-pushed": "Empujado",
  "t-search-criteria": "Criterios de búsqueda",
  "t-days-range": "Rango de días",
  "t-maximum-json-length": "La longitud máxima admitida para JSON es de 32,000 caracteres",
  "t-push-status-same-file-exist": "Fallo, el mismo archivo existe",
  "t-push-status": "Push Status",
  "t-app": "Aplicación",
  "t-only-show-groups-with-available-devices": "Mostrar solo grupos con dispositivos disponibles",
  "t-only-show-available-devices": "Mostrar solo grupos con dispositivos disponibles",
  "t-licensed-features": "Funciones con Licencia",
  "t-period": "Período",
  "t-device-is-disabled-status": "El dispositivo está deshabilitado, por favor actívelo",
  "t-send-type": "Tipo de envío",
  "t-smtp": "SMTP",
  "t-sendgrid": "SendGrid",
  "t-key-capture-device-encrypted-key-not-exist": "La clave de cifrado del no existe",
  "t-select-all-device-note": "Nota: La captura de teclas se realizará en todos los dispositivos dentro del rango especificado que se encuentren en estado activo y funcionando correctamente.",
  "t-select-device": "Seleccione el dispositivo",
  "t-select-group": "Seleccione el grupo",
  "t-all-device": "Todos los dispositivos",
  "t-all-group": "Todos los grupo",
  "t-proxy-settings": "Configuración del canal de descarga",
  "t-download-setting": "Configuración de descarga",
  "t-proxy": "Proxy",
  "t-mpush": "MPUSH",
  "t-mqtt": "MQTT",
  "t-download-directly": "Amazon S3",
  "t-cdn-download": "AWS Cloud Front",
  "t-platform-download": "Servicio de plataforma STORM",
  "t-feitian-proxy": "Proxy por FT",
  "t-proxy-service-by-ip": "Servidor proxy Feitian (IP)",
  "t-proxy-service-by-domain": "Servidor proxy Feitian (dominio)",
  "t-proxy-service": "Servicio de proxy",
  "t-successful-push-tasks": "Tareas de Push exitosas",
  "t-all-push-tasks": "Todas las tareas de Push",
  "t-real-time-logs": "Depuración remota ADB",
  "t-issue-the-command": "Comando",
  "t-communication-log": "Registro de comunicación",
  "t-refresh-interval": "Intervalo de actualización",
  "t-local-log": "Registro local",
  "t-keywords": "Palabras clave",
  "t-start-scraping": "Iniciar Extracción",
  "t-stop-scraping": "Detener Extracción",
  "t-only-supported-high-version": "Solo válido para SMA 100517 y versiones superiores",
  "t-only-supported-high-version-old-version-prompt-Upgrade": "Solo aplicable para SMA 100517 y versiones superiores; las versiones inferiores solo indican la necesidad de actualizar",
  "t-overwrite": "sobrescribir",
  "t-append": "agregar",
  "t-user-login-stats": "Registros de inicio de sesión",
  "t-search-by-user": "Buscar por usuario",
  "t-new-login-count": "Número de inicios de sesión en la nueva versión",
  "t-old-login-count": "Número de inicios de sesión en la versión anterior",
  "t-last-login-time": "Hora del último inicio de sesión",
  "t-data-load-failed": "Error al cargar los datos",
  "t-new-storm": "Nuevo STORM",
  "t-login-type": "Página de inicio de sesión",
  "t-google-maps-error-tips": "Error al cargar el mapa. Por favor, verifique su conexión de red o inténtelo de nuevo más tarde.",
  "t-frequent-operations-try-again-later": "Operaciones frecuentes, por favor espere e intente nuevamente más tarde",
  "t-captcha-required": "Por favor complete la verificación deslizante",
  "t-captcha-length-error": "La longitud del código de verificación debe ser de {param} dígitos",
  "t-captcha-error": "Código de verificación incorrecto, por favor ingréselo nuevamente",
  "t-captcha-success": "Verificación exitosa",
  "t-captcha": "Código de verificación",
  "t-captcha-input-placeholder": "Ingrese el código de verificación",
  "t-captcha-expired": "El código de verificación ha expirado, por favor ingréselo nuevamente",
  "t-captcha-slide-to-verify": "Arrastra el control deslizante para completar la verificación",
  "t-captcha-verify-success": "Verificación exitosa",
  "t-unlock-user": "Desbloquear usuario",
  "t-lock-user": "Bloquear usuario",
  "t-user-locked-successfully": "Usuario bloqueado exitosamente",
  "t-user-unlocked-successfully": "Usuario desbloqueado exitosamente",
  "t-warning-lock-user": "¿Está seguro de que desea bloquear este usuario?",
  "t-warning-unlock-user": "¿Está seguro de que desea desbloquear este usuario?",
  "t-change-the-password-error-protect": "Activar protección contra errores de contraseña",
  "t-more-wrong-password-temporarily-locking": "Número de intentos de contraseña incorrecta consecutivos. Al alcanzar este número, la cuenta será bloqueada temporalmente [Valor: 5-10]",
  "t-more-wrong-password-permanently-locking": "Número acumulado de intentos de contraseña incorrecta. Al alcanzar este número, la cuenta será bloqueada permanentemente y requerirá intervención de administrador para desbloquearla [Valor: 10-30]",
  "t-temporarily-locking-automatically": "Una vez que la cuenta está bloqueada temporalmente, se desbloqueará automáticamente después del tiempo establecido aquí (minutos) [Valor: 5-60]",
  "t-dict": "Configuración de variables del sistema",
  "t-dictionary": "Parámetros",
  "t-dictionary-type": "Tipo de parámetro",
  "t-enabled": "Enabled",
  "t-disabled": "Disabled",
  "t-dict-data": "Datos de parámetros",
  "t-dict-label": "Etiqueta del parámetro",
  "t-dict-value": "Valor del parámetro",
  "t-rca-logs": "RCA Logs",
  "t-application-not-installed": "No se detectó la aplicación, instálela para realizar esta operación, haga clic en el botón “Instalar aplicación” de abajo",
  "t-application-waiting-installed": "The device is currently being installed, please wait ..",
  "t-install-application": "Install application",
  "t-reinstall-application": "Reinstall application",
  "t-remote-assistance": "Invite FT Remote Assistance",
  "t-device-needs-app-for-remote-control": "Device needs to install application for remote control",
  "t-checking-app-installation-status": "Checking application installation status...",
  "t-transfer-files": "Transfer files",
  "t-request-sent-device-failed": "Request sent to device failed",
  "t-start-downloading-apps": "START DOWNLOADING APPLICATIONS TASK",
  "t-create-push-task": "Crear tarea de envío",
  "t-from-version": "Desde la versión",
  "t-to-version": "Hasta la versión",
  "t-delta-package": "Parche",
  "t-whole-package": "Completo",
  "t-push-status-apn-sim-state-not-ready": "FAIL, ESTADO DE SIM DE APN NO ESTÁ PREPARADO",
  "t-push-status-apn-slotindex-mistake": "FAIL, ERROR EN INDICE DE RANURA DE APN",
  "t-push-status-apn-numeric-mistake": "FAIL, ERROR NUMÉRICO DE APN",
  "t-push-status-apn-mnc-mistake": "FAIL, ERROR DE MNC DE APN",
  "t-push-status-apn-and-name-not-mistake": "FAIL, APN Y NOMBRE NO COINCIDEN",
  "t-push-status-apn-insert-failed": "FAIL, INSERCIÓN DE APN FALLIDA",
  "t-push-status-task-superseded": "FAIL, REEMPLAZADA POR NUEVA TAREA",
  "t-push-status-revoked-terminal-confirmed": "Revocado (Terminal Confirmado)",
  "t-push-status-reverting": "Revocando",
  "t-push-status-init-firmware-not-supported": "FAIL, FIRMWARE DE INICIALIZACIÓN NO SOPORTADO",
  "t-push-status-upgrade-in-progress": "FAIL, ACTUALIZACIÓN EN PROGRESO",
  "t-push-status-already-target-version": "FAIL, YA ES LA VERSION OBJETIVO",
  "t-push-status-some-tasks-succeeded-others-failed": "FAIL, ALGUNAS TAREAS EXITOSAS, OTRAS FALLARON",
  "t-push-status-insufficient-battery-will-execute-when-charged": "BATERÍA INSUFICIENTE, SE EJECUTARÁ CUANDO SE CARGUE",
  "t-push-status-second-signature-enabled-device-not-bound-to-customer": "FAIL, FIRMA SECUNDARIA HABILITADA, DISPOSITIVO NO VINCULADO AL CLIENTE",
  "server.mpm.device.not.in.customer": "El socio ha habilitado la firma secundaria. Los dispositivos deben estar vinculados a un cliente.",
  "server.mpm.customer.without.signature.application.signed.fail": "El cliente no tiene firma. La firma de la aplicación ha fallado.",
  "t-open-remote-control-model-notes": "Tenga en cuenta",
  "t-open-remote-control-model-notes-1": "Esta operación conllevará un consumo de datos determinado (en escenarios sin transferencia de archivos). A modo de referencia, se estima que se consumirán aproximadamente 7 MB de datos al usar el dispositivo F20 durante 10 minutos.",
  "t-open-remote-control-model-notes-tha": "Esta operación conllevará un consumo de datos determinado.",
  "t-open-remote-control-model-notes-2": "El consumo real de datos está sujeto a factores como el rendimiento del dispositivo, la frecuencia de operación y la resolución de pantalla.",
  "t-open-remote-control-model-waiting": "Solicitud de control remoto ha sido iniciada, por favor espere ..",
  "t-sma-manager": "Gestor SMA",
  "t-select-target-device": "Seleccionar dispositivo de destino",
  "t-filter-device-by-version-group": "Los dispositivos pueden filtrarse por versión/modelo de grupo y se admite la selección por lotes",
  "t-match": "Coincidir",
  "t-match-result": "Resultado de coincidencia",
  "t-system-auto-match-version": "El sistema ha coincidido automáticamente los paquetes diferenciales según la versión actual del dispositivo y la versión de destino ({param})",
  "t-task": "Tarea",
  "t-target": "Destino",
  "t-task-confirmation-submit": "Envío de confirmación de tarea",
  "t-number-of-success-match": "Número de coincidencias exitosas",
  "t-skip-number-of-unpackaged-devices": "Omitir el número de dispositivos no empacados",
  "t-target-os-version": "Versión del sistema operativo de destino",
  "t-current-os-version": "Versión actual del sistema operativo",
  "t-upgrade-package-type": "Tipo de paquete de actualización",
  "t-submitting": "Enviando",
  "t-file-type-not-patch-package": "El archivo cargado no cumple con las reglas del paquete diferencial",
  "t-information": "Información",
  "t-match-diff-package": "Coincidir con paquete diferencial",
  "t-steps": "Pasos",
  "t-websocket-connected": "--- WebSocket Conectado ---",
  "t-start-scraping-logs": "--- Comenzar a extraer registros ---",
  "t-stop-scraping-logs": "--- Detener la extracción de registros ---",
  "t-websocket-connection-error": "--- Error de conexión WebSocket, verifique la consola ---",
  "t-websocket-closed": "--- Conexión WebSocket Cerrada ---",
  "t-logs-cleared": "--- Registros Borrados ---",
  "t-command-issued": "> Comando Emitido: {command}",
  "t-command-failed": "> Comando Fallido: {command}",
  "t-command-exception": "> Excepción del Comando: {message}",
  "t-websocket-not-connected": "> WebSocket No Conectado, no se puede emitir el comando",
  "t-websocket-reconnecting": "> WebSocket No Conectado, intentando reconectar...",
  "t-reconnection-success": "> Reconexión Exitosa",
  "t-reconnection-attempt-failed": "> Intento de Reconexión {i}/5 Fallido",
  "t-reconnection-failed-cannot-issue": "> Reconexión Fallida, no se puede emitir el comando",
  "t-command-sent-wait": "> Comando enviado, por favor espere el resultado...",
  "t-ft-remote-control": "FT RCA",
  "t-adb-debug-logs": "Registros de depuración ADB remotos",
  "t-differential-upgrade-strategy": "Reglas del paquete diferencial",
  "t-diff-package-rule-configuration": "Configuración de reglas del paquete diferencial",
  "t-version-identifier": "Identificador de versión",
  "t-derivative-flag": "Bandera de derivado",
  "t-diff-package-push": "Empuje de paquete diferencial",
  "t-diff-package": "Paquete diferencial",
  "t-full-package": "Paquete completo",
  "t-scheduler-firmware-delta-package": "Actualización de firmware - Parche",
  "t-scheduler-firmware-full-package": "Actualización de firmware - Paquete completo",
  "t-upload-package-tips": "Por ejemplo: Deben subirse archivos de la versión {formVersion} a la versión {toVersion}",
  "t-selected-records": "Registros seleccionados",
  "t-all-records-this-query": "Todos los registros de esta consulta",
  "t-no-corresponding-differential-package": "No hay archivo de paquete correspondiente",
  "t-ota-mgmt": "Gestión OTA",
  "t-grayscale-publishing-strategy": "Estrategia de publicación en escala de grises",
  "t-grayscale-stage": "Etapa de escala de grises",
  "t-suggested-add": "Añadir sugerido",
  "t-model-addable": "Modelos añadibles (Unidades)",
  "t-model-added": "Modelos añadidos (Unidades)",
  "t-release-strategy": "Estrategia de lanzamiento",
  "t-full-release": "Lanzamiento completo",
  "t-grayscale-release": "Lanzamiento en escala de grises",
  "t-auto-upgrade": "Actualización automática",
  "t-scheduled-upgrade": "Actualización programada",
  "t-remind-customer-on-upgrade": "Recordar al cliente sobre la actualización",
  "t-upgrade-task": "Tarea de actualización",
  "t-task-name": "Nombre de la tarea",
  "t-target-version": "Versión de destino",
  "t-release-strategy-type": "Tipo de estrategia de lanzamiento",
  "t-upgrade-mgmt": "Gestión de actualizaciones",
  "t-upgrade-type": "Tipo de actualización",
  "t-upgrade-option": "Opción de actualización",
  "t-current-version": "Versión actual",
  "t-update-log": "Registro de actualizaciones",
  "t-last-request-time": "Última hora de solicitud",
  "t-cancel-upgrade": "Cancelar actualización",
  "t-task-cannot-be-revoked": "La tarea no se puede cancelar",
  "t-device-list": "Lista de dispositivos",
  "t-distribution-map": "Mapa de distribución",
  "t-whole-package-push": "Empuje de paquete completo",
  "t-full-upgrade": "Actualización completa",
  "t-delta-upgrade": "Actualización delta",
  "t-not-equipped-upgrades": "Excluir Dispositivos Con Tareas De Actualización",
  "t-source-to-target": "De origen a destino",
  "t-confirm-change": "Confirmar cambio",
  "t-confirm-change-proxy": "¿Confirmar cambio de configuración de proxy?",
  "t-warning": "Advertencia",
  "t-change-model-warning": "Advertencia de cambio de modelo",
  "t-app-used-quota": "Cuota de aplicación utilizada",
  "t-firmware-used-quota": "Cuota de firmware utilizada",
  "t-switch-to": "Cambiar a",
  "t-app-available-use": "Aplicación disponible",
  "t-firmware-available-use": "Firmware disponible",
  "t-forced-switch":"Cambio forz.",
  "t-start-time-cannot-be-greater-than-end-time": "La hora de inicio no debe ser posterior a la hora de fin",
  "t-allow-download-during-sleep": "Permitir descargas en modo reposo",
  "t-allow-download-during-sleep-desc": "Seleccione esta opción y el terminal permitirá descargar archivos de firmware en modo reposo",
  "t-not-upgrade-task-by-firmware-tips": "Sin tarea de actualización del sistema operativo",
  "t-not-upgrade-task-by-firmware-tips-desc": "Excluye dispositivos con tareas de actualización del sistema operativo existentes.",
  "t-filters-device-by-status-title": "Dispositivos Excluidos por Defecto",
  "t-filters-device-by-status-desc1": "- Ya en la versión de destino",
  "t-filters-device-by-status-desc2": "- Inactivo",
  "t-filters-device-by-status-desc3": "- Fuera de la valla geográfica",
  "t-filters-device-by-status-desc4": "- Fuera del país",
  "t-succeeded": "Éxito",
  "t-failed": "Fallido",
  "t-revoked": "Revocado",
  "t-auto-recognize-version": "Reconocimiento automático de versión",
  "t-revoked-task-tips": "Solo las tareas que han sido creadas pero aún no iniciadas por el terminal pueden ser revocadas (la versión SMA debe ser 200112 o superior).",
  "t-product": "Product",
  "t-ota-error-logs": "Evento De Excepción Del Dispositivo",
  "t-event-type": "Tipo De Evento",
  "t-active-os-upgrade-tasks": "Tareas activas de actualización de firmware (Últimos 12 Meses)",
  "t-file-upload-error-try-again": "El formato del firmware cargado es incorrecto, por favor inténtelo de nuevo",
  "t-update-time": "Tiempo de actualización",
  "t-filter-same-versions": "Excluir Dispositivos De La Versión Objetivo",
  "t-filter-same-versions-desc": "Cuando está marcado, se excluirán los dispositivos que ya están en la versión objetivo.",
  "t-allow-same-version-upgrade": "Permitir Actualización De La Misma Versión",
  "t-allow-same-version-upgrade-desc": "Si selecciona esta opción, el terminal permitirá actualizar a la misma versión de firmware que la versión actual",
  "t-replace-uncompleted-tasks": "Sobrescribir Tarea",
  "t-replace-uncompleted-tasks-desc": "La nueva tarea reemplazará la tarea anterior que no está completada en el dispositivo.",
  "t-time-period-not-allowed-across-days": "El período de tiempo no puede abarcar varios días",
  "t-file-upload-successful": "El archivo {type} correspondiente al dispositivo {device} se ha cargado exitosamente!",
  "t-select-identical-rule": "Ha seleccionado una regla duplicada",
  "t-formversion-toversion-same": "La versión de origen y la versión de destino no pueden ser las mismas",
  "t-please-complete-the-information-for-all-rules": "Por favor complete la información completa de la regla",
  "t-all-day": "Todo el día",
  "t-custom-period": "Período personalizado",
  "t-json-err-check-retry": "Error de formato JSON, por favor verifique el contenido de entrada",
  "t-only-supported-high-version-new": "Se proporciona soporte para la versión SMA 100517 y superior.",
  "t-search_report_name_user": "Nombre del informe、Creado por",
  "t-password-must-be-6-digits": "Por favor ingrese una contraseña de 6 dígitos",
  "t-batch-operation": "Operación por lotes",
  "t-sub-action": "Suboperación",
  "t-batch-application-fail-cause": "Motivodelerrordelaaplicación",
  "t-display-only-devices-without-generated-keys": "Mostrar solo dispositivos sin claves generadas",
  "t-historical-records-have-been-detected": "{count} registros históricos han sido detectados. Si el dispositivo seleccionado ya generó esta Clave, los nuevos datos sobrescribirán automáticamente los registros anteriores.",
  "t-firmware-sma-version-warning": "Nota: Los dispositivos con versiones SMA inferiores a 200117 no soportan esta configuración. El contenido relacionado con firmware será excluido al crear perfiles de terminal.",
  "t-exclude-devices-with-terminal-profile-tasks": "Excluir Dispositivos Con Tareas De Perfil De Terminal",
  "t-encrypt-type": "Tipo de Cifrado",
  "t-auto-select-recommended": "AUTO - Selección Automática (Recomendado)",
  "t-force-ecc": "ECC",
  "t-force-rsa": "RSA",
  "t-tr34": "TR34",
  "t-encrypt-type-hint-auto": "AUTO: Priorizar cifrado ECC, retroceder automáticamente a RSA si el dispositivo no lo soporta",
  "t-encrypt-type-hint-ecc": "ECC: Usar solo cifrado ECC, la inyección falla si el dispositivo no lo soporta",
  "t-encrypt-type-hint-rsa": "RSA: Usar solo cifrado RSA",
  "t-encrypt-type-hint-tr34": "TR34: Usar formato estándar TR34 para inyección de claves",
  "t-tr34-auth-required": "Complete la autenticación mutua antes de seleccionar el formato TR34",
  "t-go-to-mutual-auth": "Ir a Metadatos de Clave Vinculada",
  "t-device-ecc-not-supported": "El dispositivo no soporta cifrado ECC",
  "t-key-capture-device-cert-not-exist": "CERTIFICADO DEL DISPOSITIVO NO EXISTE",
  "t-key-capture-device-not-authenticated": "DISPOSITIVO NO AUTENTICADO",
  "t-key-capture-device-mutual-auth-unbound-key-invalidated": "AUTENTICACIÓN MUTUA DEL DISPOSITIVO NO VINCULADA, CLAVE INVALIDADA",
  "t-key-capture-key-derivation-failed": "FALLO EN LA DERIVACIÓN DE CLAVE",
  "t-root-ca-certificate": "Certificado Root CA",
  "t-sub-ca-certificate": "Certificado Sub CA",
  "t-server-certificate": "Certificado de Servidor",
  "t-import-certificate": "Importar Certificado",
  "t-export-csr": "Exportar CSR",
  "t-generate-csr": "Generar CSR",
  "t-key-size": "Tamaño de clave",
  "t-valid": "Válido",
  "t-expired": "Expirado",
  "t-public-key-algorithm": "Algoritmo de Clave Pública",
  "t-private-key-location": "Ubicación de Clave Privada",
  "t-re-import": "Reimportar",
  "t-rki-root-ca-alert": "El certificado Root CA es emitido por la fábrica FT Safe. La plataforma solo lo almacena para verificación de cadena de certificados y no puede modificarlo.",
  "t-rki-sub-ca-alert": "El certificado Sub CA es emitido por la fábrica FT Safe e importado a la plataforma. Se usa para verificar la cadena de certificados Device Cert durante la autenticación mutua.",
  "t-rki-server-cert-alert": "Server Cert es generado por la plataforma en HSM. El CSR se exporta a la fábrica FT Safe para firmar. La clave privada nunca sale del HSM.",
  "server.cert.root.ca.not.found": "Root CA no encontrado, no se puede verificar Sub CA",
  "server.cert.verify.sub.ca.failed": "La verificación del certificado falló",
  "server.cert.import.failed": "La importación del certificado del servidor falló",
  "server.cert.private.key.not.found": "No se encontró la clave privada, genere primero el CSR",
  "server.cert.private.key.mismatch": "La clave privada no coincide con el certificado del servidor",
  "server.cert.expired": "El certificado ha expirado. Emita de nuevo un certificado válido",
  "server.cert.not.yet.valid": "El certificado aún no es válido. Compruebe la fecha de emisión",
  "server.cert.not.exists": "El certificado del servidor no existe",
  "t-mutual-auth": "Bind Key Metadata",
  "t-initiate-auth": "Bind Key Metadata",
  "t-batch-auth": "Autenticación por Lotes",
  "t-rki-mutual-auth-alert": "Flujo de autenticación mutua: TMS envía comando de autenticación → Dispositivo sube Device Cert → TMS verifica con Sub CA → TMS envía Server Cert → Dispositivo verifica con Sub CA → Autenticación exitosa",
  "t-auth-status": "Estado",
  "t-auth-time": "Tiempo de Vinculación",
  "t-authenticated": "Vinculado",
  "t-unauthenticated": "No Vinculado",
  "t-authenticating": "Vinculando",
  "t-auth-failed": "Error de Vinculación",
  "t-auth-fail-cause": "Motivo del Fracaso",
  "t-not-authenticated": "Pendiente de Vincular",
  "t-unbound": "Pendiente de Generar CSR",
  "t-server-cert-not-exist": "El certificado de servidor del socio no existe. Configúrelo antes de iniciar la vinculación.",
  "t-csr-pending": "CSR Pendiente",
  "t-csr-received": "CSR Recibido",
  "t-download-csr": "Descargar CSR",
  "t-download-success": "Descarga Exitosa",
  "t-csr-content-empty": "El contenido CSR está vacío",
  "t-upload-cert": "Subir Certificado",
  "t-sync-device-cert": "Sincronizar Certificado de Dispositivo",
  "t-sync-device-random-number": "Sincronizar Número Aleatorio del Dispositivo",
  "t-cert-file": "Archivo de Certificado",
  "t-upload-success": "Subida Exitosa",
  "t-server-exception-try-later": "¡Excepción del servidor, inténtelo de nuevo más tarde!",
  "t-gray-release-template": "Plantilla de Liberación Gradual",
  "t-template-name": "Nombre de la Plantilla",
  "t-strategy-type": "Tipo de Estrategia",
  "t-release-mode": "Modo de Liberación",
  "t-batch-config": "Configuración de Etapa",
  "t-auto-promote-threshold": "Umbral de Promoción Automática",
  "t-auto-promote-threshold-required": "El umbral de promoción automática es obligatorio",
  "t-auto-promote-threshold-range": "El umbral de promoción automática debe ser mayor que 0 y no puede superar 100",
  "t-fast-release": "Liberación Rápida",
  "t-standard-release": "Liberación Estándar",
  "t-conservative-release": "Liberación Conservadora",
  "t-by-percentage": "Por Porcentaje",
  "t-by-device-count": "Por Cantidad de Dispositivos",
  "t-template-name-required": "El nombre de la plantilla es obligatorio",
  "t-batch-config-required": "La configuración de lotes es obligatoria",
  "t-enabled-success": "Habilitado exitosamente",
  "t-disabled-success": "Deshabilitado exitosamente",
  "t-enabled-cannot-delete": "No se puede eliminar cuando está habilitado",
  "t-operation-failed": "Operación fallida",
  "t-add-batch": "Agregar Etapa",
  "t-threshold-hint": "Promoción automática a la siguiente etapa cuando la tasa de éxito de actualización ≥ umbral",
  "t-collect-duration": "Duración de recolección de datos de salud",
  "t-collect-count": "Cantidad de recolección de datos de salud",
  "t-collect-duration-required": "La duración de recolección de datos de salud es obligatoria",
  "t-collect-count-required": "La cantidad de recolección de datos de salud es obligatoria",
  "t-times": "veces",
  "t-units": "unidad(es)",
  "t-percentage": "Porcentaje",
  "t-device-count": "Cantidad de Dispositivos",
  "t-custom": "Personalizado",
  "t-must-be-greater": "debe ser mayor que el anterior",
  "t-use-gray-release-template": "Lanzamiento gradual",
  "t-select-template": "Seleccionar plantilla",
  "t-gray-release-allocation-valid": "Los {count} dispositivos seleccionados cumplen el requisito de distribución para {stages} etapas de actualización.",
  "t-gray-release-allocation-insufficient": "Hay {count} dispositivos seleccionados. La cantidad seleccionada debe ser mayor que el total de dispositivos de todas las etapas ({required}); faltan {missing} dispositivos.",
  "t-gray-release-allocation-invalid-template": "Esta plantilla de lanzamiento gradual no puede asignar al menos un dispositivo a cada etapa de actualización.",
  "t-gray-release-task-detail": "Detalle de tarea de lanzamiento gradual",
  "t-gray-task": "Tarea gradual",
  "t-gray-detail": "Ver detalle gradual",
  "t-gray-template-name": "Nombre de la plantilla gradual",
  "t-current-batch": "Lote actual",
  "t-total-progress": "Progreso total",
  "t-health-rate": "Tasa de salud",
  "t-task-status": "Estado de tarea",
  "t-pause": "Pausar",
  "t-resume": "Reanudar",
  "t-force-promote": "Forzar promoción",
  "t-enter-next-stage": "Saltar a la siguiente etapa",
  "t-cancel-task": "Cancelar tarea",
  "t-batch-progress": "Progreso de lotes",
  "t-progress": "Progreso",
  "t-success-rate": "Tasa de éxito",
  "t-threshold": "Umbral",
  "t-no-batch-data": "Sin datos de lote",
  "t-health-evaluation": "Resumen de actualización de dispositivos",
  "t-pass": "Aprobado",
  "t-no-health-data": "Sin datos de salud",
  "t-paused-success": "Tarea pausada exitosamente",
  "t-resume-success": "Tarea reanudada exitosamente",
  "t-force-promote-success": "Promoción forzada exitosa",
  "t-enter-next-stage-success": "Se ha saltado a la siguiente etapa",
  "t-stage": "Etapa",
  "t-upgrade-stage-progress-overview": "Resumen del progreso de las etapas de actualización",
  "t-cancel-success": "Tarea cancelada",
  "t-not-started": "No iniciado",
  "t-in-progress": "En progreso",
  "t-paused": "En pausa",
  "t-completed": "Completado",
  "t-cancelled": "Cancelado",
  "t-terminated": "Terminado",
  "t-auto-promote": "Promoción automática",
  "t-health-evaluated-success": "Evaluación de salud completada",
  "t-health-all-passed": "Todas las verificaciones de salud pasaron",
  "t-health-not-passed": "Verificación de salud fallida",
  "t-health-all-passed-desc": "Todos los indicadores principales cumplen el umbral",
  "t-health-not-passed-desc": "Algunos indicadores principales no cumplieron el umbral",
  "t-card-read-success-rate": "Tasa de éxito de lectura de tarjeta",
  "t-print-status": "Estado de impresión",
  "t-core-health": "Indicadores principales de salud",
  "t-ft-applications": "FT Applications",
  "t-app-name": "Nombre de la aplicación",
  "t-file-path": "Ruta del archivo",
  "t-app-type": "Tipo de aplicación",
  "t-ftrca-desc": "Agente de control remoto",
  "t-fttha-desc": "Agente de salud del terminal",
  "t-apk-parse-result": "Resultado del análisis APK",
  "t-file-not-found": "Archivo no encontrado",
  "server.partner.traffic.quota.config.already.exists": "La configuración de cuota para este partner ya existe"
}
